var mouse_is_inside = false;
let currentVideo;

if (typeof window.Shopify == "undefined") {
    window.Shopify = {};
}

function debounce(fn, wait = 300) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments);
    };
};

Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options["method"] || "post";
    var parameters = options["parameters"] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in parameters) {
        var fields = document.createElement("input");
        fields.setAttribute("type", "hidden");
        fields.setAttribute("name", key);
        fields.setAttribute("value", parameters[key]);
        form.appendChild(fields);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    var countryElement = document.querySelectorAll("#" + country_domid);
    var provinceElement = document.querySelectorAll("#" + province_domid);
    var provinceContainerEl = document.querySelectorAll("#" + options["hideElement"] || "#" + province_domid);

    this.countryEl = countryElement[0];
    this.provinceEl = provinceElement[0];
    this.provinceContainer = provinceContainerEl[0];
    if (countryElement[1]) {
        this.countryEl = countryElement[1];
    }
    if (provinceElement[1]) {
        this.provinceEl = provinceElement[1];
    }
    if (provinceContainerEl[1]) {
        this.provinceContainer = provinceContainerEl[1];
    }

    Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var value = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function() {
        var value = this.provinceEl.getAttribute("data-default");
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function(e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute("data-provinces");
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = "none";
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement("option");
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function(selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function(selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement("option");
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    },
};

if (typeof Shopify === "undefined") { Shopify = {}; }
if (!Shopify.formatMoney) {
    Shopify.formatMoney = function(cents, format) {
        var value = "",
            placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || this.money_format;

        if (typeof cents == "string") {
            cents = cents.replace(".", "");
        }

        function defaultOption(opt, def) {
            return typeof opt == "undefined" ? def : opt;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ",");
            decimal = defaultOption(decimal, ".");

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split("."),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
                cents = parts[1] ? decimal + parts[1] : "";

            return dollars + cents;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
                value = formatWithDelimiters(cents, 2);
                break;
            case "amount_no_decimals":
                value = formatWithDelimiters(cents, 0);
                break;
            case "amount_with_comma_separator":
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                value = formatWithDelimiters(cents, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                value = formatWithDelimiters(cents, 0, " ", " ");
                break;
        }

        return formatString.replace(placeholderRegex, value);
    };
}

var DOMAnimations = {
    slideUp: function(element, duration = 500) {
        return new Promise(function(resolve, reject) {
            element.style.height = element.offsetHeight + "px";
            element.style.transitionProperty = `height, margin, padding`;
            element.style.transitionDuration = duration + "ms";
            element.offsetHeight;
            element.style.overflow = "hidden";
            element.style.height = 0;
            element.style.paddingTop = 0;
            element.style.paddingBottom = 0;
            element.style.marginTop = 0;
            element.style.marginBottom = 0;
            window.setTimeout(function() {
                element.style.display = "none";
                element.style.removeProperty("height");
                element.style.removeProperty("padding-top");
                element.style.removeProperty("padding-bottom");
                element.style.removeProperty("margin-top");
                element.style.removeProperty("margin-bottom");
                element.style.removeProperty("overflow");
                element.style.removeProperty("transition-duration");
                element.style.removeProperty("transition-property");
                resolve(false);
            }, duration);
        });
    },

    slideDown: function(element, duration = 500) {
        return new Promise(function(resolve, reject) {
            element.style.removeProperty("display");
            let display = window.getComputedStyle(element).display;

            if (display === "none") display = "block";

            element.style.display = display;
            let height = element.offsetHeight;
            element.style.overflow = "hidden";
            element.style.height = 0;
            element.style.paddingTop = 0;
            element.style.paddingBottom = 0;
            element.style.marginTop = 0;
            element.style.marginBottom = 0;
            element.offsetHeight;
            element.style.transitionProperty = `height, margin, padding`;
            element.style.transitionDuration = duration + "ms";
            element.style.height = height + "px";
            element.style.removeProperty("padding-top");
            element.style.removeProperty("padding-bottom");
            element.style.removeProperty("margin-top");
            element.style.removeProperty("margin-bottom");
            window.setTimeout(function() {
                element.style.removeProperty("height");
                element.style.removeProperty("overflow");
                element.style.removeProperty("transition-duration");
                element.style.removeProperty("transition-property");
            }, duration);
        });
    },

    slideToggle: function(element, duration = 500) {
        if (window.getComputedStyle(element).display === "none") {
            return this.slideDown(element, duration);
        } else {
            return this.slideUp(element, duration);
        }
    },

    classToggle: function(element, className) {
        if (element.classList.contains(className)) {
            element.classList.remove(className);
        } else {
            element.classList.add(className);
        }
    },
};

if (!Element.prototype.fadeIn) {
    Element.prototype.fadeIn = function() {
        let ms = !isNaN(arguments[0]) ? arguments[0] : 400,
            func =
            typeof arguments[0] === "function" ? arguments[0] : typeof arguments[1] === "function" ? arguments[1] : null;

        this.style.opacity = 0;
        this.style.filter = "alpha(opacity=0)";
        this.style.display = "inline-block";
        this.style.visibility = "visible";

        let $this = this,
            opacity = 0,
            timer = setInterval(function() {
                opacity += 50 / ms;
                if (opacity >= 1) {
                    clearInterval(timer);
                    opacity = 1;

                    if (func) func("done!");
                }
                $this.style.opacity = opacity;
                $this.style.filter = "alpha(opacity=" + opacity * 100 + ")";
            }, 50);
    };
}

if (!Element.prototype.fadeOut) {
    Element.prototype.fadeOut = function() {
        let ms = !isNaN(arguments[0]) ? arguments[0] : 400,
            func =
            typeof arguments[0] === "function" ?
            arguments[0] :
            typeof arguments[1] === "function" ?
            arguments[1] :
            null;

        let $this = this,
            opacity = 1,
            timer = setInterval(function() {
                opacity -= 50 / ms;
                if (opacity <= 0) {
                    clearInterval(timer);
                    opacity = 0;
                    $this.style.display = "none";
                    $this.style.visibility = "hidden";

                    if (func) func("done!");
                }
                $this.style.opacity = opacity;
                $this.style.filter = "alpha(opacity=" + opacity * 100 + ")";
            }, 50);
    };
}

function pad2(number) {
    return (number < 10 ? "0" : "") + number;
}

function screenVisibility(elem) {
    if (elem.length == 0) {
        return;
    }

    var $window = $(window);
    var viewport_top = $window.scrollTop();
    var viewport_height = $window.height();
    var viewport_bottom = viewport_top + viewport_height;
    var $elem = elem;
    var top = $elem.offset().top;
    var height = $elem.height();
    var bottom = top + height;
    return (
        (top >= viewport_top && top < viewport_bottom) ||
        (bottom > viewport_top && bottom <= viewport_bottom) ||
        (height > viewport_height &&
            top <= viewport_top &&
            bottom >= viewport_bottom)
    );
}

function isOnScreen(elem, form) {
    // if the element doesn't exist, abort
    if (elem.length == 0) {
        return;
    }
    var $window = $(window);
    var viewport_top = $window.scrollTop();
    var viewport_height = $window.height();
    var viewport_bottom = viewport_top + viewport_height;
    var $elem = $(elem);
    var top = $elem.offset().top;
    if (!form) {
        if ($(window).width() > 768) {
            top = top + 400;
        }
    }
    var height = $elem.height();
    var bottom = top + height;

    return (
        (top >= viewport_top && top < viewport_bottom) ||
        (bottom > viewport_top && bottom <= viewport_bottom) ||
        (height > viewport_height &&
            top <= viewport_top &&
            bottom >= viewport_bottom)
    );
}

jQuery.fn.scrollTo = function(elem) {
    $(this).scrollTop(
        $(this).scrollTop() - $(this).offset().top + $(elem).offset().top
    );
    return this;
};

function truncate(str, no_words) {
    var length = str.split(" ").length;
    var _value = str.split(" ").splice(0, no_words).join(" ");
    if (length > no_words) {
        _value = _value + "..";
    }
    return _value;
}

function toggleDropdown(id) {
    var x = document.getElementById(id);
    if (x.style.display === "none") {
        x.style.display = "block";
    } else {
        x.style.display = "none";
    }
}

function roundToTwo(num) {
    return +(Math.round(num + "e+2") + "e-2");
}

function listElementsForFocus(wrapper) {
    let elementsList = Array.from(
        wrapper[0].querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
    return elementsList;
}
const focusElementsList = {};

function focusElementsRotation(wrapper) {
    stopFocusElementsRotation();
    focusElementsList.wrapper = wrapper[0];
    let elements = listElementsForFocus(wrapper);
    let first = elements[0];
    let last = elements[elements.length - 1];
    focusElementsList.focusin = (e) => {
        if (e.target !== wrapper[0] && e.target !== last && e.target !== first)
            return;

        document.addEventListener("keydown", focusElementsList.keydown);
    };

    focusElementsList.focusout = function() {
        document.removeEventListener("keydown", focusElementsList.keydown);
    };

    focusElementsList.keydown = function(e) {
        if (e.defaultPrevented) return;
        if (e.code.toUpperCase() !== "TAB") return;
        if (e.target === last && !e.shiftKey) {
            e.preventDefault();
            first.focus();
        }
        if ((e.target === wrapper[0] || e.target === first) && e.shiftKey) {
            e.preventDefault();
            last.focus();
        }
    };

    document.addEventListener("focusout", focusElementsList.focusout);
    document.addEventListener("focusin", focusElementsList.focusin);
}

function stopFocusElementsRotation(expectedWrapper) {
    var expectedElement = expectedWrapper && expectedWrapper[0] ?
        expectedWrapper[0] : expectedWrapper;
    if (
        expectedElement &&
        focusElementsList.wrapper !== expectedElement
    ) {
        return false;
    }
    document.removeEventListener("focusin", focusElementsList.focusin);
    document.removeEventListener("focusout", focusElementsList.focusout);
    document.removeEventListener("keydown", focusElementsList.keydown);
    focusElementsList.wrapper = null;
    return true;
}

function isSharedDrawerFocusSurfaceOpen(drawer) {
    var body = document.body;
    if (
        !drawer ||
        drawer.isConnected === false ||
        !body ||
        !body.classList ||
        !(
            body.classList.contains("side_Drawer_open") ||
            body.classList.contains("yv_side_Drawer_open") ||
            body.classList.contains("minicart-open")
        ) ||
        drawer.hidden === true ||
        (drawer.getAttribute && drawer.getAttribute("aria-hidden") === "true")
    ) {
        return false;
    }
    if (
        typeof window.getComputedStyle === "function"
    ) {
        var drawerStyle = window.getComputedStyle(drawer);
        if (
            drawerStyle &&
            (drawerStyle.display === "none" || drawerStyle.visibility === "hidden")
        ) {
            return false;
        }
    }
    if (
        typeof drawer.getClientRects === "function" &&
        drawer.getClientRects().length === 0
    ) {
        return false;
    }
    if (typeof drawer.getBoundingClientRect === "function") {
        var rect = drawer.getBoundingClientRect();
        var viewportWidth = window.innerWidth ||
            (document.documentElement && document.documentElement.clientWidth) || 0;
        var viewportHeight = window.innerHeight ||
            (document.documentElement && document.documentElement.clientHeight) || 0;
        if (
            rect &&
            ((typeof rect.width === "number" && rect.width <= 0) ||
                (typeof rect.height === "number" && rect.height <= 0) ||
                (viewportWidth > 0 &&
                    typeof rect.right === "number" &&
                    typeof rect.left === "number" &&
                    (rect.right <= 0 || rect.left >= viewportWidth)) ||
                (viewportHeight > 0 &&
                    typeof rect.bottom === "number" &&
                    typeof rect.top === "number" &&
                    (rect.bottom <= 0 || rect.top >= viewportHeight)))
        ) {
            return false;
        }
    }
    return true;
}

function cartDrawerOwnsWrapperOverlay(sharedDrawer) {
    var body = document.body;
    return Boolean(
        isSharedDrawerFocusSurfaceOpen(sharedDrawer) &&
        (sharedDrawer.id === "mini__cart" ||
            sharedDrawer.classList.contains("mini_cart")) &&
        body &&
        body.classList &&
        (body.classList.contains("yv_side_Drawer_open") ||
            body.classList.contains("minicart-open"))
    );
}

function wrapperOverlayIsVisible(overlay) {
    if (!overlay || overlay.isConnected === false || overlay.hidden === true) {
        return false;
    }
    if (overlay.style && overlay.style.display === "none") return false;
    if (typeof window.getComputedStyle === "function") {
        var overlayStyle = window.getComputedStyle(overlay);
        if (
            overlayStyle &&
            (overlayStyle.display === "none" || overlayStyle.visibility === "hidden")
        ) {
            return false;
        }
    }
    if (
        typeof overlay.getClientRects === "function" &&
        overlay.getClientRects().length === 0
    ) {
        return false;
    }
    return true;
}

var upvVariantLifecycle =
    window.UpvanityVariantLifecycle &&
    typeof window.UpvanityVariantLifecycle === "object" ?
    window.UpvanityVariantLifecycle : {};
[
    "bindings",
    "timers",
    "pickupRequests",
    "pickupDrawerBindings",
    "quickViewRequests",
    "quickViewGenerations",
    "similarDrawerRequests",
    "similarDrawerGenerations",
    "sharedDrawerOwners",
    "sharedDrawerGenerations"
].forEach(function(key) {
    var store = upvVariantLifecycle[key];
    if (
        !store ||
        typeof store.get !== "function" ||
        typeof store.set !== "function" ||
        typeof store.has !== "function" ||
        typeof store.delete !== "function"
    ) {
        upvVariantLifecycle[key] = new WeakMap();
    }
});
window.UpvanityVariantLifecycle = upvVariantLifecycle;

function cancelSimilarDrawerRequest(drawer, expectedRequest) {
    if (!drawer) return 0;
    var currentRequest = upvVariantLifecycle.similarDrawerRequests.get(drawer);
    if (expectedRequest && currentRequest !== expectedRequest) {
        return upvVariantLifecycle.similarDrawerGenerations.get(drawer) || 0;
    }
    var generation =
        (upvVariantLifecycle.similarDrawerGenerations.get(drawer) || 0) + 1;
    upvVariantLifecycle.similarDrawerGenerations.set(drawer, generation);
    upvVariantLifecycle.similarDrawerRequests.delete(drawer);
    if (currentRequest) {
        currentRequest.cancelled = true;
        if (
            currentRequest.controller &&
            typeof currentRequest.controller.abort === "function"
        ) {
            try {
                currentRequest.controller.abort();
            } catch (error) {}
        }
        currentRequest.controller = null;
    }
    return generation;
}

function beginSimilarDrawerRequest(drawer, drawerBody, trigger, overlay) {
    if (!drawer || !drawerBody || !trigger) return null;
    var previousRequest = upvVariantLifecycle.similarDrawerRequests.get(drawer);
    var inheritsOverlayClaim = Boolean(
        previousRequest &&
        previousRequest.overlay === overlay &&
        previousRequest.overlayClaimed
    );
    var overlayPreviousInlineDisplay = inheritsOverlayClaim ?
        previousRequest.overlayPreviousInlineDisplay :
        overlay && overlay.style ? overlay.style.display : "";
    var overlayWasVisible = inheritsOverlayClaim ? false :
        wrapperOverlayIsVisible(overlay);
    var generation = cancelSimilarDrawerRequest(drawer);
    var controller = typeof AbortController === "function" ?
        new AbortController() : null;
    var requestState = {
        body: drawerBody,
        cancelled: false,
        controller: controller,
        drawer: drawer,
        generation: generation,
        overlay: overlay || null,
        overlayClaimed: Boolean(
            overlay && (inheritsOverlayClaim || !overlayWasVisible)
        ),
        overlayPreviousInlineDisplay: overlayPreviousInlineDisplay,
        trigger: trigger
    };
    upvVariantLifecycle.similarDrawerRequests.set(drawer, requestState);
    return requestState;
}

function isSimilarDrawerRequestCurrent(requestState) {
    if (!requestState || requestState.cancelled) return false;
    var drawer = requestState.drawer;
    var drawerBody = requestState.body;
    var trigger = requestState.trigger;
    return Boolean(
        drawer &&
        drawerBody &&
        trigger &&
        drawer.isConnected !== false &&
        drawerBody.isConnected !== false &&
        document.body &&
        document.body.classList.contains("similar_Drawer_open") &&
        drawer.querySelector("[data-similar-drawer-body]") === drawerBody &&
        upvVariantLifecycle.similarDrawerRequests.get(drawer) === requestState &&
        upvVariantLifecycle.similarDrawerGenerations.get(drawer) ===
            requestState.generation
    );
}

function cancelSharedDrawerOwnership(drawer, expectedOwnership) {
    if (!drawer) return 0;
    var currentOwnership = upvVariantLifecycle.sharedDrawerOwners.get(drawer);
    if (expectedOwnership && currentOwnership !== expectedOwnership) {
        return upvVariantLifecycle.sharedDrawerGenerations.get(drawer) || 0;
    }
    var generation =
        (upvVariantLifecycle.sharedDrawerGenerations.get(drawer) || 0) + 1;
    upvVariantLifecycle.sharedDrawerGenerations.set(drawer, generation);
    upvVariantLifecycle.sharedDrawerOwners.delete(drawer);
    if (currentOwnership) {
        currentOwnership.cancelled = true;
        var requests = Array.isArray(currentOwnership.requests) ?
            currentOwnership.requests.slice() : [];
        currentOwnership.requests = [];
        requests.forEach(function(request) {
            if (request && typeof request.abort === "function") {
                try {
                    request.abort();
                } catch (error) {}
            }
        });
    }
    return generation;
}

function claimSharedDrawerOwnership(drawer, owner) {
    if (!drawer) return null;
    var generation = cancelSharedDrawerOwnership(drawer);
    var ownership = {
        cancelled: false,
        drawer: drawer,
        generation: generation,
        owner: owner || "unknown",
        requests: []
    };
    upvVariantLifecycle.sharedDrawerOwners.set(drawer, ownership);
    return ownership;
}

function isSharedDrawerOwnershipCurrent(ownership) {
    if (!ownership || !ownership.drawer) return false;
    return (
        upvVariantLifecycle.sharedDrawerOwners.get(ownership.drawer) === ownership &&
        upvVariantLifecycle.sharedDrawerGenerations.get(ownership.drawer) ===
            ownership.generation &&
        !ownership.cancelled &&
        ownership.drawer.isConnected !== false
    );
}

function trackSharedDrawerRequest(ownership, request) {
    if (!ownership || !request) return request;
    if (!isSharedDrawerOwnershipCurrent(ownership)) {
        if (typeof request.abort === "function") {
            try {
                request.abort();
            } catch (error) {}
        }
        return request;
    }
    ownership.requests.push(request);
    if (typeof request.always === "function") {
        request.always(function() {
            var requestIndex = ownership.requests.indexOf(request);
            if (requestIndex > -1) ownership.requests.splice(requestIndex, 1);
        });
    }
    return request;
}

function updateProductVariantMeta(productParent, variant) {
    if (!productParent || !variant) return;
    var productAvailability = productParent.querySelector('[data-product-availability]');
    var productSku = productParent.querySelector('[data-product-sku]');
    if (productAvailability) {
        productAvailability.innerHTML = variant.available ? 'In stock' : 'Out of stock';
    }
    if (productSku) {
        productSku.innerHTML = variant.sku != '' ? variant.sku : '--';
    }
}

function isPrimaryProductVariantContext(productParent, productSection) {
    if (!productParent || !productSection) return false;
    if (window.location.pathname.indexOf('/products/') === -1) return false;
    if (!productParent.closest('#MainContent')) return false;
    if (productParent.closest('#yv_quickView_product, .quick-add-popup')) return false;
    return Boolean(productParent.querySelector('.yv-main-product-detail'));
}

function updateProductVariantHistory(
    productParent,
    productSection,
    variantId,
    transition
) {
    if (!isPrimaryProductVariantContext(productParent, productSection)) return;
    if (
        transition &&
        (
            transition.initialization === true ||
            transition.authoritative !== true
        )
    ) return;
    var productUrl = new URL(window.location.href);
    productUrl.searchParams.set('variant', variantId);
    history.replaceState({}, null, productUrl.pathname + productUrl.search + productUrl.hash);
}

function getProductVariantBasePath(productContainer) {
    var productLink = productContainer && productContainer.querySelector(
        '.yv-product-detail-title a[href*="/products/"]'
    );
    if (productLink) {
        try {
            return new URL(productLink.href, window.location.origin).pathname;
        } catch (error) {}
    }
    return window.location.pathname;
}

var UPV_QUICK_VIEW_REQUEST_DELAY = 125;
var UPV_QUICK_VIEW_REQUEST_TIMEOUT = 10000;

function cancelQuickViewRequest(drawer) {
    if (!drawer) return 0;
    var requestState = upvVariantLifecycle.quickViewRequests.get(drawer);
    var generation = (upvVariantLifecycle.quickViewGenerations.get(drawer) || 0) + 1;
    upvVariantLifecycle.quickViewGenerations.set(drawer, generation);
    upvVariantLifecycle.quickViewRequests.delete(drawer);
    if (requestState) {
        requestState.cancelled = true;
        if (requestState.timer) clearTimeout(requestState.timer);
        if (requestState.xhr && typeof requestState.xhr.abort === "function") {
            try {
                requestState.xhr.abort();
            } catch (error) {}
        }
    }
    return generation;
}

function hideQuickViewLoader() {
    if (typeof window.jQuery === "function") {
        window.jQuery(".Quick_loader").stop(true, true).hide();
        return;
    }
    document.querySelectorAll(".Quick_loader").forEach(function(loader) {
        loader.style.display = "none";
    });
}

function scheduleQuickViewRequest(
    drawer,
    requestUrl,
    onSuccess,
    onFailure,
    drawerOwnership
) {
    if (!drawer || !requestUrl) return null;
    var ownership = drawerOwnership ||
        claimSharedDrawerOwnership(drawer, "quick-view");
    if (!isSharedDrawerOwnershipCurrent(ownership)) return null;
    var generation = cancelQuickViewRequest(drawer);
    var requestState = {
        cancelled: false,
        generation: generation,
        timer: null,
        xhr: null
    };
    upvVariantLifecycle.quickViewRequests.set(drawer, requestState);

    var isCurrentRequest = function() {
        return (
            upvVariantLifecycle.quickViewRequests.get(drawer) === requestState &&
            upvVariantLifecycle.quickViewGenerations.get(drawer) === generation &&
            !requestState.cancelled &&
            isSharedDrawerOwnershipCurrent(ownership) &&
            drawer.isConnected !== false
        );
    };

    requestState.timer = setTimeout(function() {
        requestState.timer = null;
        if (!isCurrentRequest()) {
            if (upvVariantLifecycle.quickViewRequests.get(drawer) === requestState) {
                cancelQuickViewRequest(drawer);
            }
            return;
        }

        var request;
        try {
            request = $.ajax({
                url: requestUrl,
                type: "GET",
                dataType: "html",
                timeout: UPV_QUICK_VIEW_REQUEST_TIMEOUT
            });
        } catch (error) {
            if (isCurrentRequest()) {
                upvVariantLifecycle.quickViewRequests.delete(drawer);
                if (typeof onFailure === "function") onFailure(null, "error", error);
            }
            return;
        }
        requestState.xhr = request;
        request.done(function(data) {
            if (!isCurrentRequest()) return;
            requestState.xhr = null;
            upvVariantLifecycle.quickViewRequests.delete(drawer);
            if (typeof onSuccess === "function") onSuccess(data);
        });
        request.fail(function(xhr, status, error) {
            if (!isCurrentRequest()) return;
            requestState.xhr = null;
            upvVariantLifecycle.quickViewRequests.delete(drawer);
            if (status !== "abort" && typeof onFailure === "function") {
                onFailure(xhr, status, error);
            }
        });
    }, UPV_QUICK_VIEW_REQUEST_DELAY);

    return requestState;
}

function getProductVariantRoot(target) {
    if (!target) return null;
    var guardedCandidate = target;
    while (guardedCandidate) {
        var activeGuard = guardedCandidate.upvVariantPurchaseGuard;
        if (
            activeGuard &&
            activeGuard.active === true &&
            activeGuard.ownerRoot === guardedCandidate
        ) {
            // The product root class is third-party mutable. Keep descendants
            // bound to their nearest original owner during a rehydrate, even
            // if the old root is temporarily nested inside a replacement.
            return guardedCandidate;
        }
        guardedCandidate = guardedCandidate.parentElement || null;
    }
    if (
        target.classList &&
        typeof target.classList.contains == "function" &&
        target.classList.contains("yv_product_content_section")
    ) {
        return target;
    }
    if (typeof target.closest == "function") {
        return target.closest(".yv_product_content_section");
    }
    return null;
}

var upvProductVariantJsonCache =
    typeof WeakMap == "function" ? new WeakMap() : null;
var upvProductVariantPurchaseGuardSequence = 0;

function getProductVariantData(productRoot) {
    var root = getProductVariantRoot(productRoot);
    if (!root || typeof root.querySelector != "function") return null;
    var variantJson = root.querySelector(
        '[type="application/json"][data-name="variant-json"]'
    );
    if (!variantJson) return null;
    var source = String(variantJson.textContent || "");
    var cached = upvProductVariantJsonCache &&
        upvProductVariantJsonCache.get(variantJson);
    if (cached && cached.source == source) return cached.variants;
    var variants = null;
    try {
        var parsed = JSON.parse(source);
        if (Array.isArray(parsed)) variants = parsed;
    } catch (error) {}
    if (upvProductVariantJsonCache) {
        upvProductVariantJsonCache.set(variantJson, {
            source: source,
            variants: variants
        });
    }
    return variants;
}

function getSelectedProductOptionValues(productRoot) {
    var root = getProductVariantRoot(productRoot);
    if (!root || typeof root.querySelectorAll != "function") return [];
    var optionGroups = Array.from(
        root.querySelectorAll(".product-loop-variants")
    );
    if (!optionGroups.length) return [];
    return optionGroups.map(function(optionGroup) {
        if (variantStyle == "dropdown") {
            var select = Array.from(optionGroup.querySelectorAll("select")).find(
                function(candidate) { return candidate; }
            );
            return select ? select.value : undefined;
        }
        var selected = Array.from(optionGroup.querySelectorAll("input")).find(
            function(radio) { return radio.checked; }
        );
        return selected ? selected.value : undefined;
    });
}

function getExactProductVariant(productRoot, options) {
    var root = getProductVariantRoot(productRoot);
    if (!root || !Array.isArray(options) || !options.length) return null;
    if (options.some(function(option) { return option == null; })) return null;
    var variants = getProductVariantData(root);
    if (!Array.isArray(variants)) return null;
    return variants.find(function(variant) {
        return Boolean(
            variant &&
            variant.id != null &&
            Array.isArray(variant.options) &&
            variant.options.length == options.length &&
            variant.options.every(function(option, index) {
                return String(option) == String(options[index]);
            })
        );
    }) || null;
}

function setProductVariantInputState(variantInput, value, disabled) {
    var nextValue = value == null ? "" : String(value);
    var changed =
        String(variantInput.value == null ? "" : variantInput.value) != nextValue;
    try {
        variantInput.value = nextValue;
        variantInput.disabled = Boolean(disabled);
        variantInput.upvVariantInputThemeDisabled = Boolean(disabled);
        if (disabled && typeof variantInput.setAttribute == "function") {
            variantInput.setAttribute("disabled", "disabled");
        } else if (!disabled && typeof variantInput.removeAttribute == "function") {
            variantInput.removeAttribute("disabled");
        }
    } catch (error) {}
    if (changed) {
        try {
            variantInput.dispatchEvent(new Event("change", { bubbles: true }));
        } catch (error) {}
    }
    var authoritative =
        String(variantInput.value == null ? "" : variantInput.value) == nextValue &&
        Boolean(variantInput.disabled) == Boolean(disabled);
    // Respect a synchronous app owner that changed the field, but fail closed:
    // an unresolved ownership conflict must never leave a successful stale ID.
    if (!authoritative) {
        var externallyDisabled =
            !disabled && Boolean(variantInput.disabled);
        try {
            variantInput.disabled = true;
            variantInput.upvVariantInputThemeDisabled = !externallyDisabled;
            if (typeof variantInput.setAttribute == "function") {
                variantInput.setAttribute("disabled", "disabled");
            }
        } catch (error) {}
    }
    return {
        authoritative: authoritative,
        changed: changed
    };
}

function getProductVariantPreGuardLockLedger() {
    if (
        typeof window == "undefined" ||
        !window.upvVariantPreGuardLockLedger
    ) return null;
    return window.upvVariantPreGuardLockLedger;
}

function beginProductVariantPreGuardCapture(scope) {
    var ledger = getProductVariantPreGuardLockLedger();
    if (!ledger || typeof ledger.begin != "function" || !scope) return null;
    try {
        return ledger.begin(scope);
    } catch (error) {
        return null;
    }
}

function finishProductVariantPreGuardCapture(capture) {
    if (!capture || typeof capture.finish != "function") return;
    try {
        capture.finish();
    } catch (error) {}
}

function sealInitialProductVariantPreGuardCapture() {
    var ledger = getProductVariantPreGuardLockLedger();
    if (!ledger || typeof ledger.seal != "function") return;
    try {
        ledger.seal();
    } catch (error) {}
}

function consumeProductVariantPreGuardExternalLock(element) {
    var ledger = getProductVariantPreGuardLockLedger();
    if (!ledger || typeof ledger.take != "function" || !element) {
        return false;
    }
    try {
        return ledger.take(element) === true;
    } catch (error) {
        return true;
    }
}

function consumeProductVariantInitialThemeLock(element, expectedReason) {
    if (!element || typeof element.getAttribute != "function") return false;
    var reason = element.getAttribute("data-upv-initial-theme-lock");
    if (!reason) return false;
    var externallyClaimed = consumeProductVariantPreGuardExternalLock(element);
    if (typeof element.removeAttribute == "function") {
        element.removeAttribute("data-upv-initial-theme-lock");
    }
    return Boolean(
        expectedReason &&
        ["identity", "terms", "unavailable"].indexOf(reason) > -1 &&
        !externallyClaimed
    );
}

function getProductVariantInitialThemeLockReason(productRoot) {
    var root = getProductVariantRoot(productRoot);
    if (!root) return null;
    var live = getProductVariantGuardLiveTargets(root);
    var markedState = live.states.find(function(state) {
        if (
            !state.element ||
            typeof state.element.getAttribute != "function"
        ) return false;
        var reason = state.element.getAttribute(
            "data-upv-initial-theme-lock"
        );
        return ["identity", "terms", "unavailable"].indexOf(reason) > -1;
    });
    return markedState ? markedState.element.getAttribute(
        "data-upv-initial-theme-lock"
    ) : null;
}

function initializeProductVariantPurchaseState(productRoot) {
    var root = getProductVariantRoot(productRoot);
    if (!root) return false;
    if (typeof root.upvVariantThemePurchaseBlocked == "boolean") {
        return root.upvVariantThemePurchaseBlocked;
    }
    var variantInput = typeof root.querySelector == "function" &&
        root.querySelector('[name="id"]');
    if (
        variantInput &&
        variantInput.disabled &&
        variantInput.upvVariantInputThemeDisabled == null
    ) {
        // Only an explicitly marked server-rendered identity lock belongs to
        // the theme. A pre-guard app write is retained as external ownership.
        if (
            consumeProductVariantInitialThemeLock(
                variantInput,
                "identity"
            )
        ) {
            variantInput.upvVariantInputThemeDisabled = true;
        }
    }
    var variants = getProductVariantData(root);
    var currentVariant = Array.isArray(variants) && variantInput ?
        variants.find(function(variant) {
            return variant && String(variant.id) == String(variantInput.value);
        }) : null;
    var termsWrapper = typeof root.querySelector == "function" &&
        root.querySelector("[data-terms-conditions-wrapper]");
    var termsInput = termsWrapper &&
        typeof termsWrapper.querySelector == "function" &&
        termsWrapper.querySelector('[name="terms_conditions"]');
    var currentBlockingReason =
        currentVariant && currentVariant.available !== true ?
        "unavailable" :
        (termsWrapper && (!termsInput || !termsInput.checked) ?
            "terms" : null);
    var initialThemeLockReason =
        getProductVariantInitialThemeLockReason(root);
    var restoredAcceptedTerms = Boolean(
        termsWrapper &&
        termsInput &&
        termsInput.checked &&
        initialThemeLockReason == "terms"
    );
    if (restoredAcceptedTerms) {
        root.upvVariantInitialTermsAccepted = true;
    } else {
        delete root.upvVariantInitialTermsAccepted;
    }
    if (
        initialThemeLockReason &&
        initialThemeLockReason != currentBlockingReason
    ) {
        root.upvVariantInitialStateNeedsReconciliation = true;
    } else {
        delete root.upvVariantInitialStateNeedsReconciliation;
    }
    root.upvVariantInitialThemeLockReason =
        currentBlockingReason || initialThemeLockReason;
    root.upvVariantThemePurchaseBlocked = Boolean(
        root.upvVariantInitialThemeLockReason
    );
    return root.upvVariantThemePurchaseBlocked;
}

function getProductVariantGuardTargetState(guard, element) {
    if (!guard || !element || !Array.isArray(guard.targetStates)) return null;
    return guard.targetStates.find(function(state) {
        return state.element === element;
    }) || null;
}

function readProductVariantGuardTargetDisabled(state) {
    if (!state || !state.element) return false;
    if (state.type == "class") {
        return Boolean(
            state.element.classList &&
            typeof state.element.classList.contains == "function" &&
            state.element.classList.contains("disabled")
        );
    }
    return Boolean(
        state.element.disabled ||
        (
            typeof state.element.hasAttribute == "function" &&
            state.element.hasAttribute("disabled")
        )
    );
}

function productVariantGuardOwnsTarget(guard, state) {
    return Boolean(
        guard &&
        guard.token &&
        state &&
        state.element &&
        typeof state.element.getAttribute == "function" &&
        state.element.getAttribute("data-upv-variant-guard-owner") ==
            guard.token
    );
}

function markProductVariantGuardTarget(guard, state) {
    if (
        !guard ||
        !state ||
        state.wasDisabled === true ||
        state.externalDisabled === true ||
        !state.element ||
        typeof state.element.setAttribute != "function"
    ) return;
    if (
        typeof state.element.getAttribute == "function" &&
        state.element.getAttribute("data-upv-variant-guard-owner") ==
            guard.token
    ) return;
    state.element.setAttribute(
        "data-upv-variant-guard-owner",
        guard.token
    );
}

function clearProductVariantGuardTargetMarker(guard, state) {
    if (
        productVariantGuardOwnsTarget(guard, state) &&
        typeof state.element.removeAttribute == "function"
    ) {
        state.element.removeAttribute("data-upv-variant-guard-owner");
    }
}

function writeProductVariantGuardTargetDisabled(state, guard) {
    if (!state || !state.element) return;
    markProductVariantGuardTarget(guard, state);
    if (readProductVariantGuardTargetDisabled(state)) return;
    if (
        state.type == "class" &&
        state.element.classList &&
        typeof state.element.classList.add == "function"
    ) {
        state.element.classList.add("disabled");
    } else if (
        state.type == "attribute" &&
        typeof state.element.setAttribute == "function"
    ) {
        state.element.setAttribute("disabled", true);
    }
}

function getProductVariantGuardMatches(scope, selector) {
    if (!scope) return [];
    var matches = [];
    if (typeof scope.querySelectorAll == "function") {
        try {
            matches = Array.from(scope.querySelectorAll(selector));
        } catch (error) {
            matches = [];
        }
    }
    if (!matches.length && typeof scope.querySelector == "function") {
        var firstMatch = scope.querySelector(selector);
        if (firstMatch) matches.push(firstMatch);
    }
    return matches.filter(Boolean);
}

function productVariantGuardStickyBelongsToRoot(root, section, sticky) {
    if (!root || !sticky) return false;
    if (
        section &&
        typeof section.contains == "function" &&
        !section.contains(sticky)
    ) {
        return false;
    }
    var productForms = getProductVariantGuardMatches(
        root,
        'form[action*="/cart/add"]'
    );
    if (sticky.form) {
        return productForms.indexOf(sticky.form) > -1;
    }
    var formId = typeof sticky.getAttribute == "function" &&
        sticky.getAttribute("form");
    if (formId) {
        return productForms.some(function(form) {
            return form &&
                typeof form.getAttribute == "function" &&
                form.getAttribute("id") == formId;
        });
    }
    var productRoots = getProductVariantGuardMatches(
        section,
        ".yv_product_content_section"
    );
    if (productRoots.length) {
        return productRoots.length == 1 && productRoots[0] === root;
    }
    // Compatibility fallback for legacy/test hosts without a searchable
    // section. A real DOM section exposes contains/querySelectorAll and must
    // prove single-product ownership before an unassociated Sticky is claimed.
    return Boolean(
        !section ||
        typeof section.querySelectorAll != "function" ||
        typeof section.contains != "function"
    );
}

function getProductVariantGuardLiveTargets(productRoot) {
    var root = getProductVariantRoot(productRoot);
    if (!root || typeof root.querySelector != "function") {
        return { section: null, states: [] };
    }
    var section = typeof root.closest == "function" &&
        root.closest(".shopify-section");
    var states = [];
    getProductVariantGuardMatches(root, ".Sd_addProduct")
        .forEach(function(element) {
            states.push({
                element: element,
                role: "add",
                type: "attribute"
            });
        });
    getProductVariantGuardMatches(root, "[data-button-wrapper]")
        .forEach(function(element) {
            states.push({
                element: element,
                role: "wrapper",
                type: "class"
            });
        });
    getProductVariantGuardMatches(section, ".Sd_addProductSticky")
        .filter(function(element) {
            return productVariantGuardStickyBelongsToRoot(
                root,
                section,
                element
            );
        })
        .forEach(function(element) {
            states.push({
                element: element,
                role: "sticky",
                type: "attribute"
            });
        });
    return {
        section: section || null,
        states: states.filter(function(state, index, targetStates) {
            return Boolean(state.element) &&
                targetStates.findIndex(function(candidate) {
                    return candidate.element === state.element;
                }) == index;
        })
    };
}

function observeProductVariantGuardTargets(guard) {
    if (!guard || !guard.observer) return;
    if (typeof guard.observer.disconnect == "function") {
        guard.observer.disconnect();
    }
    guard.targetStates.forEach(function(state) {
        if (
            !state.element ||
            typeof guard.observer.observe != "function"
        ) {
            return;
        }
        guard.observer.observe(state.element, {
            attributeFilter: [state.type == "class" ? "class" : "disabled"],
            attributeOldValue: true,
            attributes: true
        });
    });
}

function releaseRetiredProductVariantGuardTarget(guard, state) {
    if (!guard || !state || !state.element) return;
    if (productVariantGuardOwnsTarget(guard, state)) {
        if (
            state.wasDisabled !== true &&
            state.externalDisabled !== true
        ) {
            if (
                state.type == "class" &&
                state.element.classList &&
                typeof state.element.classList.remove == "function"
            ) {
                state.element.classList.remove("disabled");
            } else if (
                state.type == "attribute" &&
                typeof state.element.removeAttribute == "function"
            ) {
                state.element.removeAttribute("disabled");
            }
        }
        clearProductVariantGuardTargetMarker(guard, state);
    }
}

function pruneRetiredProductVariantGuardTargets(guard, root, section) {
    if (!guard || !Array.isArray(guard.targetStates)) return;
    for (var index = guard.targetStates.length - 1; index >= 0; index--) {
        var state = guard.targetStates[index];
        if (!state || state.active === true) continue;
        var element = state.element;
        var disconnected = Boolean(
            element &&
            typeof element.isConnected == "boolean" &&
            element.isConnected === false
        );
        var outsideScope = false;
        if (element && state.role == "sticky") {
            outsideScope = !productVariantGuardStickyBelongsToRoot(
                root,
                section,
                element
            );
        } else if (
            element &&
            root &&
            typeof root.contains == "function"
        ) {
            outsideScope = !root.contains(element);
        } else if (
            element &&
            section &&
            typeof section.contains == "function"
        ) {
            outsideScope = !section.contains(element);
        }
        // Keep ambiguous or still-connected duplicate controls fail-closed.
        // Only a target proven detached from this product can stop being held
        // by the active guard. Theme-owned state is released; app-owned state
        // is deliberately left untouched before the strong reference is cut.
        if (!disconnected && !outsideScope) continue;
        releaseRetiredProductVariantGuardTarget(guard, state);
        state.element = null;
        guard.targetStates.splice(index, 1);
    }
}

function observeProductVariantGuardStructure(productRoot, guard, section) {
    if (!guard || !guard.structureObserver) return;
    var root = getProductVariantRoot(productRoot);
    var scope = section || root;
    if (!scope || guard.structureScope === scope) return;
    if (typeof guard.structureObserver.disconnect == "function") {
        guard.structureObserver.disconnect();
    }
    guard.structureScope = scope;
    guard.structureObserver.observe(scope, {
        attributeFilter: ["class", "data-button-wrapper", "form"],
        attributeOldValue: true,
        attributes: true,
        childList: true,
        subtree: true
    });
}

function productVariantGuardNodeAffectsStructure(node, guard, root) {
    if (!node) return false;
    if (node === root) return true;
    if (
        guard &&
        Array.isArray(guard.targetStates) &&
        guard.targetStates.some(function(state) {
            return state && state.element === node;
        })
    ) return true;
    if (node.nodeType != null && node.nodeType != 1) return false;
    var selector =
        '.Sd_addProduct, .Sd_addProductSticky, [data-button-wrapper], ' +
        'form[action*="/cart/add"], .yv_product_content_section';
    try {
        if (typeof node.matches == "function" && node.matches(selector)) {
            return true;
        }
        if (
            typeof node.querySelector == "function" &&
            node.querySelector(selector)
        ) return true;
    } catch (error) {
        return true;
    }
    return false;
}

function productVariantGuardStructureMutationNeedsRefresh(
    record,
    guard,
    root
) {
    if (!record) return false;
    if (record.type == "childList") {
        if (!record.addedNodes && !record.removedNodes) return true;
        return Array.from(record.addedNodes || [])
            .concat(Array.from(record.removedNodes || []))
            .some(function(node) {
                return productVariantGuardNodeAffectsStructure(
                    node,
                    guard,
                    root
                );
            });
    }
    if (record.type != "attributes") return false;
    if (
        record.attributeName == "data-button-wrapper" ||
        record.attributeName == "form"
    ) return true;
    if (record.attributeName != "class") return false;
    var currentClasses = record.target &&
        typeof record.target.getAttribute == "function" ?
        record.target.getAttribute("class") : "";
    var classTokens = (
        String(record.oldValue || "") + " " + String(currentClasses || "")
    ).split(/\s+/);
    return [
        "Sd_addProduct",
        "Sd_addProductSticky",
        "yv_product_content_section"
    ].some(function(token) {
        return classTokens.indexOf(token) > -1;
    });
}

function refreshProductVariantGuardTargets(productRoot, guard, options) {
    var root = getProductVariantRoot(productRoot);
    if (
        !root ||
        !guard ||
        guard.active !== true ||
        root.upvVariantPurchaseGuard !== guard
    ) return null;
    collectProductVariantGuardMutations(guard);
    var live = getProductVariantGuardLiveTargets(root);
    guard.targetStates.forEach(function(state) {
        state.active = false;
    });
    live.states.forEach(function(descriptor) {
        var state = guard.targetStates.find(function(candidate) {
            return candidate.element === descriptor.element;
        });
        if (state && state.type != descriptor.type) {
            // A third party may repurpose the same connected element from a
            // wrapper into an Add control (or the reverse). Retire the old
            // lock mechanism before creating the new one so a single element
            // can never carry two ownership states.
            releaseRetiredProductVariantGuardTarget(guard, state);
            state.element = null;
            guard.targetStates.splice(
                guard.targetStates.indexOf(state),
                1
            );
            state = null;
        }
        if (!state) {
            var initiallyDisabled =
                readProductVariantGuardTargetDisabled(descriptor);
            var inheritedThemeLock =
                productVariantGuardOwnsTarget(guard, descriptor);
            var ownsInitialThemeLock =
                consumeProductVariantInitialThemeLock(
                    descriptor.element,
                    (
                        options &&
                        options.initial === true &&
                        options.themePurchaseWasBlocked === true ?
                        options.initialThemeLockReason : null
                    )
                );
            state = {
                active: true,
                element: descriptor.element,
                externalDisabled: null,
                role: descriptor.role,
                type: descriptor.type,
                wasDisabled: Boolean(
                    initiallyDisabled &&
                    !inheritedThemeLock &&
                    !ownsInitialThemeLock
                )
            };
            guard.targetStates.push(state);
        }
        state.role = descriptor.role;
        state.active = true;
    });
    pruneRetiredProductVariantGuardTargets(
        guard,
        root,
        live.section
    );
    observeProductVariantGuardTargets(guard);
    observeProductVariantGuardStructure(root, guard, live.section);
    if (options && options.applyThemeLock === true) {
        guard.targetStates.forEach(function(state) {
            // Detached/out-of-scope targets have already been pruned. Any
            // remaining inactive target is still connected inside this
            // product scope and must stay fail-closed while selectors churn.
            writeProductVariantGuardTargetDisabled(state, guard);
        });
        discardProductVariantGuardOwnMutations(guard);
    }
    return live;
}

function recordProductVariantGuardMutations(guard, records) {
    if (!guard || guard.active !== true || !records) return;
    var mutationRecords = Array.from(records);
    var classTransitions =
        getProductVariantClassMutationTransitions(mutationRecords);
    mutationRecords.forEach(function(record, recordIndex) {
        var state = getProductVariantGuardTargetState(guard, record.target);
        if (state) {
            var nextDisabled =
                readProductVariantGuardTargetDisabled(state);
            if (state.type == "class") {
                var transition = classTransitions[recordIndex] || {
                    after: typeof state.element.getAttribute == "function" ?
                        String(state.element.getAttribute("class") || "") : "",
                    before: String(record.oldValue || "")
                };
                var previousClasses = transition.before
                    .split(/\s+/)
                    .filter(Boolean);
                var nextClasses = transition.after
                    .split(/\s+/)
                    .filter(Boolean);
                var previouslyDisabled =
                    previousClasses.indexOf("disabled") > -1;
                nextDisabled = nextClasses.indexOf("disabled") > -1;
                if (previouslyDisabled == nextDisabled) {
                    if (
                        nextDisabled !== true ||
                        transition.before != transition.after
                    ) return;
                    // Setting the exact same disabled class value is still an
                    // observable third-party ownership claim. By contrast,
                    // unrelated class additions do not inherit this lock.
                }
            }
            // A pre-existing app lock is not permanent ownership. If the app
            // explicitly releases it while this guard is active, the theme
            // may re-apply only its temporary lock and must release that lock
            // when the variant transaction settles.
            if (nextDisabled === false) {
                state.wasDisabled = false;
            }
            state.externalDisabled = nextDisabled;
            if (nextDisabled === true) {
                clearProductVariantGuardTargetMarker(guard, state);
            }
        }
    });
}

function collectProductVariantGuardMutations(guard) {
    if (
        guard &&
        guard.observer &&
        typeof guard.observer.takeRecords == "function"
    ) {
        recordProductVariantGuardMutations(
            guard,
            guard.observer.takeRecords()
        );
    }
}

function discardProductVariantGuardOwnMutations(guard) {
    if (
        guard &&
        guard.observer &&
        typeof guard.observer.takeRecords == "function"
    ) {
        guard.observer.takeRecords();
    }
}

function getProductVariantClassMutationTransitions(records) {
    var nextOldValueByTarget = new WeakMap();
    var transitions = new Array(records.length);
    for (var index = records.length - 1; index >= 0; index--) {
        var record = records[index];
        var target = record && record.target;
        if (!target || record.attributeName != "class") continue;
        var afterValue = nextOldValueByTarget.has(target) ?
            nextOldValueByTarget.get(target) :
            (typeof target.getAttribute == "function" ?
                target.getAttribute("class") : "");
        transitions[index] = {
            after: String(afterValue || ""),
            before: String(record.oldValue || "")
        };
        nextOldValueByTarget.set(target, record.oldValue);
    }
    return transitions;
}

function blockImmediateProductPurchase(productRoot) {
    var root = getProductVariantRoot(productRoot);
    if (!root || typeof root.querySelector != "function") return;
    var themePurchaseWasBlocked =
        initializeProductVariantPurchaseState(root);
    var initialThemeLockReason =
        root.upvVariantInitialThemeLockReason || null;
    if (!root.upvVariantPurchaseGuard) {
        var guard = {
            active: true,
            observer: null,
            ownerRoot: root,
            structureObserver: null,
            structureScope: null,
            targetStates: [],
            token: "upv-variant-guard-" +
                String(++upvProductVariantPurchaseGuardSequence)
        };
        root.upvVariantPurchaseGuard = guard;
        if (typeof MutationObserver == "function") {
            guard.observer = new MutationObserver(function(records) {
                if (
                    guard.active !== true ||
                    root.upvVariantPurchaseGuard !== guard
                ) return;
                recordProductVariantGuardMutations(guard, records);
                if (
                    guard.active !== true ||
                    root.upvVariantPurchaseGuard !== guard
                ) return;
                guard.targetStates.forEach(function(state) {
                    if (state.externalDisabled === false) {
                        writeProductVariantGuardTargetDisabled(state, guard);
                    }
                });
                discardProductVariantGuardOwnMutations(guard);
            });
            guard.structureObserver = new MutationObserver(function(records) {
                if (
                    guard.active !== true ||
                    root.upvVariantPurchaseGuard !== guard
                ) return;
                if (
                    typeof root.isConnected == "boolean" &&
                    root.isConnected === false
                ) {
                    restoreImmediateProductPurchase(root, true);
                    return;
                }
                if (!Array.from(records || []).some(function(record) {
                    return productVariantGuardStructureMutationNeedsRefresh(
                        record,
                        guard,
                        root
                    );
                })) return;
                refreshProductVariantGuardTargets(root, guard, {
                    applyThemeLock: true
                });
            });
        }
        refreshProductVariantGuardTargets(root, guard, {
            applyThemeLock: true,
            initial: true,
            initialThemeLockReason: initialThemeLockReason,
            themePurchaseWasBlocked: themePurchaseWasBlocked
        });
    } else {
        refreshProductVariantGuardTargets(
            root,
            root.upvVariantPurchaseGuard,
            { applyThemeLock: true }
        );
    }
    delete root.upvVariantInitialThemeLockReason;
    root.upvVariantThemePurchaseBlocked = true;
}

function restoreImmediateProductPurchase(productRoot, allowPurchase) {
    var root = getProductVariantRoot(productRoot);
    if (!root) return false;
    var guard = root.upvVariantPurchaseGuard;
    if (!allowPurchase) return Boolean(guard);
    if (guard) {
        refreshProductVariantGuardTargets(root, guard, {
            applyThemeLock: false
        });
    }
    collectProductVariantGuardMutations(guard);
    if (guard) guard.active = false;
    if (
        guard &&
        guard.observer &&
        typeof guard.observer.disconnect == "function"
    ) {
        guard.observer.disconnect();
    }
    if (
        guard &&
        guard.structureObserver &&
        typeof guard.structureObserver.disconnect == "function"
    ) {
        guard.structureObserver.disconnect();
    }
    root.upvVariantPurchaseGuard = null;
    root.upvVariantThemePurchaseBlocked = false;
    delete root.upvVariantInitialStateNeedsReconciliation;
    delete root.upvVariantInitialTermsAccepted;
    delete root.upvVariantInitialThemeLockReason;
    if (!guard) return false;
    var externalButtonLock = guard.targetStates.some(function(state) {
        return Boolean(
            state.active === true &&
            state.type == "attribute" &&
            (state.wasDisabled || state.externalDisabled === true)
        );
    });
    guard.targetStates.forEach(function(state) {
        var preserveDisabled =
            state.wasDisabled ||
            state.externalDisabled === true ||
            (
                state.active === true &&
                state.type == "class" &&
                externalButtonLock
            );
        if (!preserveDisabled) {
            if (
                state.type == "class" &&
                state.element.classList &&
                typeof state.element.classList.remove == "function"
            ) {
                state.element.classList.remove("disabled");
            } else if (
                state.type == "attribute" &&
                typeof state.element.removeAttribute == "function"
            ) {
                state.element.removeAttribute("disabled");
            }
        }
        clearProductVariantGuardTargetMarker(guard, state);
    });
    guard.targetStates.length = 0;
    guard.observer = null;
    guard.ownerRoot = null;
    guard.structureObserver = null;
    guard.structureScope = null;
    return true;
}

function discardProductVariantTransition(productRoot) {
    var root = getProductVariantRoot(productRoot);
    if (!root) return;
    completeProductSellingPlanTransition(root);
    restoreImmediateProductPurchase(root, true);
    var variantInput = typeof root.querySelector == "function" &&
        root.querySelector('[name="id"]');
    if (
        variantInput &&
        variantInput.disabled &&
        variantInput.upvVariantInputThemeDisabled === true
    ) {
        setProductVariantInputState(variantInput, variantInput.value, false);
    }
    delete root.upvVariantThemePurchaseBlocked;
    root.upvVariantTransactionError = false;
}

function showProductVariantUpdateError(productRoot) {
    var root = getProductVariantRoot(productRoot);
    if (!root || typeof root.querySelector != "function") return;
    var errorElement = root.querySelector(".productErrors");
    if (!errorElement) return;
    errorElement.textContent =
        (typeof unavailableText == "string" && unavailableText) ||
        ((typeof errorLabel == "string" && errorLabel) || "");
    if (errorElement.style) errorElement.style.display = "";
}

function beginProductSellingPlanTransition(productRoot) {
    var root = getProductVariantRoot(productRoot);
    if (!root || typeof root.querySelector != "function") return false;
    var sellingPlanInput = root.querySelector('[name="selling_plan"]');
    var sellingPlanContainer = root.querySelector(
        "[data-selling-plan-container]"
    );
    // The template emits a hidden selling_plan input even when this product has
    // no plans. Only a real plan UI needs a guarded reconstruction window.
    if (!sellingPlanInput || !sellingPlanContainer) return false;
    sellingPlanInput.value = "";
    root.upvSellingPlanVariantPending = true;
    if (
        sellingPlanContainer &&
        typeof sellingPlanContainer.setAttribute == "function"
    ) {
        sellingPlanContainer.setAttribute("aria-busy", "true");
        sellingPlanContainer.setAttribute("inert", "");
    }
    return true;
}

function completeProductSellingPlanTransition(productRoot, variantId) {
    var root = getProductVariantRoot(productRoot);
    if (!root) return;
    if (variantId != null) root.upvSettledVariantId = String(variantId);
    root.upvSellingPlanVariantPending = false;
    var sellingPlanContainer = typeof root.querySelector == "function" &&
        root.querySelector("[data-selling-plan-container]");
    if (
        sellingPlanContainer &&
        typeof sellingPlanContainer.removeAttribute == "function"
    ) {
        sellingPlanContainer.removeAttribute("aria-busy");
        sellingPlanContainer.removeAttribute("inert");
    }
}

function isProductSellingPlanSelectionValid(productRoot, variant) {
    var root = getProductVariantRoot(productRoot);
    if (!root || typeof root.querySelector != "function") return true;
    var sellingPlanInput = root.querySelector('[name="selling_plan"]');
    var sellingPlanId = sellingPlanInput &&
        String(sellingPlanInput.value || "");
    if (!sellingPlanId) return true;
    var sellingPlans = variant && variant.selling_plans;
    return Boolean(
        sellingPlans &&
        Object.prototype.hasOwnProperty.call(
            sellingPlans,
            "plan_" + sellingPlanId
        )
    );
}

function settleDelayedProductVariantIdentity(productRoot, variant) {
    var root = getProductVariantRoot(productRoot);
    var variantInput = root && typeof root.querySelector == "function" &&
        root.querySelector('[name="id"]');
    if (!root || !variant || !variantInput) {
        return {
            authoritative: false,
            changed: false,
            input: variantInput || null
        };
    }
    if (
        variantInput.disabled &&
        variantInput.upvVariantInputThemeDisabled !== true
    ) {
        return {
            authoritative: false,
            changed: false,
            externalLocked: true,
            input: variantInput
        };
    }
    var inputState = setProductVariantInputState(
        variantInput,
        variant.id,
        root.upvVariantTransactionError === true
    );
    inputState.input = variantInput;
    return inputState;
}

function inspectProductVariantSelection(productRoot, variantInput) {
    var root = getProductVariantRoot(productRoot);
    if (!root || !variantInput) return null;
    var inputId = String(
        variantInput.value == null ? "" : variantInput.value
    );
    var inputDisabled = Boolean(variantInput.disabled);
    var transactionFailed = root.upvVariantTransactionError === true;
    var pendingSellingPlan = root.upvSellingPlanVariantPending === true;
    var options = getSelectedProductOptionValues(root);
    if (!options.length) {
        var variants = getProductVariantData(root);
        var variantDataAvailable = Array.isArray(variants);
        var currentVariant = variantDataAvailable ?
            variants.find(function(variant) {
                return variant && String(variant.id) == inputId;
            }) : null;
        var available = currentVariant ?
            currentVariant.available === true : null;
        var sellingPlanValid = isProductSellingPlanSelectionValid(
            root,
            currentVariant
        );
        var identityMismatch = Boolean(
            inputId && variantDataAvailable && !currentVariant
        );
        var resolved = Boolean(inputId && currentVariant);
        var authoritative = Boolean(
            resolved &&
            !inputDisabled &&
            !transactionFailed &&
            !pendingSellingPlan
        );
        return {
            applicable: false,
            authoritative: authoritative,
            available: available,
            changed: false,
            id: inputId,
            identityMismatch: identityMismatch,
            input: variantInput,
            inputDisabled: inputDisabled,
            pendingSellingPlan: pendingSellingPlan,
            resolved: resolved,
            root: root,
            sellingPlanValid: sellingPlanValid,
            status: transactionFailed ?
                "transaction-error" :
                (pendingSellingPlan ?
                "pending-selling-plan" :
                (inputDisabled ?
                "external-lock" :
                (identityMismatch ?
                "conflict" :
                (!resolved ?
                "unresolved" :
                (available === false ?
                "unavailable" :
                (sellingPlanValid ?
                "not-applicable" : "invalid-selling-plan")))))),
            transactionFailed: transactionFailed,
            variant: currentVariant || null,
            variantDataAvailable: variantDataAvailable
        };
    }
    var variant = getExactProductVariant(root, options);
    if (!variant) {
        return {
            applicable: true,
            authoritative: false,
            available: false,
            changed: false,
            id: null,
            identityMismatch: true,
            input: variantInput,
            inputDisabled: inputDisabled,
            pendingSellingPlan: pendingSellingPlan,
            resolved: false,
            root: root,
            sellingPlanValid: false,
            status: transactionFailed ? "transaction-error" : "unresolved",
            transactionFailed: transactionFailed,
            variant: null
        };
    }
    var variantId = String(variant.id);
    var identityMismatch = inputId != variantId;
    var sellingPlanInput = typeof root.querySelector == "function" &&
        root.querySelector('[name="selling_plan"]');
    var sellingPlanContainer = typeof root.querySelector == "function" &&
        root.querySelector("[data-selling-plan-container]");
    if (
        root.upvSettledVariantId != null &&
        String(root.upvSettledVariantId) != variantId &&
        sellingPlanInput &&
        sellingPlanContainer
    ) {
        pendingSellingPlan = true;
    }
    var available = variant.available === true;
    var sellingPlanValid = isProductSellingPlanSelectionValid(root, variant);
    var authoritative = Boolean(
        !identityMismatch &&
        !inputDisabled &&
        !transactionFailed
    );
    return {
        applicable: true,
        authoritative: authoritative,
        available: available,
        changed: false,
        id: variantId,
        identityMismatch: identityMismatch,
        input: variantInput,
        inputDisabled: inputDisabled,
        pendingSellingPlan: pendingSellingPlan,
        resolved: true,
        root: root,
        sellingPlanValid: sellingPlanValid,
        status: transactionFailed ?
            "transaction-error" :
            (pendingSellingPlan ?
            "pending-selling-plan" :
            (inputDisabled ?
            "external-lock" :
            (identityMismatch ?
            "conflict" :
            (!available ?
            "unavailable" :
            (sellingPlanValid ? "available" : "invalid-selling-plan"))))),
        transactionFailed: transactionFailed,
        variant: variant
    };
}

function synchronizeProductVariantInput(target, behavior) {
    var root = getProductVariantRoot(target);
    if (!root) return null;
    var verifyOnly = Boolean(behavior && behavior.verifyOnly === true);
    var variantInput = root.querySelector('[name="id"]');
    if (!variantInput) return null;
    if (verifyOnly) {
        return inspectProductVariantSelection(root, variantInput);
    }
    initializeProductVariantPurchaseState(root);
    if (root.upvSettledVariantId == null && variantInput.value != null) {
        root.upvSettledVariantId = String(variantInput.value);
    }
    var options = getSelectedProductOptionValues(root);
    if (!options.length) {
        var defaultVariantTransactionFailed =
            root.upvVariantTransactionError === true;
        var defaultVariantPending =
            root.upvSellingPlanVariantPending === true;
        var defaultVariantId = String(
            variantInput.value == null ? "" : variantInput.value
        );
        var defaultVariants = getProductVariantData(root);
        var defaultVariantDataAvailable = Array.isArray(defaultVariants);
        var defaultVariant = defaultVariantDataAvailable ?
            defaultVariants.find(function(variant) {
                return variant && String(variant.id) == defaultVariantId;
            }) : null;
        var defaultVariantResolved = Boolean(defaultVariantId && defaultVariant);
        var defaultVariantAvailable = defaultVariant ?
            defaultVariant.available === true : null;
        var defaultSellingPlanValid = isProductSellingPlanSelectionValid(
            root,
            defaultVariant
        );
        var defaultVariantInputLocked = Boolean(
            variantInput.disabled &&
            variantInput.upvVariantInputThemeDisabled !== true
        );
        var defaultVariantThemeDisabled = Boolean(
            defaultVariantTransactionFailed ||
            defaultVariantPending ||
            !defaultVariantResolved ||
            defaultVariantAvailable !== true ||
            !defaultSellingPlanValid
        );
        var defaultInputState = defaultVariantInputLocked ?
            { authoritative: false, changed: false } :
            setProductVariantInputState(
                variantInput,
                variantInput.value,
                defaultVariantThemeDisabled
            );
        if (defaultVariantThemeDisabled) {
            blockImmediateProductPurchase(root);
        }
        return {
            applicable: false,
            authoritative:
                defaultInputState.authoritative &&
                defaultVariantResolved &&
                defaultVariantAvailable === true &&
                defaultSellingPlanValid &&
                !defaultVariantTransactionFailed &&
                !defaultVariantPending &&
                !defaultVariantInputLocked,
            available: defaultVariantAvailable,
            changed: defaultInputState.changed,
            id: defaultVariantId,
            input: variantInput,
            pendingSellingPlan: defaultVariantPending,
            resolved: defaultVariantResolved,
            root: root,
            sellingPlanValid: defaultSellingPlanValid,
            status: defaultVariantTransactionFailed ?
                "transaction-error" :
                (defaultVariantPending ?
                "pending-selling-plan" :
                (defaultVariantInputLocked ?
                "external-lock" :
                (!defaultVariantResolved ?
                (defaultVariantId && defaultVariantDataAvailable ?
                "conflict" : "unresolved") :
                (defaultVariantAvailable !== true ?
                "unavailable" :
                (defaultSellingPlanValid ?
                "not-applicable" : "invalid-selling-plan"))))),
            transactionFailed: defaultVariantTransactionFailed,
            variant: defaultVariant || null,
            variantDataAvailable: defaultVariantDataAvailable
        };
    }
    var variant = getExactProductVariant(root, options);
    if (!variant) {
        var unresolvedSellingPlanPending =
            root.upvSellingPlanVariantPending === true ||
            beginProductSellingPlanTransition(root);
        var unresolvedInputState = setProductVariantInputState(
            variantInput,
            "",
            true
        );
        blockImmediateProductPurchase(root);
        return {
            applicable: true,
            authoritative: false,
            available: false,
            changed: unresolvedInputState.changed,
            id: null,
            input: variantInput,
            pendingSellingPlan: unresolvedSellingPlanPending,
            resolved: false,
            root: root,
            status: "unresolved",
            variant: null
        };
    }
    var variantId = String(variant.id);
    var variantTransactionFailed = root.upvVariantTransactionError === true;
    var variantInputExternallyLocked = Boolean(
        variantInput.disabled &&
        variantInput.upvVariantInputThemeDisabled !== true
    );
    var sellingPlanPending = root.upvSellingPlanVariantPending === true;
    if (String(root.upvSettledVariantId) != variantId) {
        sellingPlanPending =
            beginProductSellingPlanTransition(root) || sellingPlanPending;
    }
    var inputState = variantInputExternallyLocked ?
        { authoritative: false, changed: false } :
        setProductVariantInputState(
            variantInput,
            variantId,
            variantTransactionFailed
        );
    var available = variant.available === true;
    var sellingPlanValid = isProductSellingPlanSelectionValid(root, variant);
    if (
        !available ||
        sellingPlanPending ||
        !sellingPlanValid ||
        variantTransactionFailed ||
        variantInputExternallyLocked ||
        !inputState.authoritative
    ) {
        blockImmediateProductPurchase(root);
    }
    return {
        applicable: true,
        authoritative:
            inputState.authoritative && !variantTransactionFailed,
        available: available,
        changed: inputState.changed,
        id: variantId,
        input: variantInput,
        pendingSellingPlan: sellingPlanPending,
        resolved: true,
        root: root,
        sellingPlanValid: sellingPlanValid,
        status: variantTransactionFailed ?
            "transaction-error" :
            (variantInputExternallyLocked ?
            "external-lock" :
            (!inputState.authoritative ?
            "conflict" :
            (!available ? "unavailable" :
                (sellingPlanValid ? "available" : "invalid-selling-plan")))),
        variant: variant
    };
}

function isProductVariantPurchaseStateReady(state) {
    var termsWrapper = state && state.root &&
        typeof state.root.querySelector == "function" &&
        state.root.querySelector("[data-terms-conditions-wrapper]");
    var termsInput = termsWrapper &&
        typeof termsWrapper.querySelector == "function" &&
        termsWrapper.querySelector('[name="terms_conditions"]');
    return Boolean(
        state &&
        state.authoritative === true &&
        state.resolved === true &&
        state.available === true &&
        state.sellingPlanValid === true &&
        state.pendingSellingPlan !== true &&
        state.transactionFailed !== true &&
        state.status !== "transaction-error" &&
        state.input &&
        !state.input.disabled &&
        String(state.input.value || "") &&
        (!termsWrapper || (termsInput && termsInput.checked))
    );
}

productVariants = function(section = document) {
    var productContainers = section.getElementsByClassName('yv_product_content_section');
    Array.from(productContainers).forEach(function(productContainer, index) {
        let selectIds = productContainer.querySelectorAll('[name="id"]');
        if (
            productContainer.upvSettledVariantId == null &&
            selectIds[0] &&
            selectIds[0].value != null
        ) {
            productContainer.upvSettledVariantId = String(selectIds[0].value);
        }
        var reconcileInitialPurchaseState = false;
        if (initializeProductVariantPurchaseState(productContainer)) {
            reconcileInitialPurchaseState = Boolean(
                productContainer.upvVariantInitialTermsAccepted === true ||
                productContainer.upvVariantInitialStateNeedsReconciliation ===
                    true
            );
            blockImmediateProductPurchase(productContainer);
        }
        var productOptions = productContainer.getElementsByClassName("productOption");
        if (
            !productOptions ||
            !productOptions.length ||
            reconcileInitialPurchaseState
        ) {
            synchronizeProductVariantInput(productContainer);
        }
        if (reconcileInitialPurchaseState) {
            delete productContainer.upvVariantInitialTermsAccepted;
            delete productContainer.upvVariantInitialStateNeedsReconciliation;
            var reconciledInitialState = synchronizeProductVariantInput(
                productContainer,
                { verifyOnly: true }
            );
            if (isProductVariantPurchaseStateReady(reconciledInitialState)) {
                restoreImmediateProductPurchase(productContainer, true);
            } else {
                blockImmediateProductPurchase(productContainer);
            }
        }
        if (productOptions) {
            var eventType = "click";
            let triggeredEvent = false;
            if (variantStyle == "dropdown") { eventType = "change"; }
            var productOptionList = Array.from(productOptions);
            var shouldInitializeProduct = productOptionList.some(function(productOption) {
                return !upvVariantLifecycle.bindings.has(productOption);
            });
            productOptionList.forEach(function(productOption, index) {
                var previousBinding = upvVariantLifecycle.bindings.get(productOption);
                if (previousBinding) {
                    productOption.removeEventListener(previousBinding.eventType, previousBinding.handler);
                }

                var handleProductOptionChange = function() {
                    var _productParent = productOption.closest(".yv_product_content_section");
                    if (!_productParent) return;
                    var isInitialVariantHydration =
                        _productParent.upvInitialVariantHydration === true;
                    let optionValue = productOption.value;
                    let optionName = productOption.getAttribute("name");
                    let productPageSection = _productParent.closest(".shopify-section");
                    if (productPageSection) {
                        let getStickyOption = productPageSection.querySelector('select[name="sticky-' + optionName + '"]');
                        if (getStickyOption) {
                            getStickyOption.value = optionValue;
                        }
                    }
                    var optionSelector = productOption.closest('.product-option-selector');
                    if (optionSelector && optionSelector.querySelector('[data-option-value]')) {
                        optionSelector.querySelector('[data-option-value]').textContent = optionValue;
                    }
                    var synchronizedVariant = synchronizeProductVariantInput(
                        _productParent
                    );
                    var previousTimer = upvVariantLifecycle.timers.get(_productParent);
                    if (previousTimer) clearTimeout(previousTimer);
                    var variantTimer = setTimeout(function() {
                        upvVariantLifecycle.timers.delete(_productParent);
                        if (!_productParent.isConnected) {
                            discardProductVariantTransition(_productParent);
                            return;
                        }
                        try {
                        var options = getSelectedProductOptionValues(_productParent);
                        const fieldsets = Array.from(_productParent.querySelectorAll(".product-loop-variants"));
                        let productOptionsWithValues = '';
                        if (_productParent.querySelector('[type="application/json"][data-name="main-product-options"]')) {
                            try {
                                productOptionsWithValues = JSON.parse(
                                    _productParent.querySelector(
                                        '[type="application/json"][data-name="main-product-options"]'
                                    ).textContent
                                );
                            } catch (error) {
                                productOptionsWithValues = '';
                            }
                        }
                        var getVariant = variantChange(options, "options", _productParent);
                        var delayedVariantInputState =
                            settleDelayedProductVariantIdentity(
                                _productParent,
                                getVariant
                            );
                        var variantIdInput = delayedVariantInputState.input;
                        var delayedVariantInputAuthoritative =
                            delayedVariantInputState.authoritative === true;
                        try {
                            sellingPlans(getVariant, _productParent);
                        } catch (error) {
                            completeProductSellingPlanTransition(_productParent);
                            throw error;
                        }
                        completeProductSellingPlanTransition(
                            _productParent,
                            getVariant &&
                                delayedVariantInputAuthoritative ?
                                getVariant.id : null
                        );
                        updateBackInStock(getVariant, productContainer);
                        updateProductVariantMeta(_productParent, getVariant);
                        let variantData = '';
                        if (_productParent.querySelector('[type="application/json"][data-name="variant-json"]')) {
                            variantData = getProductVariantData(_productParent) || '';
                        }
                        if (productOptionsWithValues != '' && variantData != '') {
                            updateOptionsAvailability(variantData, productOptionsWithValues, getVariant, fieldsets, variantStyle)
                        }
                        var buttonWrapper = _productParent.querySelector("[data-button-wrapper]");
                        var paymentButtonWrapper = _productParent.querySelector(".Sd_addProduct");
                        var termsConditionCheckbox = '';
                        var paymentButton = paymentButtonWrapper ? paymentButtonWrapper.querySelector("span") : null;
                        if (_productParent) {
                            termsConditionCheckbox = _productParent.querySelector("[data-terms-conditions-wrapper]");
                        }
                        let stickyPaymentButton = "";
                        let stickyPaymentButtonWrapper = "";
                        if (productPageSection) {
                            stickyPaymentButtonWrapper = productPageSection.querySelector(".Sd_addProductSticky");

                            if (stickyPaymentButtonWrapper) {
                                stickyPaymentButton = stickyPaymentButtonWrapper.querySelector("span");
                            }
                        }
                        var advancePayment = paymentButtonWrapper ? paymentButtonWrapper.querySelector(
                            ".shopify-payment-button"
                        ) : null;

                        var priceContainer = _productParent.querySelector(
                            "[data-price-wrapper]"
                        );
                        var _productSection = _productParent.closest(".shopify-section");
                        priceUpdate(_productSection, priceContainer, getVariant, true);
                        let variantSku = "";
                        if (getVariant && getVariant.sku) {
                            variantSku = getVariant.sku;
                        }
                        let errorWrappers = productPageSection ?
                            productPageSection.querySelectorAll(".productErrors") : [];
                        if (errorWrappers) {
                            Array.from(errorWrappers).forEach(function(errorWrapper) {
                                errorWrapper.innerHTML = "";
                                errorWrapper.style.display = "none";
                            });
                        }
                        let variantSkuContainer = _productParent.querySelector(
                            "[data-variant-sku ]"
                        );
                        if (variantSkuContainer) {
                            variantSkuContainer.innerHTML = variantSku;
                        }
                        if (getVariant != undefined) {
                            if (getVariant.featured_media != null) {
                                /* update media based on selected variant start */
                                var image = getVariant.featured_media.id;
                                var varints = getVariant.options;
                                let imageAlt = getVariant.featured_media.alt;
                                if (imageAlt != null) {
                                    imageAlt = imageAlt.toLowerCase();
                                }
                                var productMediaScope = $(_productSection);
                                let thumbSelector = productMediaScope.find(".gallery__slide-img").closest(
                                    ".data-thumb-slider"
                                );
                                var mainSliderSelector = productMediaScope.find(".yv-product-image-item").closest(
                                    ".yv-product-big-slider"
                                );
                                var mainSliderImages = mainSliderSelector.find(
                                    '.yv-product-image-item[variant-color="' + imageAlt + '"]'
                                );
                                var allSliderImages = mainSliderSelector.find(
                                    ".yv-product-image-item"
                                );
                                var videoSlides = productMediaScope.find(
                                    '.yv-product-video-item[variant-color="' + imageAlt + '"]'
                                );
                                var allVideoSlides = productMediaScope.find(".yv-product-video-item");
                                var ModelSlides = productMediaScope.find(
                                    '.yv-product-model-item[variant-color="' + imageAlt + '"]'
                                );
                                var allModelSlides = productMediaScope.find(".yv-product-model-item");
                                if (mainSliderImages.length > 0) {
                                    if (mainSliderSelector.hasClass("flickity-enabled")) {
                                        if (typeof destroyProductSlider === "function") {
                                            destroyProductSlider(mainSliderSelector[0]);
                                        } else {
                                            var currentMainSlider = Flickity.data(mainSliderSelector[0]);
                                            if (currentMainSlider) currentMainSlider.destroy();
                                            if (typeof productSlider !== "undefined" && productSlider === currentMainSlider) {
                                                productSlider = undefined;
                                            }
                                        }
                                    }
                                    //   allSliderImages.fadeOut();
                                    allSliderImages.hide();
                                    allSliderImages
                                        .find("a.yv-product-zoom")
                                        .attr("data-fancybox", "none");
                                    allModelSlides.hide();
                                    mainSliderImages.fadeIn("slow");
                                    mainSliderImages
                                        .find("a.yv-product-zoom")
                                        .attr(
                                            "data-fancybox",
                                            "gallery" + _productSection.getAttribute("id")
                                        );
                                    //   mainSliderImages.show();
                                    videoSlides.show();
                                    ModelSlides.show();
                                    initProductSlider(_productSection);
                                }
                                var mainThumbSliderImages = productMediaScope.find(
                                    '.gallery__slide-img[variant-color="' + imageAlt + '"]'
                                );
                                var allThumSliderImages = productMediaScope.find(".gallery__slide-img");
                                if (mainThumbSliderImages.length > 0) {
                                    if (thumbSelector.hasClass("flickity-enabled")) {
                                        if (typeof destroyProductThumbSlider === "function") {
                                            destroyProductThumbSlider(thumbSelector[0]);
                                        } else {
                                            var currentThumbSlider = Flickity.data(thumbSelector[0]);
                                            if (currentThumbSlider) currentThumbSlider.destroy();
                                            if (typeof productThumbSlider !== "undefined" && productThumbSlider === currentThumbSlider) {
                                                productThumbSlider = undefined;
                                            }
                                        }
                                    }
                                    //   allThumSliderImages.fadeOut();
                                    allThumSliderImages.hide();
                                    mainThumbSliderImages.fadeIn("slow");
                                    //   mainThumbSliderImages.show();
                                    initProductThumbSlider(_productSection);
                                }
                                var selected_attribute = productMediaScope.find(
                                    '.gallery-thumbs-item[variant-color="' + imageAlt + '"]'
                                );
                                var thumbimage = productMediaScope.find(".gallery-thumbs-item");
                                if (selected_attribute.length > 0) {
                                    //   thumbimage.fadeOut();
                                    thumbimage.hide();
                                    selected_attribute.fadeIn("slow");
                                    //   selected_attribute.show();
                                }
                                var mainSelectedImages = productMediaScope.find(
                                    '.gallery-main-item[variant-color="' + imageAlt + '"]'
                                );
                                var allMainImages = productMediaScope.find(".gallery-main-item");
                                if (mainSelectedImages.length > 0) {
                                    //   allMainImages.fadeOut();
                                    allMainImages.hide();
                                    allMainImages
                                        .find("a.yv-product-zoom")
                                        .attr("data-fancybox", "none");
                                    mainSelectedImages.fadeIn("slow");
                                    mainSelectedImages
                                        .find("a.yv-product-zoom")
                                        .attr(
                                            "data-fancybox",
                                            "gallery" + _productSection.getAttribute("id")
                                        );
                                    //   mainSelectedImages.show();
                                }
                            }
                            /* update media based on selected variant stop*/
                            /* update media based on selected variant in quick add start*/
                            if (getVariant.featured_image != null && productPageSection.classList.contains('quick-add-popup')) {
                                let variantImage = getVariant.featured_image;
                                let currentVariantImage = productPageSection.querySelector(`.product-img.active`);
                                let selectedVariantImage = productPageSection.querySelector(`.product-img-${variantImage}`);
                                if (selectedVariantImage && currentVariantImage) {
                                    currentVariantImage.classList.add('hidden');
                                    selectedVariantImage.classList.remove('hidden');
                                    currentVariantImage.classList.remove('active');
                                    selectedVariantImage.classList.add('active');
                                }
                            }
                            /* update media based on selected variant in quick add stop*/
                            if (_productParent.querySelector("shopify-payment-terms")) {
                                _productParent.querySelector(
                                    "shopify-payment-terms"
                                ).style.display = "block";
                            }

                            var delayedVariantRefreshRequired = Boolean(
                                variantIdInput &&
                                (
                                    String(getVariant.id) != String(variantIdInput.value) ||
                                    variantIdInput.disabled ||
                                    delayedVariantInputState.changed ||
                                    (
                                        synchronizedVariant &&
                                        synchronizedVariant.changed &&
                                        String(synchronizedVariant.id) == String(getVariant.id)
                                    )
                                )
                            );
                            if (delayedVariantRefreshRequired) {
                                //             variant image change
                                if (getVariant.featured_media != null) {
                                    let sectionId = productPageSection.getAttribute("id");
                                    var image = getVariant.featured_media.id;
                                    var imageSource = jQuery("#" + sectionId).find(
                                        '[data-image="media-' + image + '"]'
                                    );
                                    if (imageSource) {
                                        var imageIndex = imageSource.index();
                                        var slider = imageSource.closest("[data-flickity-slider]");
                                        if (slider.length == 0) {
                                            slider = imageSource.closest(
                                                "[data-flickity-product-slider]"
                                            );
                                        }
                                        var activeProductSlider = slider.length > 0 ? Flickity.data(slider[0]) : null;
                                        if (activeProductSlider) {
                                            activeProductSlider.select(imageIndex);
                                        } else {
                                            if (slider && slider.hasClass("flickity-enabled")) {
                                                slider.flickity("select", imageIndex);
                                                if ($(window).width() < 768) {
                                                    let sliderImage = jQuery("body")
                                                        .find("#" + sectionId)
                                                        .find("#media-main-" + image);
                                                    if (sliderImage.length > 0) {
                                                        jQuery("html,body").animate({
                                                            scrollTop: imageSource.offset().top - top,
                                                        });
                                                        let sliderImageParent = sliderImage.parent();
                                                        sliderImageParent.scrollLeft(
                                                            sliderImageParent.scrollLeft() +
                                                            sliderImage.position().left
                                                        );
                                                    }
                                                }
                                            } else if (slider.hasClass("gallery-item")) {
                                                let top = 10;
                                                // if (jQuery("#headerSection").hasClass("sticky-header")) {
                                                top = jQuery('.shopify-section-main-header').height() + top;
                                                // }
                                                jQuery("html,body").animate({
                                                    scrollTop: imageSource.offset().top - top,
                                                });
                                                if ($(window).width() < 768) {
                                                    let sliderImage = (sliderImage = jQuery(
                                                        "#" + sectionId
                                                    ).find("#media-main" + image));
                                                    if (sliderImage) {
                                                        let sliderImageParent = sliderImage.parent();
                                                        sliderImageParent.scrollLeft(
                                                            sliderImageParent.scrollLeft() +
                                                            sliderImage.position().left
                                                        );
                                                    }
                                                }
                                            } else {
                                                imageSource.click();
                                                if ($(window).width() < 768) {
                                                    let sliderImage = jQuery("#" + sectionId).find(
                                                        "#media-" + image
                                                    );
                                                    if (sliderImage.length == 0) {
                                                        sliderImage = jQuery("#" + sectionId).find(
                                                            "#media-main-" + image
                                                        );
                                                    }
                                                    if (sliderImage.length > 0) {
                                                        let sliderImageParent = sliderImage.parent();
                                                        sliderImageParent.scrollLeft(
                                                            sliderImageParent.scrollLeft() +
                                                            sliderImage.position().left
                                                        );
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    if (
                                        getVariant.featured_media.media_type == "image" &&
                                        productPageSection
                                    ) {
                                        let featuredImage = productPageSection.querySelector(
                                            '[data-id="featuredImage-' +
                                            getVariant.featured_media.id +
                                            '"]'
                                        );
                                        if (featuredImage) {
                                            let featuredProductImages =
                                                productPageSection.querySelectorAll(
                                                    ".featured-product-image"
                                                );
                                            Array.from(featuredProductImages).forEach(function(image) {
                                                image.classList.remove("active");
                                            });
                                            featuredImage.classList.add("active");
                                        }
                                    }
                                }
                            }
                            let inventoryBar = _productParent.querySelector(
                                "[product__inventory]"
                            );
                            if (inventoryBar) {
                                inventoryBar.classList.remove("hidden");
                                updateInventroyStatusBar(
                                    getVariant.inventory_quantity,
                                    getVariant.inventory_policy,
                                    _productParent
                                );
                            }
                            updateProductVariantHistory(
                                _productParent,
                                productPageSection,
                                getVariant.id,
                                {
                                    authoritative: delayedVariantInputAuthoritative,
                                    initialization: isInitialVariantHydration
                                }
                            );
                            pickUpAvialabiliy(true, _productParent, getVariant.id);
                            if (getVariant.available == true) {
                                var termsConditionInput = termsConditionCheckbox &&
                                    termsConditionCheckbox.querySelector(
                                        '[name="terms_conditions"]'
                                    );
                                var purchaseTermsAccepted =
                                    delayedVariantInputAuthoritative &&
                                    (
                                        !termsConditionCheckbox ||
                                        Boolean(termsConditionInput && termsConditionInput.checked)
                                    );
                                if (!delayedVariantInputAuthoritative) {
                                    blockImmediateProductPurchase(_productParent);
                                }
                                if (termsConditionCheckbox) {
                                    termsConditionCheckbox.style.display = "block";
                                }
                                restoreImmediateProductPurchase(
                                    _productParent,
                                    purchaseTermsAccepted
                                );
                                if (paymentButton) {
                                    if (
                                        preorderStatus &&
                                        getVariant.inventory_policy == "continue" &&
                                        getVariant.inventory_quantity <= 0
                                    ) {
                                        paymentButton.innerHTML = preorderText;
                                    } else {
                                        paymentButton.innerHTML = addToCartText;
                                    }
                                }
                                if (stickyPaymentButton) {
                                    if (
                                        preorderStatus &&
                                        getVariant.inventory_policy == "continue" &&
                                        getVariant.inventory_quantity <= 0
                                    ) {
                                        stickyPaymentButton.innerHTML = preorderText;
                                    } else {
                                        stickyPaymentButton.innerHTML = addToCartText;
                                    }
                                }
                            } else {
                                if (termsConditionCheckbox) {
                                    termsConditionCheckbox.style.display = "none";
                                    if (termsConditionCheckbox.querySelector('[name="terms_conditions"]')) {
                                        termsConditionCheckbox.querySelector('[name="terms_conditions"]').checked = false
                                    }
                                }
                                blockImmediateProductPurchase(_productParent);
                                if (stickyPaymentButton) {
                                    stickyPaymentButton.innerHTML = soldOutText;
                                }
                                if (paymentButton) {
                                    paymentButton.innerHTML = soldOutText;
                                }
                            }
                        } else {
                            if (termsConditionCheckbox) {
                                termsConditionCheckbox.style.display = "none";
                                if (termsConditionCheckbox.querySelector('[name="terms_conditions"]')) {
                                    termsConditionCheckbox.querySelector('[name="terms_conditions"]').checked = false
                                }
                            }
                            let inventoryBar = _productParent.querySelector(
                                "[product__inventory]"
                            );
                            if (inventoryBar) {
                                inventoryBar.classList.add("hidden");
                            }
                            if (_productParent.querySelector("shopify-payment-terms")) {
                                _productParent.querySelector(
                                    "shopify-payment-terms"
                                ).style.display = "none";
                            }
                            pickUpAvialabiliy(false, _productParent);
                            blockImmediateProductPurchase(_productParent);
                            if (paymentButton) {
                                paymentButton.innerHTML = unavailableText;
                            }
                            if (stickyPaymentButton) {
                                stickyPaymentButton.innerHTML = unavailableText;
                            }
                        }
                        _productParent.upvVariantTransactionError = false;
                        if (getVariant) {
                            var completedVariantInputState =
                                settleDelayedProductVariantIdentity(
                                    _productParent,
                                    getVariant
                                );
                            if (!completedVariantInputState.authoritative) {
                                throw new Error("Variant identity ownership conflict");
                            }
                        }
                        } catch (error) {
                            _productParent.upvVariantTransactionError = true;
                            completeProductSellingPlanTransition(_productParent);
                            var failedVariantInput =
                                _productParent.querySelector('[name="id"]');
                            if (
                                failedVariantInput &&
                                !(
                                    failedVariantInput.disabled &&
                                    failedVariantInput.upvVariantInputThemeDisabled !== true
                                )
                            ) {
                                setProductVariantInputState(
                                    failedVariantInput,
                                    failedVariantInput.value,
                                    true
                                );
                            }
                            blockImmediateProductPurchase(_productParent);
                            showProductVariantUpdateError(_productParent);
                        }
                    }, 500);
                    upvVariantLifecycle.timers.set(_productParent, variantTimer);
                };

                productOption.addEventListener(eventType, handleProductOptionChange);
                upvVariantLifecycle.bindings.set(productOption, {
                    eventType: eventType,
                    handler: handleProductOptionChange
                });

                if (!triggeredEvent && shouldInitializeProduct) {
                    productContainer.upvInitialVariantHydration = true;
                    try {
                        if (variantStyle == "swatch" && productOption.checked) {
                            productOption.click();
                            triggeredEvent = true;
                        } else if (variantStyle == "dropdown") {
                            let clickEvent = new Event('change');
                            productOption.dispatchEvent(clickEvent);
                            triggeredEvent = true;
                        }
                    } finally {
                        delete productContainer.upvInitialVariantHydration;
                    }
                }
            });
        }
    });
};

function acceptTermsConditions(event) {
    let element = event.target;
    let parent = element.closest('.yv_product_content_section');
    let buttonWrapper = parent.querySelector('[data-button-wrapper]');
    if (parent.querySelector('.Sd_addProduct')) {
        if (element.checked) {
            var termsVariantState = null;
            try {
                synchronizeProductVariantInput(parent);
                termsVariantState = synchronizeProductVariantInput(
                    parent,
                    { verifyOnly: true }
                );
            } catch (error) {}
            var termsVariantReady =
                isProductVariantPurchaseStateReady(termsVariantState);
            if (!termsVariantReady) {
                blockImmediateProductPurchase(parent);
                return;
            }
            restoreImmediateProductPurchase(
                parent,
                true
            );
        } else {
            blockImmediateProductPurchase(parent);
        }
    }
}

function variantChange(options, type, selector) {
    var variantData = getProductVariantData(selector);
    if (!Array.isArray(variantData)) return;
    let currentVariant = variantData.find((variant) => {
        if (type === "options") {
            return !variant.options
                .map((option, index) => {
                    return options[index] === option;
                })
                .includes(false);
        }
        if (type === "id") {
            return variant.id == options;
        }
    });
    if (!currentVariant) {
        return getFirstAvailableVariant(options, variantStyle, selector, variantData);
    } else {
        return currentVariant;
    }
}

function updateInventroyStatusBar(variantQty, variantPolicy, productRoot) {
    let inventoryScope = productRoot && productRoot.querySelector ? productRoot : document;
    let productInventoryBar = inventoryScope.querySelector("[product__inventory]");
    if (productInventoryBar) {
        let quantity = productInventoryBar.querySelector(
            "[product-inventroy-status-bar]"
        ).dataset.quantity;
        var hasVariantInventory =
            variantQty !== undefined &&
            variantQty !== null &&
            variantPolicy !== undefined &&
            variantPolicy !== null;
        if (hasVariantInventory) {
            quantity = variantQty;
            if (
                quantity > 0 &&
                quantity <= minInventroyQuantity &&
                variantPolicy == "deny"
            ) {
                productInventoryBar.classList.remove("hidden");
                productInventoryBar.classList.remove("full-inventory");
                productInventoryBar.classList.add("low-inventory");
                let quantityHtml = `<strong> ${variantQty} </strong>`;
                let newStatus = inventroyLowStatus.replace(
                    "||inventory||",
                    quantityHtml
                );
                productInventoryBar.querySelector("[inventory-status]").innerHTML =
                    newStatus;
                productInventoryBar
                    .querySelector("[product-inventroy-status-bar]")
                    .classList.remove("hide-bar");
                letBarWidth = (parseInt(variantQty) * 100) / 40;
                productInventoryBar
                    .querySelector("[product-inventroy-status-bar]")
                    .setAttribute(
                        "style",
                        "--inventroy-status-bar-width:" + letBarWidth + "%"
                    );
            } else if (quantity <= 0) {
                productInventoryBar.classList.add("hidden");
            } else {
                productInventoryBar.classList.remove("hidden");
                productInventoryBar.classList.remove("low-inventory");
                productInventoryBar.classList.add("full-inventory");
                productInventoryBar.querySelector("[inventory-status]").innerHTML =
                    inventroyAvailableStatus;
                productInventoryBar
                    .querySelector("[product-inventroy-status-bar]")
                    .classList.add("hide-bar");
                productInventoryBar
                    .querySelector("[product-inventroy-status-bar]")
                    .setAttribute("style", "--inventroy-status-bar-width:100%");
            }
            productInventoryBar
                .querySelector("[product-inventroy-status-bar]")
                .setAttribute("data-quantity", variantQty);
        } else if (quantity && quantity >= 0 && quantity <= minInventroyQuantity) {
            letBarWidth = (parseInt(quantity) * 100) / 40;
            productInventoryBar
                .querySelector("[product-inventroy-status-bar]")
                .setAttribute(
                    "style",
                    "--inventroy-status-bar-width:" + letBarWidth + "%"
                );
        }
    }
}

function priceUpdate(productSection, priceContainer, getVariant, showSaved) {
    var showSavedAmount = "";
    var savedAmountStyle = "";
    var priceHtml = "";
    if (getVariant != undefined) {
        if (priceContainer) {
            showSavedAmount = priceContainer.getAttribute("data-saved");
            savedAmountStyle = priceContainer.getAttribute("data-saved-style");
        }
        var compareAtPrice = parseInt(getVariant.compare_at_price);
        var price = parseInt(getVariant.price);
        var percentage =
            roundToTwo(((compareAtPrice - price) / compareAtPrice) * 100) +
            "% " +
            saleOffText;
        var savedAmount =
            Shopify.formatMoney(compareAtPrice - price, moneyFormat) +
            " " +
            saleOffText;
        priceHtml = `<span class="yv-visually-hidden">${regularPriceText}</span><span class="yv-product-price h2">${Shopify.formatMoney(
      price,
      moneyFormat
    )}</span>`;
        var savedAmountHtml =
            '<span class="yv-visually-hidden">' + savedPriceText + "</span>";
        if (showSaved) {
            if (showSavedAmount == "true") {
                if (savedAmountStyle == "percentage") {
                    savedAmountHtml += `<span class="yv-product-percent-off">${percentage}</span>`;
                } else {
                    savedAmountHtml += `<span class="yv-product-percent-off">${savedAmount}</span>`;
                }
            }
        } else {
            if (getVariant.allocation_type == "") {
                if (savedAmountStyle == "percentage") {
                    savedAmountHtml += `<span class="yv-product-percent-off">${percentage}</span>`;
                } else {
                    savedAmountHtml += `<span class="yv-product-percent-off">${savedAmount}</span>`;
                }
            } else if (getVariant.allocation_type == "percentage") {
                savedAmountHtml += `<span class="yv-product-percent-off">${getVariant.allocation_value}% ${saleOffText}</span>`;
            } else {
                savedAmountHtml += `<span class="yv-product-percent-off">${Shopify.formatMoney(
          getVariant.allocation_value,
          moneyFormat
        )} ${saleOffText}</span>`;
            }
        }
        if (compareAtPrice > price) {
            priceHtml = `<span class="yv-visually-hidden">${comparePriceText}</span><span class="yv-product-price h2">${Shopify.formatMoney(
        price,
        moneyFormat
      )}</span>
      <div class="yv-compare-price-box"><span class="yv-visually-hidden">${regularPriceText}</span><span class="yv-product-compare-price"> ${Shopify.formatMoney(
        compareAtPrice,
        moneyFormat
      )}</span>
      ${savedAmountHtml}</div>`;
        }
        if (getVariant.unit_price_measurement) {
            priceHtml +=
                '<span class="yv-visually-hidden">' +
                unitPriceText +
                '</span><p class="yv-product-unit-price">' +
                Shopify.formatMoney(getVariant.unit_price, moneyFormat) +
                " / ";
            priceHtml +=
                getVariant.reference_value == 1 ? "" : getVariant.reference_value;
            priceHtml += getVariant.reference_unit + "</p>";
        }

        if (getVariant.available != true) {
            priceHtml += `<span class="yv-visually-hidden">${soldOutText}</span>`;
        }
    }
    if (priceContainer) {
        if (productSection.classList.contains('quick-add-popup')) {
            priceHtml = priceHtml.replace('h2', '')
        }
        priceContainer.innerHTML = priceHtml;
    }
    if (productSection) {
        let stickyPriceContainer = productSection.querySelector(
            "[data-sticky-price-wrapper]"
        );
        if (stickyPriceContainer) {
            priceHtml = priceHtml.replace('h2', 'h4')
            stickyPriceContainer.innerHTML = priceHtml;
        }
    }
}

function sellingPlans(variant, form) {
    let sellingPlanVariable = form.querySelector('[name="selling_plan"]');
    let sellingHtmlContainer = form.querySelector(
        "[data-selling-plan-container]"
    );
    if (sellingPlanVariable) sellingPlanVariable.value = "";
    if (sellingHtmlContainer) {
        sellingHtmlContainer.innerHTML = "";
        if (variant && variant.selling_plans) {
            let sellingPlans = variant.selling_plans;
            let variantPlans = [],
                variantGroups = [];
            if (Object.keys(sellingPlans).length > 0) {
                for (plan in sellingPlans) {
                    var planId = parseInt(plan.replace("plan_", ""));
                    var groupId = sellingPlans[plan]["group_id"];
                    variantPlans.push(planId);
                    if (!variantGroups.includes(groupId)) {
                        variantGroups.push(groupId);
                    }
                }
                var sellingPlanHtml = `<div class="selling_group active">
<div class="sellingPlanHeading" for="oneTimePurchase">
<input type="radio" id="oneTimePurchase" name="sellingPlanHeading" checked>
<label for="oneTimePurchase">${oneTimePurchaseText}</label>
</div>
</div>`;
                variantGroups.forEach(function(group, index) {
                    var group = eval("selling_Plan_Group_" + group);
                    var groupPlans = group.selling_plans;

                    sellingPlanHtml += `<div class="selling_group">
<div class="sellingPlanHeading" for="sellingGroup${index}">
<input type="radio" id="sellingGroup${index}" name="sellingPlanHeading" value="">
<label for="sellingGroup${index}">${group.name}</label>
</div>
<div  class="selling_plan">
<select class="selling_plan_attribute">`;
                    for (plan in groupPlans) {
                        var plan = groupPlans[plan];
                        sellingPlanHtml += `<option value="${plan.id}">${plan.name}</option>`;
                    }
                    sellingPlanHtml += `</select></div></div>`;
                });
                sellingPlanHtml += `</div>`;
                sellingHtmlContainer.innerHTML = sellingPlanHtml;
                sellingPlanChange(form);
            }
        }
    }
}

function collectProductLifecycleElements(scope, selector) {
    if (!scope || typeof scope.querySelectorAll !== "function") return [];
    var elements = [];
    if (typeof scope.matches === "function" && scope.matches(selector)) {
        elements.push(scope);
    }
    elements = elements.concat(Array.from(scope.querySelectorAll(selector)));
    if (selector == ".yv_product_content_section") {
        if (
            scope.upvVariantPurchaseGuard &&
            scope.upvVariantPurchaseGuard.ownerRoot === scope &&
            elements.indexOf(scope) == -1
        ) {
            elements.push(scope);
        }
        // A third-party rehydrate can remove the identifying class before a
        // drawer is disposed. Find only the exceptional active guard owners
        // so their observers and target references cannot outlive the drawer.
        Array.from(scope.querySelectorAll("*")).forEach(function(candidate) {
            if (
                candidate &&
                candidate.upvVariantPurchaseGuard &&
                candidate.upvVariantPurchaseGuard.ownerRoot === candidate &&
                elements.indexOf(candidate) == -1
            ) {
                elements.push(candidate);
            }
        });
    }
    return elements;
}

function cancelPickupAvailabilityRequest(pickUp) {
    if (!pickUp) return;
    var requestState = upvVariantLifecycle.pickupRequests.get(pickUp);
    if (requestState) {
        if (requestState.timer) clearTimeout(requestState.timer);
        if (requestState.controller) requestState.controller.abort();
        requestState.pending = false;
    }
    upvVariantLifecycle.pickupRequests.delete(pickUp);
}

function disposeProductVariantLifecycle(scope) {
    collectProductLifecycleElements(scope, ".yv_product_content_section").forEach(function(productContainer) {
        var variantTimer = upvVariantLifecycle.timers.get(productContainer);
        if (variantTimer) clearTimeout(variantTimer);
        upvVariantLifecycle.timers.delete(productContainer);
        discardProductVariantTransition(productContainer);

        Array.from(productContainer.querySelectorAll(".productOption")).forEach(function(productOption) {
            var binding = upvVariantLifecycle.bindings.get(productOption);
            if (binding) {
                productOption.removeEventListener(binding.eventType, binding.handler);
                upvVariantLifecycle.bindings.delete(productOption);
            }
        });
    });

    collectProductLifecycleElements(scope, ".product__pickup-availabilities").forEach(function(pickUp) {
        cancelPickupAvailabilityRequest(pickUp);
        var showContainerButton = pickUp.querySelector("#ShowPickupAvailabilityDrawer");
        var drawerBinding = showContainerButton &&
            upvVariantLifecycle.pickupDrawerBindings.get(showContainerButton);
        if (drawerBinding) {
            showContainerButton.removeEventListener("click", drawerBinding.handler);
            upvVariantLifecycle.pickupDrawerBindings.delete(showContainerButton);
        }
    });
    if (typeof destroyQuickViewMediaSliders === "function") {
        destroyQuickViewMediaSliders(scope);
    }
}

function pickUpAvialabiliy(status, productRoot, selectedVariantId) {
    var pickupScope = productRoot && productRoot.querySelector ? productRoot : document;
    var pickUp = pickupScope.querySelector(".product__pickup-availabilities");
    if (!pickUp) return;
    var previewContainer = pickUp.querySelector("#pickup-availability-preview-container");
    if (!previewContainer) return;

    var hasSelectedVariantId =
        selectedVariantId !== undefined &&
        selectedVariantId !== null &&
        selectedVariantId !== "";
    var productForm = pickUp.closest("form");
    var variantInput = productForm && productForm.querySelector("[name=id]");
    var variantId = hasSelectedVariantId ? selectedVariantId : (variantInput && variantInput.value);
    var normalizedVariantId = variantId === undefined || variantId === null ? "" : String(variantId);

    var previousRequest = upvVariantLifecycle.pickupRequests.get(pickUp);
    if (
        status &&
        previousRequest &&
        previousRequest.pending &&
        previousRequest.variantId === normalizedVariantId
    ) {
        return;
    }

    cancelPickupAvailabilityRequest(pickUp);

    previewContainer.innerHTML = "";
    pickUp.classList.add("hidden");
    previewContainer.classList.add("hidden");
    if (!status) return;

    var generation = previousRequest ? previousRequest.generation + 1 : 1;
    var requestState = {
        controller: null,
        generation: generation,
        pending: true,
        timer: null,
        variantId: normalizedVariantId
    };
    upvVariantLifecycle.pickupRequests.set(pickUp, requestState);

    var completeRequest = function() {
        if (upvVariantLifecycle.pickupRequests.get(pickUp) === requestState) {
            requestState.pending = false;
            requestState.controller = null;
        }
    };

    requestState.timer = setTimeout(function() {
        requestState.timer = null;
        if (upvVariantLifecycle.pickupRequests.get(pickUp) !== requestState) return;
        if (!pickUp.isConnected) {
            cancelPickupAvailabilityRequest(pickUp);
            return;
        }
        var currentProductForm = pickUp.closest("form");
        var currentVariantInput = currentProductForm && currentProductForm.querySelector("[name=id]");
        var requestVariantId = hasSelectedVariantId ?
            String(selectedVariantId) :
            String((currentVariantInput && currentVariantInput.value) || "");
        if (!requestVariantId) {
            completeRequest();
            return;
        }
        requestState.variantId = requestVariantId;
        var rootUrl = pickUp.dataset.rootUrl || "/";
        if (!rootUrl.endsWith("/")) rootUrl = rootUrl + "/";
        var variantSectionUrl = `${rootUrl}variants/${requestVariantId}/?section_id=pickup-availability`;
        var controller = typeof AbortController === "function" ? new AbortController() : null;
        requestState.controller = controller;
        var fetchOptions = controller ? { signal: controller.signal } : undefined;

        fetch(variantSectionUrl, fetchOptions)
            .then((response) => {
                if (!response.ok) throw new Error("Pickup availability request failed");
                return response.text();
            })
            .then((text) => {
                var activeRequest = upvVariantLifecycle.pickupRequests.get(pickUp);
                if (activeRequest !== requestState) return;
                if (!pickUp.isConnected) {
                    cancelPickupAvailabilityRequest(pickUp);
                    return;
                }
                var sectionInnerHTML = new DOMParser()
                    .parseFromString(text, "text/html")
                    .querySelector(".shopify-section");
                if (!sectionInnerHTML) {
                    completeRequest();
                    return;
                }
                var container = sectionInnerHTML.querySelector(
                    "#pickUpAvailabilityPreview"
                );
                if (container) {
                    previewContainer.innerHTML = sectionInnerHTML.innerHTML;
                    previewContainer.classList.remove("hidden");
                    pickUp.classList.remove("hidden");
                    showPickupDrawer(pickUp);
                }
                completeRequest();
            })
            .catch((error) => {
                completeRequest();
            });
    }, 500);
}

function sellingPlanChange(scope) {
    var sellingPlanRoot = scope && typeof scope.querySelectorAll == "function" ?
        scope : document;
    var groupSelectors = sellingPlanRoot.querySelectorAll('[name="sellingPlanHeading"]');
    Array.from(groupSelectors).forEach(function(group) {
        if (group.upvSellingPlanClickHandler) {
            group.removeEventListener("click", group.upvSellingPlanClickHandler);
        }
        var handleSellingPlanGroupClick = () => {
            var value = "";
            var productForm = group.closest("form");
            var sellingPlanVariable = productForm.querySelector(
                '[name="selling_plan"]'
            );
            var selectors = productForm.querySelectorAll(".selling_group");
            var _thisParent = group.closest(".selling_group");
            if (_thisParent.classList.contains("active")) {
                return;
            } else {
                Array.from(selectors).forEach(function(selector) {
                    if (selector != _thisParent) {
                        selector.classList.remove("active");
                        if (selector.querySelector(".selling_plan")) {
                            DOMAnimations.slideUp(selector.querySelector(".selling_plan"));
                        }
                    }
                });

                var variantId = productForm
                    .querySelector('[name="id"]')
                    .value;
                var variantSelected = variantChange(variantId, "id", productForm);
                var _productParent = productForm.closest(".yv_product_content_section");
                var _productSection = productForm.closest(".shopify-section");
                var priceContainer = _productParent.querySelector(
                    "[data-price-wrapper]"
                );
                if (_thisParent.querySelector(".selling_plan_attribute")) {
                    value = _thisParent.querySelector(".selling_plan_attribute").value;
                    priceUpdate(
                        _productSection,
                        priceContainer,
                        variantSelected["selling_plans"]["plan_" + value],
                        false
                    );
                } else {
                    priceUpdate(_productSection, priceContainer, variantSelected, true);
                }
                sellingPlanVariable.value = value;
                _thisParent.classList.add("active");
                if (_thisParent.querySelector(".selling_plan")) {
                    DOMAnimations.slideDown(_thisParent.querySelector(".selling_plan"));
                }
            }
        };
        group.addEventListener("click", handleSellingPlanGroupClick);
        group.upvSellingPlanClickHandler = handleSellingPlanGroupClick;
    });
    var planSelectors = sellingPlanRoot.querySelectorAll(
        "select.selling_plan_attribute"
    );
    Array.from(planSelectors).forEach(function(plan) {
        if (plan.upvSellingPlanChangeHandler) {
            plan.removeEventListener("change", plan.upvSellingPlanChangeHandler);
        }
        var handleSellingPlanAttributeChange = () => {
            var value = "";
            var productForm = plan.closest("form");
            var sellingPlanVariable = productForm.querySelector(
                '[name="selling_plan"]'
            );
            sellingPlanVariable.value = plan.value;
            var variantId = productForm
                .querySelector('[name="id"]')
                .value;

            var variantSelected = variantChange(variantId, "id", productForm);
            var _productParent = productForm.closest(".yv_product_content_section");
            var priceContainer = _productParent.querySelector("[data-price-wrapper]");
            var _productSection = productForm.closest(".shopify-section");
            priceUpdate(
                _productSection,
                priceContainer,
                variantSelected["selling_plans"]["plan_" + plan.value],
                false
            );
        };
        plan.addEventListener("change", handleSellingPlanAttributeChange);
        plan.upvSellingPlanChangeHandler = handleSellingPlanAttributeChange;
    });
}

showMultipleOptions = function() {
    return false;
    var showOptions = document.getElementsByClassName("showOptions");
    if (showOptions) {
        Array.from(showOptions).forEach(function(option) {
            option.addEventListener("click", () => {
                hideOptions();
                var product = option.getAttribute("data-product");
                var wrapper = option.closest(".card--product ");
                wrapper.querySelector("#" + product).style.display = "block";
            });
        });
    }

    var closeOptions = document.getElementsByClassName("close-product-wrap");
    if (closeOptions) {
        Array.from(closeOptions).forEach(function(option) {
            option.addEventListener("click", () => {
                var product = option.getAttribute("data-product");
                var wrapper = option.closest(".card--product ");
                wrapper.querySelector("#" + product).style.display = "none";
            });
        });
    }

    function hideOptions() {
        var options = document.getElementsByClassName("product-wrap");
        Array.from(options).forEach(function(option) {
            option.style.display = "none";
        });
    }
};

function showPickupDrawer(pickUp) {
    var pickupScope = pickUp && pickUp.querySelector ? pickUp : document;
    const showContainerButton = pickupScope.querySelector(
        "#ShowPickupAvailabilityDrawer"
    );
    const previewContainer = pickupScope.querySelector(
        "#pickup-availability-preview-container"
    );
    if (showContainerButton && previewContainer) {
        var previousBinding = upvVariantLifecycle.pickupDrawerBindings.get(showContainerButton);
        if (previousBinding) {
            showContainerButton.removeEventListener("click", previousBinding.handler);
        }
        var handlePickupDrawer = function(e) {
            e.preventDefault();
            const drawer = document.querySelector("[data-side-drawer]");
            const drawerTitle = drawer && drawer.querySelector("[data-drawer-title]");
            const drawerBody = drawer && drawer.querySelector("[data-drawer-body]");
            const availabilityMain = previewContainer.querySelector(
                "#pickUpAvailabilityMain"
            );
            if (!drawer || !drawerTitle || !drawerBody || !availabilityMain) return;
            var pickupButtonWillBeRemoved =
                typeof drawerBody.contains === "function" &&
                drawerBody.contains(showContainerButton);
            var stableQuickViewTrigger = drawer.upvQuickViewTrigger;
            var pickupReturnFocusTarget = showContainerButton;
            if (pickupButtonWillBeRemoved) {
                pickupReturnFocusTarget =
                    isNativeQuickViewSharedDrawer(drawer) &&
                    document.body.classList.contains("side_Drawer_open") &&
                    stableQuickViewTrigger &&
                    stableQuickViewTrigger.isConnected !== false ?
                    stableQuickViewTrigger : null;
            } else if (showContainerButton.isConnected === false) {
                pickupReturnFocusTarget = null;
            }
            cancelQuickViewRequest(drawer);
            hideQuickViewLoader();
            var pickupOwnership = claimSharedDrawerOwnership(drawer, "pickup");
            if (pickupOwnership) {
                pickupOwnership.returnFocusTarget = pickupReturnFocusTarget;
            }
            disposeProductVariantLifecycle(drawerBody);
            drawer.setAttribute("class", "yv_side_drawer_wrapper");
            drawer.removeAttribute("id");
            drawer.upvQuickViewTrigger = null;
            var drawerHtml = availabilityMain.innerHTML;

            drawer.classList.add("pickup-availability-drawer");
            drawerTitle.innerHTML = pickUpAvialabiliyHeading;
            drawerBody.innerHTML = drawerHtml;
            drawerBody.classList.remove("searching");
            if (!drawerTitle.id) {
                drawerTitle.id = "pickup-availability-title";
            }
            drawer.setAttribute("role", "dialog");
            drawer.setAttribute("aria-modal", "true");
            drawer.setAttribute("aria-hidden", "false");
            drawer.setAttribute("aria-labelledby", drawerTitle.id);
            drawer.removeAttribute("aria-label");
            focusElement = pickupReturnFocusTarget || "";
            document.body.classList.add("side_Drawer_open");
            focusElementsRotation($(drawer));
            var pickupInitialFocus = drawer.querySelector(
                ".yv_side_drawer_close, [data-drawer-close]"
            );
            if (pickupInitialFocus && typeof pickupInitialFocus.focus === "function") {
                pickupInitialFocus.setAttribute(
                    "aria-label",
                    "Close pickup availability"
                );
                if (pickupInitialFocus.tagName === "BUTTON") {
                    pickupInitialFocus.setAttribute("type", "button");
                }
                pickupInitialFocus.focus();
            } else {
                drawer.focus();
            }
        };
        showContainerButton.addEventListener("click", handlePickupDrawer);
        upvVariantLifecycle.pickupDrawerBindings.set(showContainerButton, {
            handler: handlePickupDrawer
        });
    }
}

flickitySlider = function(selector, slideIndex) {
    if (selector.attr("data-manual") == "true") {
        return false;
    }
    var optionContainer = selector.attr("data-flickity-slider");
    if (optionContainer) {
        var options = JSON.parse(optionContainer);
        if (selector.hasClass("flickity-enabled")) {
            selector.flickity("resize");
        } else {
            if (slideIndex) {
                selector
                    .not(".flickity-enabled")
                    .flickity(options)
                    .flickity("select", slideIndex);
            } else {
                selector.not(".flickity-enabled").flickity(options).flickity("resize");
            }
        }
        selector.off("change.flickity.upvTheme").on("change.flickity.upvTheme", function(event, index) {
            selector[0].querySelectorAll(".yv-youtube-video").forEach((video) => {
                if (video.contentWindow) {
                    video.contentWindow.postMessage(
                        '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
                        "*"
                    );
                }
            });
            selector[0].querySelectorAll(".yv-vimeo-video").forEach((video) => {
                if (video.contentWindow) video.contentWindow.postMessage('{"method":"pause"}', "*");
            });
            selector[0]
                .querySelectorAll("video:not(.videoBackgroundFile)")
                .forEach((video) => video.pause());
        });
        selector.find(".flickity-slider-thumb-item")
            .off("focus.upvThemeFlickity")
            .on("focus.upvThemeFlickity", function() {
            let slideIndex = parseInt($(this).attr("data-index"));
            let productMainSlider = selector
                .closest(".shopify-section")
                .find("[data-flickity-product-slider]");
            let mainSlider = selector
                .closest(".shopify-section")
                .find(".data-main-slider");
            let activeProductSlider = productMainSlider.length > 0
                ? Flickity.data(productMainSlider[0])
                : null;
            if (activeProductSlider) {
                activeProductSlider.select(slideIndex);
            } else if (mainSlider.length > 0 && mainSlider.hasClass("flickity-enabled")) {
                mainSlider.flickity("select", slideIndex);
            }
        });
    }
};

function getQuickViewMediaSliders(section) {
    if (typeof jQuery !== "function") return null;
    if (!section) return jQuery();
    return jQuery(section).find(
        ".yv-quickview_product-main[data-flickity-slider], " +
        ".yv-quickview_product-thumb[data-flickity-slider]"
    );
}

function initQuickViewMediaSliders(section) {
    var quickViewSliders = getQuickViewMediaSliders(section);
    if (!quickViewSliders) return 0;
    quickViewSliders.each(function() {
        flickitySlider(jQuery(this));
    });
    return quickViewSliders.length;
}

function isInactiveQuickViewSlider(sliderElement) {
    if (!sliderElement || typeof sliderElement.closest !== "function") {
        return false;
    }
    var quickViewDrawer = sliderElement.closest(
        "#yv_quickView_product.yv_quickView_product"
    );
    return Boolean(
        quickViewDrawer && !isSharedDrawerFocusSurfaceOpen(quickViewDrawer)
    );
}

function destroyQuickViewMediaSliders(section) {
    var quickViewSliders = getQuickViewMediaSliders(section);
    if (!quickViewSliders) return 0;
    for (var sliderIndex = quickViewSliders.length - 1; sliderIndex >= 0; sliderIndex--) {
        var sliderElement = quickViewSliders[sliderIndex];
        var slider = jQuery(sliderElement);
        slider.off(".upvTheme");
        slider.find(".flickity-slider-thumb-item").off(".upvThemeFlickity");
        var instance =
            typeof Flickity !== "undefined" &&
            typeof Flickity.data === "function" ?
            Flickity.data(sliderElement) : null;
        if (instance && typeof instance.destroy === "function") {
            instance.destroy();
        } else if (slider.hasClass("flickity-enabled")) {
            slider.flickity("destroy");
        }
    }
    return quickViewSliders.length;
}

sliders = function() {
    var sliders = jQuery("body").find("[data-flickity-slider]");
    if (sliders.length > 0) {
        sliders.each(function(index) {
            if (isInactiveQuickViewSlider(this)) return;
            if (jQuery(this).is("[data-mobile-only]")) {
                if ($(window).width() < 768) {
                    if (!jQuery(this).hasClass("flickity-enabled")) {
                        flickitySlider(jQuery(this));
                    }
                } else {
                    if (jQuery(this).hasClass("flickity-enabled")) {
                        jQuery(this).flickity("destroy");
                    }
                }
            } else if (jQuery(this).is("[data-desktop-only]")) {
                if ($(window).width() >= 768) {
                    if (!jQuery(this).hasClass("flickity-enabled")) {
                        flickitySlider(jQuery(this));
                    }
                } else {
                    if (jQuery(this).hasClass("flickity-enabled")) {
                        jQuery(this).flickity("destroy");
                    }
                }
            } else {
                if (!jQuery(this).hasClass("flickity-enabled")) {
                    flickitySlider(jQuery(this));
                } else {
                    jQuery(this).flickity("resize");
                }
            }
        });
    }
};

// let yvYouTubeVideos = document.querySelectorAll(".yvYoutubeAutoPlayvVideo");
// if (yvYouTubeVideos.length > 0) {
//   // youtTubeScriptLoad();
// }
function youtTubeScriptLoad() {
    if (document.querySelector(`script[src="https://www.youtube.com/iframe_api"]`)) return;
    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    document.body.appendChild(tag);
}

function onYouTubeIframeAPIReady() {
    document.dispatchEvent(new CustomEvent('on:youtube-api:loaded'));
}

function initYouTubeIframe(section = document) {
    let youTubeVideos = section.querySelectorAll(".yvYoutubeAutoPlayvVideo");
    Array.from(youTubeVideos).forEach(function(video) {
        let divId = video.getAttribute("id");
        let vidId = video.dataset.id;
        if (!window["YT"]) {
            document.addEventListener('on:youtube-api:loaded', function() { youTubeVideoReady(divId, vidId) });
            youtTubeScriptLoad();
        } else {
            youTubeVideoReady(divId, vidId);
        }
    });
}

function youTubeVideoReady(divId, vidId) {
    YT.ready(() => {
        let player = new YT.Player(divId, {
            videoId: vidId,
            playerVars: {
                showinfo: 0,
                controls: 0,
                fs: 0,
                rel: 0,
                height: "100%",
                width: "100%",
                iv_load_policy: 3,
                html5: 1,
                loop: 1,
                autoplay: 1,
                playsinline: 1,
                modestbranding: 1,
                disablekb: 1,
                wmode: "opaque",
            },
            events: {
                onReady: onPlayerReady,
                onStateChange: onPlayerStateChange,
            },
        });
    });
}

function onPlayerReady(event) {
    event.target.mute();
    event.target.playVideo();
}
let done = false;

function onPlayerStateChange(event) {
    if (event.data == 0) {
        event.target.playVideo();
    }
}

/* Accordion panels own their animation task; unrelated DOMAnimations stay unchanged. */
var upvAccordionAnimations = new WeakMap();

function animateAccordionContent(element, expanded) {
    if (!element) return;
    var previous = upvAccordionAnimations.get(element);
    if (previous && previous.expanded === expanded) return;

    var owner = element.parentNode;
    var details = owner && owner.tagName === "DETAILS" ? owner : null;
    var header = owner && owner.querySelector(".yv-accordion-header");
    var computed = window.getComputedStyle(element);
    var visible = computed.display !== "none" && (!details || details.hasAttribute("open"));
    if (!previous && !expanded && !visible) {
        if (details) details.removeAttribute("open");
        return;
    }

    var spacing = ["padding-top", "padding-bottom", "margin-top", "margin-bottom"];
    var properties = ["height", "overflow", "transition-property", "transition-duration"].concat(spacing);
    var startSpacing = spacing.map(function(property) {
        return visible ? computed.getPropertyValue(property) : "0px";
    });
    var startHeight = visible ? element.getBoundingClientRect().height : 0;
    if (visible && computed.boxSizing !== "border-box") {
        startHeight -= parseFloat(computed.paddingTop) + parseFloat(computed.paddingBottom) +
            parseFloat(computed.borderTopWidth) + parseFloat(computed.borderBottomWidth);
    }
    var original = previous ? previous.original : properties.map(function(property) {
        return [property, element.style.getPropertyValue(property), element.style.getPropertyPriority(property)];
    });
    if (previous) window.clearTimeout(previous.timer);
    var task = { expanded: expanded, original: original, timer: null };
    upvAccordionAnimations.set(element, task);

    function restoreStyles() {
        original.forEach(function(entry) {
            if (entry[1]) element.style.setProperty(entry[0], entry[1], entry[2]);
            else element.style.removeProperty(entry[0]);
        });
    }

    restoreStyles();
    element.style.transitionProperty = "none";
    if (details) details.setAttribute("open", "");
    element.style.removeProperty("display");
    var display = window.getComputedStyle(element).display;
    element.style.display = display === "none" ? "block" : display;
    computed = window.getComputedStyle(element);
    var targetSpacing = spacing.map(function(property) {
        return expanded ? computed.getPropertyValue(property) : "0px";
    });
    var targetHeight = expanded ? element.getBoundingClientRect().height : 0;
    if (expanded && computed.boxSizing !== "border-box") {
        targetHeight -= parseFloat(computed.paddingTop) + parseFloat(computed.paddingBottom) +
            parseFloat(computed.borderTopWidth) + parseFloat(computed.borderBottomWidth);
    }

    element.style.height = Math.max(0, startHeight) + "px";
    element.style.overflow = "hidden";
    spacing.forEach(function(property, index) {
        element.style.setProperty(property, startSpacing[index]);
    });
    element.offsetHeight;
    element.style.transitionProperty = "height, margin, padding";
    element.style.transitionDuration = "500ms";
    element.style.height = Math.max(0, targetHeight) + "px";
    spacing.forEach(function(property, index) {
        element.style.setProperty(property, targetSpacing[index]);
    });

    task.timer = window.setTimeout(function() {
        if (upvAccordionAnimations.get(element) !== task) return;
        if (!expanded) {
            element.style.display = "none";
            if (details && header && !header.classList.contains("active")) details.removeAttribute("open");
        }
        restoreStyles();
        upvAccordionAnimations.delete(element);
    }, 500);
}

function tabAccordionContent() {
    var tabHead = document.getElementsByClassName("yv-tab-product-item");
    if (tabHead.length > 0) {
        tabHead[0].classList.add("active");
        var tabContent = document.getElementsByClassName("yv-product-detail-tab");
        tabContent[0].style.display = "block";

        Array.from(tabHead).forEach(function(btn) {
            btn.addEventListener("click", (event) => {
                event.preventDefault();
                Array.from(tabHead).forEach(function(item) {
                    item.classList.remove("active");
                });
                Array.from(tabContent).forEach(function(item) {
                    item.style.display = "none";
                });
                btn.classList.add("active");
                var _value = btn.getAttribute("content");
                document.getElementById(_value).style.display = "block";
            });
        });
    }
    var accordionHead = document.getElementsByClassName("yv-accordion-header");
    if (accordionHead.length > 0) {
        var accordionContent = document.getElementsByClassName(
            "yv-accordion-content"
        );

        Array.from(accordionHead).forEach(function(btn) {
            if (btn.dataset.upvAccordionBound === "true") return;
            btn.dataset.upvAccordionBound = "true";
            if (btn.parentNode.tagName === "DETAILS" && btn.parentNode.hasAttribute("open")) {
                btn.classList.add("active");
            }
            btn.addEventListener("click", (event) => {
                event.preventDefault();
                let _section = btn.closest('.shopify-section')
                var accordionScope = btn.closest('.shopify-section.faq-section');
                if (btn.classList.contains("active")) {
                    if (btn.parentNode.tagName !== "DETAILS") btn.parentNode.removeAttribute("open");
                    clearAccordion(null, null, accordionScope);
                } else {
                    btn.classList.add("active");
                    btn.parentNode.setAttribute("open", "");
                    var _value = btn.getAttribute("content");
                    clearAccordion(btn, document.getElementById(_value), accordionScope);
                    animateAccordionContent(document.getElementById(_value), true);
                    var _media = btn.getAttribute("media");
                    if (_section && document.getElementById(_media) && !document.getElementById(_media).classList.contains('active')) {
                        if (_section.querySelector('.tabbed-collage-image.active')) {
                            _section.querySelector('.tabbed-collage-image.active').fadeOut(100)
                            _section.querySelector('.tabbed-collage-image.active').classList.remove('active')
                            setTimeout(function() {
                                document.getElementById(_media).fadeIn(100)
                                document.getElementById(_media).classList.add('active')
                            }, 100)
                        }
                    }
                }
            });
        });
    }
}

function clearAccordion(currentHead, currentContent, scope) {
    var accordionRoot = scope || document;
    var accordionHeads = accordionRoot.getElementsByClassName("yv-accordion-header");
    var accordionContents = accordionRoot.getElementsByClassName(
        "yv-accordion-content"
    );
    Array.from(accordionHeads).forEach(function(item) {
        if (item == currentHead) {
            return;
        } else {
            item.classList.remove("active");
        }
    });
    Array.from(accordionContents).forEach(function(item) {
        if (item == currentContent) {
            return;
        } else {
            animateAccordionContent(item, false);
        }
    });
}

var mapSelectors = "[data-map-container]";
var apiloaded = null;

function initMaps() {
    jQuery(mapSelectors).each(function(index, selector) {
        createMap(selector);
    });
}

function checkMapApi(selector) {
    if (selector || jQuery(mapSelectors).length > 0) {
        if (apiloaded === "loaded") {
            if (selector) {
                createMap(selector);
            } else {
                initMaps();
            }
        } else {
            if (apiloaded !== "loading") {
                apiloaded = "loading";
                if (
                    typeof window.google === "undefined" ||
                    typeof window.google.maps === "undefined"
                ) {
                    var script = document.createElement("script");
                    script.onload = function() {
                        apiloaded = "loaded";
                        if (selector) {
                            createMap(selector);
                        } else {
                            initMaps();
                        }
                    };
                    script.src =
                        "https://maps.googleapis.com/maps/api/js?key=" + googleMapApiKey;
                    document.head.appendChild(script);
                }
            }
        }
    }
}

function createMap(selector) {
    var geocoder = new google.maps.Geocoder();
    var address = jQuery(selector).data("location");
    var mapStyle = jQuery(selector).data("map-style");
    geocoder.geocode({ address: address }, function(results, status) {
        if (results != null) {
            var options = {
                zoom: 17,
                backgroundColor: "none",
                center: results[0].geometry.location,
                mapTypeId: mapStyle,
            };
            var map = (this.map = new google.maps.Map(selector, options));
            var center = (this.center = map.getCenter());
            var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter(),
            });
            google.maps.event.addDomListener(window, "resize", function() {
                setTimeout(function() {
                    google.maps.event.trigger(map, "resize");
                    map.setCenter(center);
                }, 250);
            });
        }
    });
}

var dealCountdownTimers = new Map();

function clearDealCountdown(section) {
    var root = typeof section === "string" ? document.getElementById(section) : section;
    if (!root) {
        return;
    }

    dealCountdownTimers.forEach(function(timer, parent) {
        if (parent === root || root.contains(parent)) {
            clearInterval(timer);
            dealCountdownTimers.delete(parent);
        }
    });
}

var dealSection = function(selector) {
    const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;
    var parent = typeof selector === "string" ? document.getElementById(selector) : selector;

    if (!parent) {
        return;
    }

    clearDealCountdown(parent);

    var dateSelector = parent.querySelector(".dealDate");
    var daySelector = parent.querySelector("#dDays");
    var hourSelector = parent.querySelector("#dHours");
    var minSelector = parent.querySelector("#dMinutes");
    var secSelector = parent.querySelector("#dSeconds");

    if (!dateSelector || !daySelector || !hourSelector || !minSelector || !secSelector) {
        return;
    }

    const myArr = dateSelector.value.split("/");
    let _day = myArr[0];
    let _month = myArr[1];
    let _year = myArr[2];
    let _date = _month + "/" + _day + "/" + _year + " 00:00:00";
    let countDown = new Date(_date).getTime();

    function updateDealCountdown() {
        if (parent.isConnected === false) {
            clearDealCountdown(parent);
            return;
        }

        let now = new Date().getTime(),
            distance = countDown - now;
        var leftDays = Math.floor(distance / day);

        if (distance > 0) {
            daySelector.innerText = pad2(leftDays);
            hourSelector.innerText = pad2(Math.floor((distance % day) / hour));
            minSelector.innerText = pad2(Math.floor((distance % hour) / minute));
            secSelector.innerText = pad2(Math.floor((distance % minute) / second));
            return;
        }

        let hideStatus = parent.getAttribute("data-hide-section");
        if (hideStatus == "true") {
            parent.style.display = "none";
        }
        daySelector.innerText = "00";
        hourSelector.innerText = "00";
        minSelector.innerText = "00";
        secSelector.innerText = "00";
        clearDealCountdown(parent);
    }

    updateDealCountdown();
    if (parent.isConnected !== false && countDown > new Date().getTime()) {
        dealCountdownTimers.set(parent, setInterval(updateDealCountdown, second));
    }
};

function clearActive(currentHead, currentContent) {
    var tabs = document.getElementsByClassName("faqSection-header");
    var tabsContent = document.getElementsByClassName("faqSection-content");
    Array.from(tabs).forEach(function(item) {
        var iconPlus = item.querySelector(".iconPlus");
        var iconMinus = item.querySelector(".iconMinus");
        if (item == currentHead) {
            return;
        } else {
            iconMinus.style.display = "none";
            iconPlus.style.display = "inline";
            item.classList.remove("active");
        }
    });
    Array.from(tabsContent).forEach(function(item) {
        if (item == currentContent) {
            return;
        } else {
            DOMAnimations.slideUp(item);
        }
    });
}

function quantityChange() {
    jQuery(".quantity:not(.cart-item-quantity)").each(function() {
        var spinner = jQuery(this),
            input = spinner.find('input[type="number"]'),
            btnUp = spinner.find(".quantity-up"),
            btnDown = spinner.find(".quantity-down"),
            min = input.attr("min"),
            max = input.attr("max");

        btnUp.off("click.upvQuantity").on("click.upvQuantity", function(e) {
            e.preventDefault();
            var oldValue = parseFloat(input.val());
            if (oldValue >= max) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue + 1;
            }
            spinner.find("input").val(newVal);
            spinner.find("input").trigger("change");
        });

        btnDown.off("click.upvQuantity").on("click.upvQuantity", function(e) {
            e.preventDefault();
            var oldValue = parseFloat(input.val());
            if (oldValue <= min) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue - 1;
            }
            spinner.find("input").val(newVal);
            spinner.find("input").trigger("change");
        });
    });
}


function syncTabbedCollectionSelection(filterItem) {
    var filterGroup = filterItem && filterItem.parentElement;
    if (!filterGroup || !filterGroup.children) return;

    Array.from(filterGroup.children).forEach(function(item) {
        if (!item.classList || !item.classList.contains("filter-products")) return;
        var button = item.querySelector && item.querySelector("button.yv-tab-link");
        if (!button) return;
        button.setAttribute("aria-pressed", item === filterItem ? "true" : "false");
    });
}

function sliderFilter() {
    $("body")
      .off("click.upvSliderFilter", ".filter-products")
      .on("click.upvSliderFilter", ".filter-products", function(e) {
        e.preventDefault();
        if (!$(this).hasClass("active")) {
            syncTabbedCollectionSelection(this);
            $(this).siblings().removeClass("active");
            $(this).addClass("active");
            $(this).closest(".shopify-section").find(".yv-tab-btn-pane").attr('data-tab-active', $(this).attr('data-tab-button'));
            let selectedCollection = $(this).data("filter");
            let selector = $(this)
                .closest(".shopify-section")
                .find(".yv-tabbed-collection-filter-items");
            if (selector.hasClass("flickity-enabled")) {
                selector.flickity("destroy");
            }
            selector.find(".filter-slide").removeClass("active").hide();
            selector.find(".filter-slide .aos-init").removeClass("aos-animate");
            // selector.find('.filter-slide').css('visibility', 'hidden').css('animation-name', 'none')
            selector
                .find(".filter-slide." + selectedCollection)
                .addClass("active")
                .show();

            // if ($(window).width() > 767) {
            flickitySlider(selector);
            // }
            selector
                .find(".filter-slide." + selectedCollection + " .aos-init")
                .addClass("aos-animate");
            // selector.find('.filter-slide.' + selectedCollection).addClass('animated').css('visibility', 'visible').css('animation-name', 'fadeIn');
            setTimeout(function() {}, 200);
        }
      });
}

function closeOpenSizeChartModel() {
    var body = document.body;
    if (!body || !body.classList.contains("sizeChartOpen")) return;
    body.classList.remove("sizeChartOpen");
    var sizeChartModel = document.getElementById("sizeChartModel");
    if (sizeChartModel) {
        $(sizeChartModel).stop(true, true).hide();
    }
}

function isNativeQuickViewSharedDrawer(drawer) {
    return Boolean(
        drawer &&
        drawer.id === "yv_quickView_product" &&
        drawer.classList.contains("yv_quickView_product")
    );
}

function getSimilarDrawerReturnTrigger(drawer) {
    if (!drawer) return null;
    var requestState = upvVariantLifecycle.similarDrawerRequests.get(drawer);
    return requestState && requestState.trigger ?
        requestState.trigger : drawer.upvSimilarDrawerTrigger;
}

function releaseSimilarDrawerOverlay(requestState, sharedDrawer) {
    if (
        !requestState ||
        !requestState.overlayClaimed ||
        !requestState.overlay ||
        requestState.overlay.isConnected === false ||
        cartDrawerOwnsWrapperOverlay(sharedDrawer)
    ) {
        return false;
    }
    if (requestState.overlay.style) {
        requestState.overlay.style.display =
            requestState.overlayPreviousInlineDisplay || "";
    } else {
        $(requestState.overlay).hide();
    }
    requestState.overlayClaimed = false;
    return true;
}

function closeSimilarDrawer(drawer, expectedRequest) {
    if (!drawer) return false;
    var currentRequest = upvVariantLifecycle.similarDrawerRequests.get(drawer);
    if (expectedRequest && currentRequest !== expectedRequest) return false;
    var returnFocusTarget = getSimilarDrawerReturnTrigger(drawer);
    cancelSimilarDrawerRequest(drawer, expectedRequest);

    var drawerBody = drawer.querySelector("[data-similar-drawer-body]");
    if (drawerBody) drawerBody.innerHTML = "";
    drawer.classList.remove("searching");
    drawer.querySelectorAll(".yv-upsell-drawer").forEach(
        function(upsellDrawer) {
            upsellDrawer.classList.remove("active");
        }
    );
    document.body.classList.remove("similar_Drawer_open");

    var releasedSimilarFocus = stopFocusElementsRotation(drawer);
    var sharedDrawer = document.querySelector("[data-side-drawer]");
    var sharedDrawerIsOpen = isSharedDrawerFocusSurfaceOpen(sharedDrawer);
    var canRestoreFocus = releasedSimilarFocus || !focusElementsList.wrapper;
    if (canRestoreFocus && sharedDrawerIsOpen) {
        focusElementsRotation($(sharedDrawer));
        if (
            returnFocusTarget &&
            returnFocusTarget.isConnected !== false &&
            typeof sharedDrawer.contains === "function" &&
            sharedDrawer.contains(returnFocusTarget) &&
            typeof returnFocusTarget.focus === "function"
        ) {
            returnFocusTarget.focus();
        } else {
            $(sharedDrawer).trigger("focus");
        }
    } else if (
        canRestoreFocus &&
        returnFocusTarget &&
        returnFocusTarget.isConnected !== false &&
        typeof returnFocusTarget.focus === "function"
    ) {
        returnFocusTarget.focus();
    }
    releaseSimilarDrawerOverlay(currentRequest, sharedDrawer);
    drawer.upvSimilarDrawerTrigger = null;
    return true;
}

function upvanityFocusSearchReturnTarget(target) {
    var element = target && (target.nodeType === 1 ? target : target[0]);
    if (!element || typeof element.matches !== "function" ||
        !element.matches("a.search-form[data-search-drawer]")) return false;
    if (element.isConnected === false || typeof element.focus !== "function" ||
        element.closest("[hidden], [inert]") || !element.getClientRects().length) return true;
    var style = window.getComputedStyle(element);
    if (style.visibility === "hidden" || style.visibility === "collapse") return true;
    element.focus({ preventScroll: true });
    return true;
}

function removeClasses() {
    closeOpenSizeChartModel();
    var similarDrawer = document.querySelector("[data-similar-product-drawer]");
    var similarDrawerWasOpen = Boolean(
        similarDrawer &&
        document.body.classList.contains("similar_Drawer_open")
    );
    var similarDrawerReturnTarget = null;
    if (similarDrawer) {
        similarDrawerReturnTarget = getSimilarDrawerReturnTrigger(similarDrawer);
        cancelSimilarDrawerRequest(similarDrawer);
    }
    var quickViewDrawer = document.querySelector("[data-side-drawer]");
    var quickViewDrawerWasOpen = isNativeQuickViewSharedDrawer(quickViewDrawer);
    if (quickViewDrawer) {
        cancelSharedDrawerOwnership(quickViewDrawer);
        hideQuickViewLoader();
        var quickViewDrawerBody = quickViewDrawer.querySelector(
            "[data-drawer-body]"
        );
        if (quickViewDrawerBody) {
            quickViewDrawerBody.classList.remove("searching");
        }
    }
    if (quickViewDrawerWasOpen) {
        cancelQuickViewRequest(quickViewDrawer);
        disposeProductVariantLifecycle(quickViewDrawer);
    }
    $("body")
        .removeClass("similar_Drawer_open")
        .removeClass("side_Drawer_open")
        .removeClass("catalog-open")
        .removeClass("yv_side_Drawer_open")
        .removeClass("active_askme")
        .removeClass("scrollHidden")
        .removeClass("quickview-open")
        .removeClass("nav-open")
        .removeClass("addsearch")
        .removeClass("minicart-open")
        .removeClass("customer-open")
        .removeClass("NewsletterActive")
        .removeClass("show__similar__products")
        .removeClass("offer-open")
        .removeClass("mega-menu-open")
        .removeClass("open-filter-sort")
        .removeClass("sizeChartOpen");
      

    $(".yv-upsell-drawer").removeClass("active");
    $(".yv-coupan-sidebar").removeClass("open");
    $(".wrapper-overlay").hide();
    if (!$("input.form-control.search-input").hasClass("yv-search-bar")) {
        $("input.form-control.search-input").val("");
    }
    $(".yv-search-result-container").empty();
    setTimeout(function() {
        $(".yv-newsletter-popup").fadeOut("slow");
    }, 200);
    if ($(window).width() > 767) {
        $(".askmeMain").hide().removeClass("slideAskme");
    } else {
        $(".askmeMain.slideAskme").removeClass("slideAskme");
        setTimeout(function() {
            $(".askmeMain").hide();
        }, 250);
    }
    $(".dropdown-menu-list").removeClass("open");
    $(".toggle-level,.list-menu__item.toggle").removeClass("open-menu-drop");
    $(".side-menu").find(".inner").removeClass("is-open");
    $(".side-menu").find(".inner").slideUp("slow");
    if ($(window).width() < 768) {
        $("#sort__list").removeClass("active");
    } else {
        $("#sort__list").slideUp();
    }
    $("body").removeClass("side_Drawer_open");
    stopFocusElementsRotation();
    if (focusElement) {
        var searchReturnTarget = focusElement;
        if (upvanityFocusSearchReturnTarget(searchReturnTarget)) {
            if (focusElement === searchReturnTarget) focusElement = "";
        } else {
            if (focusElement.nodeType || focusElement == window) {
                focusElement.focus();
            } else {
                focusElement.trigger("focus");
            }
            focusElement = "";
        }
    } else if (
        similarDrawerWasOpen &&
        similarDrawerReturnTarget &&
        similarDrawerReturnTarget.isConnected !== false &&
        typeof similarDrawerReturnTarget.focus === "function"
    ) {
        similarDrawerReturnTarget.focus();
    }
    if (similarDrawer) similarDrawer.upvSimilarDrawerTrigger = null;
    if (quickViewDrawerWasOpen) {
        quickViewDrawer.upvQuickViewTrigger = null;
    }
}

function closeVideoMedia(quickView) {
    document.querySelectorAll(".yv-youtube-video").forEach((video) => {
        if (!isOnScreen(video) || quickView) {
            video.contentWindow.postMessage(
                '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
                "*"
            );
        }
    });
    document.querySelectorAll(".yv-vimeo-video").forEach((video) => {
        if (!isOnScreen(video) || quickView) {
            video.contentWindow.postMessage('{"method":"pause"}', "*");
        }
    });
    document.querySelectorAll("video").forEach((video) => {
        if (!video.classList.contains("videoBackgroundFile")) {
            if (!isOnScreen(video) || quickView) {
                video.pause();
            }
        }
    });
}

function hideAllMenu(selectMenu) {
    var dropDownMenus = document.getElementsByClassName("yv-dropdown-detail");
    if (dropDownMenus.length > 0) {
        Array.from(dropDownMenus).forEach(function(menu) {
            if (selectMenu != menu) {
                menu.removeAttribute("open");
            }
            menu.classList.remove("open");
        });
    }
}

const ease = {
    exponentialIn: (t) => {
        return t == 0.0 ? t : Math.pow(2.0, 10.0 * (t - 1.0));
    },
    exponentialOut: (t) => {
        return t == 1.0 ? t : 1.0 - Math.pow(2.0, -10.0 * t);
    },
    exponentialInOut: (t) => {
        return t == 0.0 || t == 1.0 ?
            t :
            t < 0.5 ?
            +0.5 * Math.pow(2.0, 20.0 * t - 10.0) :
            -0.5 * Math.pow(2.0, 10.0 - t * 20.0) + 1.0;
    },
    sineOut: (t) => {
        const HALF_PI = 1.5707963267948966;
        return Math.sin(t * HALF_PI);
    },
    circularInOut: (t) => {
        return t < 0.5 ?
            0.5 * (1.0 - Math.sqrt(1.0 - 4.0 * t * t)) :
            0.5 * (Math.sqrt((3.0 - 2.0 * t) * (2.0 * t - 1.0)) + 1.0);
    },
    cubicIn: (t) => {
        return t * t * t;
    },
    cubicOut: (t) => {
        const f = t - 1.0;
        return f * f * f + 1.0;
    },
    cubicInOut: (t) => {
        return t < 0.5 ? 4.0 * t * t * t : 0.5 * Math.pow(2.0 * t - 2.0, 3.0) + 1.0;
    },
    quadraticOut: (t) => {
        return -t * (t - 2.0);
    },
    quarticOut: (t) => {
        return Math.pow(t - 1.0, 3.0) * (1.0 - t) + 1.0;
    },
};
//  wave animation code start
class ShapeOverlays {
    constructor(elm) {
        this.elm = elm;
        this.path = elm.querySelectorAll("path");
        this.numPoints = 2;
        this.duration = 600;
        this.delayPointsArray = [];
        this.delayPointsMax = 0;
        this.delayPerPath = 200;
        this.timeStart = Date.now();
        this.isOpened = false;
        this.isAnimating = false;
        this.animationFrame = null;
        this.destroyed = false;
    }

    toggle() {
        if (this.destroyed) return;
        this.isAnimating = true;
        for (var i = 0; i < this.numPoints; i++) {
            this.delayPointsArray[i] = 0;
        }
        if (this.isOpened === false) {
            this.open();
        } else {
            this.close();
        }
    }
    open() {
        this.isOpened = true;
        this.elm.classList.add("is-opened");
        this.timeStart = Date.now();
        this.renderLoop();
    }
    close() {
        this.isOpened = false;
        this.elm.classList.remove("is-opened");
        this.timeStart = Date.now();
        this.renderLoop();
    }

    updatePath(time) {
        const points = [];

        for (var i = 0; i < this.numPoints; i++) {
            const thisEase = this.isOpened ?
                i == 1 ?
                ease.cubicOut :
                ease.cubicInOut :
                i == 1 ?
                ease.cubicInOut :
                ease.cubicOut;
            points[i] =
                thisEase(
                    Math.min(
                        Math.max(time - this.delayPointsArray[i], 0) / this.duration,
                        1
                    )
                ) * 100;
        }

        let str = "";
        str += this.isOpened ? `M 0 0 V ${points[0]} ` : `M 0 ${points[0]} `;
        for (var i = 0; i < this.numPoints - 1; i++) {
            const p = ((i + 1) / (this.numPoints - 1)) * 100;
            const cp = p - ((1 / (this.numPoints - 1)) * 100) / 2;
            str += `C ${cp} ${points[i]} ${cp} ${points[i + 1]} ${p} ${points[i + 1]
        } `;
        }
        str += this.isOpened ? `V 0 H 0` : `V 100 H 0`;
        return str;
    }

    render() {
        if (this.isOpened) {
            for (var i = 0; i < this.path.length; i++) {
                this.path[i].setAttribute(
                    "d",
                    this.updatePath(Date.now() - (this.timeStart + this.delayPerPath * i))
                );
            }
        } else {
            for (var i = 0; i < this.path.length; i++) {
                this.path[i].setAttribute(
                    "d",
                    this.updatePath(
                        Date.now() -
                        (this.timeStart + this.delayPerPath * (this.path.length - i - 1))
                    )
                );
            }
        }
    }
    renderLoop() {
        if (this.destroyed) return;
        this.render();
        if (
            Date.now() - this.timeStart <
            this.duration +
            this.delayPerPath * (this.path.length - 1) +
            this.delayPointsMax
        ) {
            this.animationFrame = requestAnimationFrame(() => {
                this.animationFrame = null;
                this.renderLoop();
            });
        } else {
            this.isAnimating = false;
            this.animationFrame = null;
        }
    }

    destroy() {
        this.destroyed = true;
        this.isAnimating = false;
        if (this.animationFrame !== null) {
            cancelAnimationFrame(this.animationFrame);
            this.animationFrame = null;
        }
    }
}

const UPVANITY_CLOSE_DRAWER_GUARD_SELECTOR = ".yv-filter-sidebar,.yv-discount-panel,.yv-newsletter-popup-outer,.customer-links,.acc-sign-in,[data-account-dropdown],.customer-support,.yv-login-popup-inner,.yv-newsletter-popup-content,.yv-browse-category,.yv-addon-button-wrapper-card,.sizeChart-label,.sizeChart-main,.offer-open,.yv-product-slider-item,.navbar-toggler,.similar_options,.openCartDrawer,.yv-coupan-sidebar,.dropdown-menu-list,.ask_this_product,.yv_similar_drawer_wrapper,#toolbox-sort,#sort__list,.yv_side_drawer_wrapper,.askmecontainer,.search-bar-container,.search-form,.yv-newsletter-popup-body,.side-menu,#filterSideBar";

function createUpvanityLegacyInteractionController() {
    const closeDrawerGuardBindings = new WeakMap();
    const menuGuardBindings = new WeakMap();
    const navigationBindings = new WeakMap();
    const hoveredCloseDrawerGuards = new Set();
    const hoveredMenuGuards = new Set();
    let closeDrawerBody = null;
    let hamburgerDelegationBody = null;
    let hamburgerBinding = null;
    const pendingEscapeTimers = new Set();

    function isConnected(element) {
        if (!element) return false;
        if (typeof element.isConnected === "boolean") return element.isConnected;
        return Boolean(
            document.documentElement &&
            document.documentElement.contains &&
            document.documentElement.contains(element)
        );
    }

    function elementsInScope(scope, selector) {
        let root = scope && scope.querySelectorAll ? scope : document;
        let elements = [];
        if (root.nodeType === 1 && root.matches && root.matches(selector)) {
            elements.push(root);
        }
        Array.from(root.querySelectorAll(selector)).forEach(function(element) {
            if (elements.indexOf(element) === -1) elements.push(element);
        });
        return elements;
    }

    function allElementsInScope(scope) {
        let root = scope && scope.querySelectorAll ? scope : document;
        let elements = [];
        if (root.nodeType === 1) elements.push(root);
        Array.from(root.querySelectorAll("*")).forEach(function(element) {
            elements.push(element);
        });
        return elements;
    }

    function scopeContains(scope, element) {
        if (!scope || !element) return false;
        if (scope === document || scope === element) return true;
        return Boolean(scope.contains && scope.contains(element));
    }

    function updateCloseDrawerHoverState() {
        mouse_is_inside = hoveredCloseDrawerGuards.size > 0;
    }

    function removeHoverBinding(element, bindings, hovered, namespace) {
        if (!bindings.has(element)) return;
        $(element).off(namespace);
        bindings.delete(element);
        hovered.delete(element);
        updateCloseDrawerHoverState();
    }

    function bindHoverGuard(element, bindings, hovered, namespace) {
        if (bindings.has(element)) return;
        let enter = function() {
            hovered.add(element);
            updateCloseDrawerHoverState();
        };
        let leave = function() {
            hovered.delete(element);
            updateCloseDrawerHoverState();
        };
        $(element)
            .on("mouseenter" + namespace, enter)
            .on("mouseleave" + namespace, leave);
        bindings.set(element, { enter: enter, leave: leave });
    }

    function removeNavigationBinding(menu) {
        let binding = navigationBindings.get(menu);
        if (!binding) return;
        binding.events.forEach(function(item) {
            menu.removeEventListener(item.type, item.handler);
        });
        navigationBindings.delete(menu);
    }

    function removeHamburgerDelegates() {
        if (!hamburgerDelegationBody) return;
        $(hamburgerDelegationBody).off(".upvLegacyHamburger");
        hamburgerDelegationBody = null;
    }

    function clearHamburgerTimers(binding) {
        if (!binding) return;
        binding.timers.forEach(function(timer) {
            clearTimeout(timer);
        });
        binding.timers.clear();
    }

    function removeHamburgerBinding() {
        if (!hamburgerBinding) return;
        clearHamburgerTimers(hamburgerBinding);
        hamburgerBinding.hamburger.removeEventListener("click", hamburgerBinding.clickHandler);
        if (
            hamburgerBinding.overlay &&
            typeof hamburgerBinding.overlay.destroy === "function"
        ) {
            hamburgerBinding.overlay.destroy();
        }
        hamburgerBinding.hamburger.classList.remove("opened");
        hamburgerBinding.overlayElement.classList.remove("is-opened");
        let body = document.querySelector("body");
        if (body) body.classList.remove("hamburder-opened");
        hamburgerBinding = null;
        removeHamburgerDelegates();
    }

    function cleanupDisconnectedBindings() {
        Array.from(hoveredCloseDrawerGuards).forEach(function(element) {
            if (!isConnected(element)) hoveredCloseDrawerGuards.delete(element);
        });
        Array.from(hoveredMenuGuards).forEach(function(element) {
            if (!isConnected(element)) hoveredMenuGuards.delete(element);
        });
        if (
            hamburgerBinding &&
            (!isConnected(hamburgerBinding.hamburger) ||
                !isConnected(hamburgerBinding.overlayElement))
        ) {
            removeHamburgerBinding();
        }
        updateCloseDrawerHoverState();
    }

    function closeDrawerIsHovered() {
        cleanupDisconnectedBindings();
        return hoveredCloseDrawerGuards.size > 0;
    }

    function menuIsHovered() {
        cleanupDisconnectedBindings();
        return hoveredMenuGuards.size > 0;
    }

    function handleBodyClick(event) {
        if (!closeDrawerIsHovered()) {
            setTimeout(function() {
                if (
                    window.location.href.indexOf("#mobileMenu") > -1 ||
                    window.location.href.indexOf("#header") > -1
                ) {
                    let url = window.location.href.replace("#mobileMenu", "");
                    url = url.replace("#header", "");
                    history.replaceState({}, null, url);
                }
            }, 100);
            $(".yv-discount-sidebar-element").hide();
        }

        if (
            $(this).hasClass("offer-open") &&
            !$(".yv-coupan-sidebar-element").hasClass("open")
        ) {
            return false;
        }

        let clickedMenu =
            event.target && event.target.closest ?
            event.target.closest(".yv-dropdown-detail") :
            null;
        if (!clickedMenu && !menuIsHovered()) {
            $(".yv-dropdown-detail").removeAttr("open");
            $(".yv-dropdown-detail").removeClass("open");
            stopFocusElementsRotation();
        }
    }

    function handleBodyMouseup(event) {
        if (
            $(this).hasClass("offer-open") &&
            !$(".yv-coupan-sidebar-element").hasClass("open")
        ) {
            return false;
        } else {
            $("body").removeClass("offer-open");
            $(".yv-coupan-sidebar-element").removeClass("open");
        }
        var sizeChartTarget =
            event.target && event.target.closest ?
            event.target.closest(".sizeChart-label,.sizeChart-main") :
            null;
        if (!closeDrawerIsHovered() && !sizeChartTarget) {
            if (document.querySelector("[data-account-dropdown]")) {
                DOMAnimations.slideUp(document.querySelector("[data-account-dropdown]"));
            }
            let storeDetailsContent = document.querySelectorAll("[data-store-location-dropdown]");
            Array.from(storeDetailsContent).forEach(function(content) {
                DOMAnimations.slideUp(content);
            });
            if (document.querySelector("[data-account-popup]")) {
                $("body").removeClass("account-popup-open");
            }
            $("#view-catalog").hide();
            removeClasses();
            closeVideoMedia("quickView");
        }

        var isHovered = $(".yv-addon-button-wrapper-card").filter(function() {
            return $(this).is(":hover");
        });
        if (!menuIsHovered() && !isHovered) {
            $(".yv-addon-button-wrapper").hide();
            $("body").removeClass("query-form-open");
        }
    }

    function eventWasPrevented(event, originalEvent) {
        return Boolean(
            (originalEvent && originalEvent.defaultPrevented) ||
            event.defaultPrevented ||
            (typeof event.isDefaultPrevented === "function" && event.isDefaultPrevented())
        );
    }

    function performLegacyEscapeCleanup() {
        closeVideoMedia("quickView");
        if (document.querySelector(".hamburger.opened")) {
            document.querySelector(".hamburger.opened").click();
        }
        $(".yv-upsell-drawer").removeClass("active");
        $("body").removeClass("offer-open");
        $(".yv-coupan-sidebar-element").removeClass("open");
        $(".super_active").removeClass("super_active");
        $(".yv-dropdown-detail").removeAttr("open");
        $(".yv-dropdown-detail").removeClass("open");
        $("#password-popup").fadeOut();
        $("body").removeClass("PasswordFormActive");
        removeClasses();
    }

    function handleBodyKeydown(event) {
        if (event.keyCode != 27) return;
        let originalEvent = event.originalEvent || event;
        if (eventWasPrevented(event, originalEvent)) return;
        let timer = setTimeout(function() {
            pendingEscapeTimers.delete(timer);
            if (eventWasPrevented(event, originalEvent)) return;
            performLegacyEscapeCleanup();
        }, 0);
        pendingEscapeTimers.add(timer);
    }

    function ensureCloseDrawerBodyBindings() {
        let body = document.querySelector("body");
        if (!body) return;
        if (closeDrawerBody === body) return;
        if (closeDrawerBody) $(closeDrawerBody).off(".upvLegacyCloseDrawers");
        closeDrawerBody = body;
        $(closeDrawerBody)
            .on("click.upvLegacyCloseDrawers", handleBodyClick)
            .on("mouseup.upvLegacyCloseDrawers", handleBodyMouseup)
            .on("keydown.upvLegacyCloseDrawers", handleBodyKeydown);
    }

    function ensureHamburgerDelegates() {
        let body = document.querySelector("body");
        if (!body || hamburgerDelegationBody === body) return;
        removeHamburgerDelegates();
        hamburgerDelegationBody = body;
        $(hamburgerDelegationBody).on(
            "click.upvLegacyHamburger",
            ".dropdown-hamburger-menu-item-title",
            function(event) {
                event.preventDefault();
                $(this).closest(".dropdown-hamburger-menu-item").addClass("active");
                $(this).parent().parent().parent().addClass("super_active");
            }
        );
        $(hamburgerDelegationBody).on(
            "click.upvLegacyHamburger",
            ".back-to-menu",
            function(event) {
                event.preventDefault();
                $(this).closest(".dropdown-hamburger-menu-item").removeClass("active");
                $(this).closest(".super_active").removeClass("super_active");
            }
        );
    }

    function refreshCloseDrawers(scope = document) {
        cleanupDisconnectedBindings();
        elementsInScope(scope, UPVANITY_CLOSE_DRAWER_GUARD_SELECTOR).forEach(
            function(element) {
                bindHoverGuard(
                    element,
                    closeDrawerGuardBindings,
                    hoveredCloseDrawerGuards,
                    ".upvLegacyCloseDrawerGuard"
                );
            }
        );
        elementsInScope(scope, ".dropdown-menu-item").forEach(function(element) {
            bindHoverGuard(
                element,
                menuGuardBindings,
                hoveredMenuGuards,
                ".upvLegacyMenuGuard"
            );
        });
        ensureCloseDrawerBodyBindings();
    }

    function refreshNavigation(scope = document) {
        cleanupDisconnectedBindings();
        elementsInScope(scope, "header").forEach(function(header) {
            let mode =
                header.getAttribute("data-naviation-open-method") == "hover" ?
                "hover" :
                "click";
            Array.from(header.querySelectorAll(".yv-dropdown-detail")).forEach(
                function(menu) {
                    let currentBinding = navigationBindings.get(menu);
                    if (currentBinding && currentBinding.mode === mode) return;
                    if (currentBinding) removeNavigationBinding(menu);

                    let events = [];
                    if (mode === "hover") {
                        let mouseoverHandler = function() {
                            menu.classList.add("open");
                            menu.setAttribute("open", "");
                        };
                        let mouseleaveHandler = function() {
                            menu.classList.remove("open");
                            menu.removeAttribute("open");
                        };
                        menu.addEventListener("mouseover", mouseoverHandler);
                        menu.addEventListener("mouseleave", mouseleaveHandler);
                        events.push({ type: "mouseover", handler: mouseoverHandler });
                        events.push({ type: "mouseleave", handler: mouseleaveHandler });
                    } else {
                        let clickHandler = function(event) {
                            let summary =
                                event.target && event.target.closest ?
                                event.target.closest("summary") :
                                null;
                            if (!summary || summary.parentElement !== menu) return;
                            if (menu.open) {
                                hideAllMenu(menu);
                                document.querySelector("body").classList.remove("mega-menu-open");
                            } else {
                                hideAllMenu(menu);
                                menu.classList.add("open");
                                document.querySelector("body").classList.remove("mega-menu-open");
                                document.querySelector("body").classList.add("mega-menu-open");
                            }
                        };
                        menu.addEventListener("click", clickHandler);
                        events.push({ type: "click", handler: clickHandler });
                    }
                    let keydownHandler = function(event) {
                        if (
                            (event.key !== "Escape" && event.keyCode !== 27) ||
                            event.defaultPrevented ||
                            navigationBindings.get(menu)?.events !== events ||
                            !isConnected(menu) ||
                            !menu.hasAttribute("open") ||
                            !menu.contains(event.target) ||
                            !menu.contains(document.activeElement)
                        ) return;
                        let opener = Array.from(menu.children).find(function(child) {
                            return child.matches(mode === "hover" ? "a.nav-link" : "summary.nav-link");
                        });
                        if (
                            !isConnected(opener) ||
                            opener.closest("[hidden], [inert]") ||
                            !opener.getClientRects().length
                        ) return;
                        let style = window.getComputedStyle(opener);
                        if (
                            style.display === "none" ||
                            style.visibility === "hidden" ||
                            style.visibility === "collapse"
                        ) return;
                        event.preventDefault();
                        opener.focus({ preventScroll: true });
                        if (
                            navigationBindings.get(menu)?.events !== events ||
                            !isConnected(menu) ||
                            opener.parentElement !== menu ||
                            document.activeElement !== opener
                        ) return;
                        menu.removeAttribute("open");
                        menu.classList.remove("open");
                        if (!document.querySelector("header .yv-dropdown-detail[open]")) {
                            document.body.classList.remove("mega-menu-open");
                        }
                    };
                    menu.addEventListener("keydown", keydownHandler);
                    events.push({ type: "keydown", handler: keydownHandler });
                    navigationBindings.set(menu, { mode: mode, events: events });
                }
            );
        });
    }

    function refreshHamburger(scope = document) {
        cleanupDisconnectedBindings();
        let hamburgers = elementsInScope(scope, ".hamburger");
        let elmHamburger = null;
        let elmOverlay = null;
        hamburgers.some(function(candidate) {
            let owner =
                candidate.closest(".shopify-section-main-header") ||
                candidate.closest("header");
            if (!owner) return false;
            let pairedOverlay = owner.querySelector(".shape-overlays");
            if (!pairedOverlay) return false;
            elmHamburger = candidate;
            elmOverlay = pairedOverlay;
            return true;
        });
        if (!elmHamburger || !elmOverlay) return false;
        if (
            hamburgerBinding &&
            hamburgerBinding.hamburger === elmHamburger &&
            hamburgerBinding.overlayElement === elmOverlay
        ) {
            ensureHamburgerDelegates();
            return true;
        }

        removeHamburgerBinding();
        let overlay = new ShapeOverlays(elmOverlay);
        let binding = {
            hamburger: elmHamburger,
            overlayElement: elmOverlay,
            overlay: overlay,
            clickHandler: null,
            timers: new Set()
        };
        binding.clickHandler = function(event) {
            event.preventDefault();
            if (overlay.isAnimating) return false;
            overlay.toggle();
            let parentBody = document.querySelector("body");
            let gNavItems = document.querySelectorAll(".hamburger-menu-item");
            let dropdownNavItems = document.querySelectorAll(
                ".dropdown-hamburger-menu-item"
            );
            if (overlay.isOpened === true) {
                elmHamburger.classList.add("opened");
                if (parentBody) parentBody.classList.add("hamburder-opened");
                Array.from(gNavItems).forEach(function(navItem) {
                    let timer = setTimeout(function() {
                        binding.timers.delete(timer);
                        if (isConnected(navItem)) navItem.classList.add("opened");
                    }, 50);
                    binding.timers.add(timer);
                });
                focusElement = elmHamburger;
            } else {
                clearHamburgerTimers(binding);
                let superActives = document.querySelectorAll(".super_active");
                Array.from(superActives).forEach(function(item) {
                    item.classList.remove("super_active");
                });
                elmHamburger.classList.remove("opened");
                if (parentBody) parentBody.classList.remove("hamburder-opened");
                Array.from(gNavItems).forEach(function(item) {
                    item.classList.remove("opened");
                });
                Array.from(dropdownNavItems).forEach(function(item) {
                    item.classList.remove("active");
                });
            }
        };
        elmHamburger.addEventListener("click", binding.clickHandler);
        hamburgerBinding = binding;
        ensureHamburgerDelegates();
        return true;
    }

    function unload(scope) {
        allElementsInScope(scope).forEach(function(element) {
            if (closeDrawerGuardBindings.has(element)) {
                removeHoverBinding(
                    element,
                    closeDrawerGuardBindings,
                    hoveredCloseDrawerGuards,
                    ".upvLegacyCloseDrawerGuard"
                );
            }
            if (menuGuardBindings.has(element)) {
                removeHoverBinding(
                    element,
                    menuGuardBindings,
                    hoveredMenuGuards,
                    ".upvLegacyMenuGuard"
                );
            }
            if (navigationBindings.has(element)) removeNavigationBinding(element);
        });
        if (
            hamburgerBinding &&
            (scopeContains(scope, hamburgerBinding.hamburger) ||
                scopeContains(scope, hamburgerBinding.overlayElement))
        ) {
            removeHamburgerBinding();
        }
        updateCloseDrawerHoverState();
    }

    function destroy() {
        unload(document);
        pendingEscapeTimers.forEach(function(timer) {
            clearTimeout(timer);
        });
        pendingEscapeTimers.clear();
        if (closeDrawerBody) {
            $(closeDrawerBody).off(".upvLegacyCloseDrawers");
            closeDrawerBody = null;
        }
        removeHamburgerDelegates();
        hoveredCloseDrawerGuards.clear();
        hoveredMenuGuards.clear();
        updateCloseDrawerHoverState();
    }

    function debugState() {
        cleanupDisconnectedBindings();
        let elements = allElementsInScope(document);
        return {
            version: 1,
            closeDrawerBodyBindings: closeDrawerBody ? 1 : 0,
            hamburgerDelegateGroups: hamburgerDelegationBody ? 1 : 0,
            hamburgerBindings: hamburgerBinding ? 1 : 0,
            closeDrawerGuardBindings: elements.filter(function(element) {
                return closeDrawerGuardBindings.has(element);
            }).length,
            menuGuardBindings: elements.filter(function(element) {
                return menuGuardBindings.has(element);
            }).length,
            navigationBindings: elements.filter(function(element) {
                return navigationBindings.has(element);
            }).length
        };
    }

    return {
        version: 1,
        refresh: function(scope = document) {
            refreshHamburger(scope);
            refreshNavigation(scope);
            refreshCloseDrawers(scope);
        },
        refreshHamburger: refreshHamburger,
        refreshNavigation: refreshNavigation,
        refreshCloseDrawers: refreshCloseDrawers,
        unload: unload,
        destroy: destroy,
        debugState: debugState
    };
}

function getUpvanityLegacyInteractionController() {
    let controller = window.UpvanityLegacyInteractionController;
    if (!controller || controller.version !== 1) {
        if (controller && typeof controller.destroy === "function") controller.destroy();
        controller = createUpvanityLegacyInteractionController();
        window.UpvanityLegacyInteractionController = controller;
    }
    return controller;
}

function legacyInteractionElements(section = document) {
    return getUpvanityLegacyInteractionController().refresh(section);
}

function hamburgerInit(section = document) {
    return getUpvanityLegacyInteractionController().refreshHamburger(section);
}

function navigationMenu(section = document) {
    return getUpvanityLegacyInteractionController().refreshNavigation(section);
}

function closeDrawers(section = document) {
    return getUpvanityLegacyInteractionController().refreshCloseDrawers(section);
}

function unloadLegacyInteractionElements(section) {
    let controller = window.UpvanityLegacyInteractionController;
    if (controller && controller.version === 1) controller.unload(section);
}

function createUpvanityProductRecommendationsController() {
    const wrapperSelector = "[product-recommendations]";
    const productSelector = "[data-product-id], .yv-complementary-product-box";
    const controllerHiddenAttribute = "data-upvanity-recommendations-hidden";
    const requestDeadlineMs = 15000;
    const states = new WeakMap();
    const pendingRequests = new Set();
    let destroyed = false;

    function elementsInScope(scope) {
        if (!scope || typeof scope.querySelectorAll !== "function") return [];
        const elements = [];
        if (scope.nodeType === 1 && typeof scope.matches === "function" && scope.matches(wrapperSelector)) {
            elements.push(scope);
        }
        return elements.concat(Array.from(scope.querySelectorAll(wrapperSelector)));
    }

    function visibilityTarget(wrapper) {
        if (wrapper && wrapper.classList && wrapper.classList.contains("related_products") &&
            typeof wrapper.closest === "function") {
            return wrapper.closest(".shopify-section") || wrapper;
        }
        return wrapper;
    }

    function setVisible(wrapper, visible) {
        const target = visibilityTarget(wrapper);
        if (!target || typeof target.getAttribute !== "function") return;
        if (visible) {
            if (target.getAttribute(controllerHiddenAttribute) === "true") {
                target.removeAttribute("hidden");
                target.removeAttribute(controllerHiddenAttribute);
            }
        } else if (!target.hasAttribute("hidden")) {
            target.setAttribute("hidden", "");
            target.setAttribute(controllerHiddenAttribute, "true");
        }
    }

    function containsProducts(container) {
        return !!(container && typeof container.querySelector === "function" &&
            container.querySelector(productSelector));
    }

    function reportError(message, error) {
        if (typeof console !== "undefined" && typeof console.error === "function") {
            console.error(message, error);
        }
    }

    function destroySlider(sliderElement) {
        if (!sliderElement || typeof jQuery !== "function") return;
        try {
            const slider = jQuery(sliderElement);
            slider.off(".upvTheme");
            slider.find(".flickity-slider-thumb-item").off(".upvThemeFlickity");
            const instance = typeof Flickity !== "undefined" &&
                typeof Flickity.data === "function" ? Flickity.data(sliderElement) : null;
            if (instance && typeof instance.destroy === "function") {
                instance.destroy();
            } else if (slider.hasClass("flickity-enabled")) {
                slider.flickity("destroy");
            }
        } catch (error) {
            reportError("Product recommendations slider cleanup failed", error);
        }
    }

    function destroyStateSlider(wrapper, state) {
        const sliderElement = state && state.sliderElement ? state.sliderElement :
            wrapper.querySelector("[data-flickity-slider]");
        destroySlider(sliderElement);
        if (state) state.sliderElement = null;
    }

    function clearRequestDeadline(request) {
        if (request.deadlineTimer !== null) {
            window.clearTimeout(request.deadlineTimer);
            request.deadlineTimer = null;
        }
    }

    function abortRequest(request) {
        if (request.controller) {
            try {
                request.controller.abort();
            } catch (error) {
                reportError("Product recommendations request cancellation failed", error);
            }
        }
    }

    function cancelRequest(state) {
        if (!state || !state.request) return;
        const request = state.request;
        state.request = null;
        pendingRequests.delete(request);
        clearRequestDeadline(request);
        abortRequest(request);
    }

    function isCurrent(request) {
        const wrapper = request.wrapper;
        const state = request.state;
        return !destroyed && wrapper.isConnected !== false &&
            states.get(wrapper) === state && state.request === request &&
            state.generation === request.generation &&
            wrapper.dataset.url === request.url;
    }

    function finishRequest(request) {
        clearRequestDeadline(request);
        pendingRequests.delete(request);
        const state = request.state;
        if (states.get(request.wrapper) === state && state.request === request) {
            state.request = null;
            if (state.status === "loading") state.status = "idle";
            request.wrapper.removeAttribute("aria-busy");
        }
    }

    function matchingResponseRoot(text, request) {
        const html = document.createElement("div");
        html.innerHTML = text;
        return Array.from(html.querySelectorAll(wrapperSelector)).find(function(candidate) {
            return candidate.dataset.url === request.url;
        }) || null;
    }

    function initializeContent(wrapper, state) {
        try {
            gridPickUpAvailability(wrapper);
        } catch (error) {
            reportError("Product recommendations pickup initialization failed", error);
        }

        const sliderElement = wrapper.querySelector("[data-flickity-slider]");
        state.sliderElement = sliderElement;
        if (sliderElement && !sliderElement.classList.contains("flickity-enabled")) {
            const desktopOnly = sliderElement.classList.contains("data-desktop-only");
            if (!desktopOnly || window.innerWidth > 767) {
                try {
                    if (typeof jQuery === "function" && typeof flickitySlider === "function") {
                        flickitySlider(jQuery(sliderElement));
                    }
                } catch (error) {
                    reportError("Product recommendations slider initialization failed", error);
                }
            }
        }

        try {
            showMultipleOptions();
        } catch (error) {
            reportError("Product recommendations option initialization failed", error);
        }
    }

    function commitResponse(request, recommendations) {
        if (!isCurrent(request)) return;
        const wrapper = request.wrapper;
        const state = request.state;
        if (!containsProducts(recommendations)) {
            destroyStateSlider(wrapper, state);
            wrapper.innerHTML = "";
            setVisible(wrapper, false);
            state.status = "empty";
            return;
        }

        destroyStateSlider(wrapper, state);
        wrapper.innerHTML = recommendations.innerHTML;
        setVisible(wrapper, true);
        initializeContent(wrapper, state);
        state.status = "loaded";
    }

    function handleFailure(request, error) {
        if (error && error.name === "AbortError") return;
        if (!isCurrent(request)) return;
        request.state.status = "error";
        if (!containsProducts(request.wrapper)) setVisible(request.wrapper, false);
        reportError("Product recommendations failed to load", error);
    }

    function hydrateWrapper(wrapper) {
        if (destroyed || !wrapper || wrapper.isConnected === false) return;
        const url = String(wrapper.dataset.url || "").trim();
        const existingState = states.get(wrapper);
        if (!url) {
            if (existingState) {
                existingState.generation += 1;
                cancelRequest(existingState);
                destroyStateSlider(wrapper, existingState);
                states.delete(wrapper);
            }
            wrapper.removeAttribute("aria-busy");
            if (!containsProducts(wrapper)) setVisible(wrapper, false);
            return;
        }

        if (existingState && existingState.requestUrl === url &&
            (existingState.status === "loading" || existingState.status === "loaded" ||
                existingState.status === "empty")) {
            return;
        }

        const state = existingState || {
            generation: 0,
            request: null,
            requestUrl: "",
            sliderElement: wrapper.querySelector("[data-flickity-slider]"),
            status: "idle"
        };
        cancelRequest(state);
        state.generation += 1;
        state.requestUrl = url;
        state.status = "loading";
        states.set(wrapper, state);

        const controller = typeof AbortController === "function" ? new AbortController() : null;
        const request = {
            controller: controller,
            deadlineTimer: null,
            generation: state.generation,
            state: state,
            url: url,
            wrapper: wrapper
        };
        state.request = request;
        pendingRequests.add(request);
        wrapper.setAttribute("aria-busy", "true");
        request.deadlineTimer = window.setTimeout(function() {
            const error = new Error("Product recommendations request timed out");
            error.name = "TimeoutError";
            handleFailure(request, error);
            finishRequest(request);
            abortRequest(request);
        }, requestDeadlineMs);

        const fetchOptions = controller ? { signal: controller.signal } : undefined;
        let fetchResult;
        try {
            fetchResult = fetch(url, fetchOptions);
        } catch (error) {
            handleFailure(request, error);
            finishRequest(request);
            return;
        }

        Promise.resolve(fetchResult)
            .then(function(response) {
                if (!isCurrent(request)) return;
                if (!response || response.ok !== true) {
                    const status = response && typeof response.status !== "undefined" ?
                        response.status : "unknown";
                    throw new Error("Product recommendations request failed with status " + status);
                }
                return response.text();
            })
            .then(function(text) {
                if (!isCurrent(request)) return;
                const recommendations = matchingResponseRoot(text, request);
                if (!recommendations) {
                    throw new Error("Product recommendations response did not contain its matching section root");
                }
                commitResponse(request, recommendations);
            })
            .catch(function(error) {
                handleFailure(request, error);
            })
            .then(function() {
                finishRequest(request);
            });
    }

    function refresh(scope = document) {
        if (destroyed) return;
        elementsInScope(scope).forEach(hydrateWrapper);
    }

    function unloadWrapper(wrapper) {
        const state = states.get(wrapper);
        if (state) {
            state.generation += 1;
            cancelRequest(state);
            destroyStateSlider(wrapper, state);
            states.delete(wrapper);
        } else {
            destroySlider(wrapper.querySelector("[data-flickity-slider]"));
        }
        wrapper.removeAttribute("aria-busy");
    }

    function unload(scope) {
        elementsInScope(scope).forEach(unloadWrapper);
    }

    function destroy() {
        if (destroyed) return;
        destroyed = true;
        elementsInScope(document).forEach(unloadWrapper);
        pendingRequests.forEach(function(request) {
            clearRequestDeadline(request);
            abortRequest(request);
            request.wrapper.removeAttribute("aria-busy");
        });
        pendingRequests.clear();
    }

    return {
        version: 1,
        refresh: refresh,
        unload: unload,
        destroy: destroy,
        debugState: function(wrapper) {
            const state = states.get(wrapper);
            return state ? {
                generation: state.generation,
                hasSlider: !!state.sliderElement,
                requestUrl: state.requestUrl,
                status: state.status
            } : null;
        }
    };
}

function getUpvanityProductRecommendationsController() {
    let controller = window.UpvanityProductRecommendationsController;
    if (!controller || controller.version !== 1) {
        if (controller && typeof controller.destroy === "function") controller.destroy();
        controller = createUpvanityProductRecommendationsController();
        window.UpvanityProductRecommendationsController = controller;
    }
    return controller;
}

function productRecommendations(scope = document) {
    return getUpvanityProductRecommendationsController().refresh(scope);
}

function productRecommendationsInit(productRecommendationsSection) {
    return getUpvanityProductRecommendationsController().refresh(productRecommendationsSection);
}

function unloadProductRecommendations(scope) {
    const controller = window.UpvanityProductRecommendationsController;
    if (controller && controller.version === 1) controller.unload(scope);
}

function productHoverSlider() {
    var hoverSlider = setInterval(function() {
        if ($(".yv-product-hover-slider").length > 0) {
            clearInterval(hoverSlider);
            $(".yv-product-hover-slider").hover(
                function() {
                    var _this = $(this);
                    if (
                        _this.find(".sd-main-Slider").attr("data-flickity-hover-slider") ==
                        undefined
                    ) {
                        return false;
                    }
                    _this.addClass("slider-active");
                    var sliderOptions = JSON.parse(
                        _this.find(".sd-main-Slider").attr("data-flickity-hover-slider")
                    );
                    var $hoverSlider = _this
                        .find(".sd-main-Slider")
                        .flickity(sliderOptions);
                },
                function() {
                    if ($(this).find(".sd-main-Slider").hasClass("flickity-enabled")) {
                        $(this).removeClass("slider-active");
                        $(this).find(".sd-main-Slider").flickity("destroy");
                    }
                }
            );
            $(".yv-product-hover-slider")
                .find(".slider-button-prev")
                .on("click", function(e) {
                    e.preventDefault();
                    let gridHoverSlider = $(this)
                        .parent(".yv-product-hover-slider")
                        .find(".sd-main-Slider");
                    if (gridHoverSlider.hasClass("flickity-enabled")) {
                        gridHoverSlider.flickity("previous");
                    }
                });
            // next
            $(".yv-product-hover-slider")
                .find(".slider-button-next")
                .on("click", function(e) {
                    e.preventDefault();
                    let gridHoverSlider = $(this)
                        .parent(".yv-product-hover-slider")
                        .find(".sd-main-Slider");
                    if (gridHoverSlider.hasClass("flickity-enabled")) {
                        gridHoverSlider.flickity("next");
                    }
                });
        }
    }, 500);

    setTimeout(function() {
        clearInterval(hoverSlider);
    }, 6000);
}

function deferredProductHoverImages(section = document) {
    let deferredCards = section.querySelectorAll('[data-upv-deferred-hover-card]');
    Array.from(deferredCards).forEach(function(card) {
        if (card.dataset.upvDeferredHoverBound === 'true') return;

        let initialImage = card.querySelector(
            'img.product-second-img[data-upv-deferred-src]'
        );
        let initialContainer = card.querySelector(
            '.yv-product-card-img.yv-product-hover-image-pending'
        );
        if (!initialImage || !initialContainer) return;

        card.dataset.upvDeferredHoverBound = 'true';
        let pointerTimer = null;

        let clearPointerTimer = function() {
            if (pointerTimer === null) return;
            clearTimeout(pointerTimer);
            pointerTimer = null;
        };

        let removeActivationListeners = function() {
            clearPointerTimer();
            card.removeEventListener('pointerenter', handlePointerEnter);
            card.removeEventListener('pointerleave', handlePointerLeave);
            card.removeEventListener('focusin', handleFocusIn);
        };

        let activateDeferredImage = function() {
            clearPointerTimer();
            if (card.isConnected === false) return;

            let image = card.querySelector(
                'img.product-second-img[data-upv-deferred-src]'
            );
            let imageContainer = card.querySelector(
                '.yv-product-card-img.yv-product-hover-image-pending'
            );
            if (!image || !imageContainer) {
                card.removeAttribute('data-upv-deferred-hover-card');
                removeActivationListeners();
                return;
            }
            if (image.dataset.upvDeferredHoverState) return;

            let deferredSrc = image.getAttribute('data-upv-deferred-src');
            if (!deferredSrc) return;

            image.dataset.upvDeferredHoverState = 'loading';
            card.removeAttribute('data-upv-deferred-hover-card');
            removeActivationListeners();

            let handleImageLoad;
            let handleImageError;
            let removeImageListeners = function() {
                image.removeEventListener('load', handleImageLoad);
                image.removeEventListener('error', handleImageError);
            };

            let markReady = function() {
                if (
                    image.isConnected === false ||
                    imageContainer.isConnected === false ||
                    !card.contains(imageContainer) ||
                    !imageContainer.contains(image) ||
                    image.naturalWidth <= 0
                ) return;
                image.dataset.upvDeferredHoverState = 'ready';
                imageContainer.classList.remove('yv-product-hover-image-pending');
                imageContainer.classList.add('yv-product-hover-image');
            };

            handleImageLoad = function() {
                removeImageListeners();
                markReady();
            };
            handleImageError = function() {
                removeImageListeners();
                image.dataset.upvDeferredHoverState = 'error';
                if (
                    imageContainer.isConnected === false ||
                    !card.contains(imageContainer)
                ) return;
                imageContainer.classList.remove('yv-product-hover-image');
                imageContainer.classList.add('yv-product-hover-image-pending');
            };

            image.addEventListener('load', handleImageLoad);
            image.addEventListener('error', handleImageError);

            image.setAttribute('data-src', deferredSrc);
            image.removeAttribute('data-upv-deferred-src');
            image.classList.add('lazyload');

            if (
                window.lazySizes &&
                window.lazySizes.loader &&
                typeof window.lazySizes.loader.unveil === 'function'
            ) {
                window.lazySizes.loader.unveil(image);
            }
            if (image.complete && image.naturalWidth > 0) handleImageLoad();
        };

        let handlePointerEnter = function(event) {
            if (event.pointerType === 'touch') return;
            clearPointerTimer();
            pointerTimer = setTimeout(activateDeferredImage, 120);
        };

        let handlePointerLeave = function() {
            clearPointerTimer();
        };

        let handleFocusIn = function() {
            if (document.documentElement.dataset.uvFocusModality === 'pointer') return;
            activateDeferredImage();
        };

        card.addEventListener('pointerenter', handlePointerEnter);
        card.addEventListener('pointerleave', handlePointerLeave);
        card.addEventListener('focusin', handleFocusIn);
    });
}

function initBeforeAfter() {
    let cursors = document.querySelectorAll(".before-after-cursor-point");
    Array.from(cursors).forEach(function(cursor) {
        beforeAfterImage(cursor);
    });
}

function beforeAfterImage(cursor) {
    const _parentSection = cursor.closest(".shopify-section");
    let pointerDown = false;
    let _offsetX = (_currentX = 0);
    let minOffset = -cursor.offsetLeft - 0;
    let maxOffset = cursor.offsetParent.clientWidth + minOffset;
    _parentSection.addEventListener("pointerdown", function(event) {
        if (
            event.target === cursor ||
            event.target.closest(".before-after-cursor-point") === cursor
        ) {
            _initialX = event.clientX - _offsetX;
            pointerDown = true;
        }
    });
    _parentSection.addEventListener("pointermove", function() {
        if (!pointerDown) {
            return;
        }
        _currentX = Math.min(
            Math.max(event.clientX - _initialX, minOffset),
            maxOffset
        );
        _offsetX = _currentX;
        _currentX = _currentX.toFixed(1);
        _parentSection.style.setProperty(
            "--imageClipPosition",
            `${_currentX}px`
        );
    });
    _parentSection.addEventListener("pointerup", function(event) {
        pointerDown = false;
    });
    window.addEventListener("resize", function() {
        if (!cursor.offsetParent) {
            return false;
        }
        minOffset = -cursor.offsetLeft - 0;
        maxOffset = cursor.offsetParent.clientWidth + minOffset;
        _currentX = Math.min(Math.max(minOffset, _currentX), maxOffset)

        _parentSection.style.setProperty(
            "--imageClipPosition",
            `${_currentX}px`
        );
    });
}

function hideBanner() {
    document.querySelector(".cookies-banner") && (document.querySelector(".cookies-banner").style.display = "none");
}

function showBanner() {
    document.querySelector(".cookies-banner") && (document.querySelector(".cookies-banner").style.display = "block");
}

function handleAccept(e) {
    window.Shopify.customerPrivacy.setTrackingConsent(!0, hideBanner),
        document.addEventListener("trackingConsentAccepted", function() {
            console.log("trackingConsentAccepted event fired");
        });
}

function handleDecline() {
    window.Shopify.customerPrivacy.setTrackingConsent(!1, hideBanner);
}

function initCookieBanner() {
    const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked(),
        userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

    if (userCanBeTracked && userTrackingConsent === "no_interaction") {
        showBanner();
    }
}

function cookiesBanner() {
    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function(e) {
        if (e) throw e;
        initCookieBanner();
    });
}

$(document).ready(function() {
    try {
        productVariants();
    } catch (error) {
        if (typeof console != "undefined" && console.error) {
            console.error("Product variant initialization failed", error);
        }
    } finally {
        sealInitialProductVariantPreGuardCapture();
    }
    try {
        pickUpAvialabiliy(true);
    } catch (error) {
        if (typeof console != "undefined" && console.error) {
            console.error("Pickup availability initialization failed", error);
        }
    }
    sellingPlanChange();
    sliders();
    checkMapApi();
    quantityChange();
    tabAccordionContent();
    var slideIndex = 0;
    var block = "";
    let stickyItems = $(".sticky-item");
    setTimeout(function() {
        if ($("body").hasClass("sticky-header")) {
            let headerHeight = $(".shopify-section-main-header").height();
            // stickyItems.css('top', headerHeight + 'px');
            // $('.yv-collections-topbar').css('top', (headerHeight) + 'px');
        } else {
            stickyItems.css("top", "0px");
            // $('.yv-collections-topbar').css('top', '0px');
        }
    }, 500);

    jQuery(document).on(
        "shopify:section:select shopify:section:deselect shopify:section:load shopify:section:unload shopify:block:select shopify:block:deselect",
        function(event) {
            var parent = event.target;
            var mainSliderSelector = $(".yv-product-big-slider");
            if (mainSliderSelector.hasClass("flickity-enabled")) {
                var activeMainSlider = Flickity.data(mainSliderSelector[0]);
                if (activeMainSlider) activeMainSlider.resize();
            }
            if (Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
            }
            if (jQuery(parent).hasClass("offer-sidebar-section")) {
                jQuery(parent).show();
            } else {
                $(".offer-sidebar-section").hide();
                jQuery("body").removeClass("offer-open");
                jQuery(".yv-coupan-sidebar-element").removeClass("open");
            }
            $(".offer-sidebar-section").hide();
            var slider = jQuery(parent).find("[data-flickity-slider]");
            if (event.type == "shopify:block:select") {
                jQuery(parent).find('.yv-accordion-header').trigger('click')
                if (jQuery(parent).hasClass('yv-timeline-nav')) {
                    jQuery(parent).find('[data-timeline-nav]').trigger('click')
                }
                if (jQuery(parent).hasClass('collections-list-slider-item')) {
                    collectionHoverAction(jQuery(parent).find('[data-hover-collection-item]')[0])
                }
                if (jQuery(parent).hasClass('color-collections-color-item')) {
                    jQuery(parent).trigger('click')
                }
                if (
                    jQuery(parent)
                    .closest(".shopify-section")
                    .hasClass("offer-sidebar-section")
                ) {
                    $(".offer-sidebar-section").show();
                    jQuery("body").addClass("offer-open");
                    jQuery("body").find(".yv-coupan-sidebar-element").addClass("open");
                    jQuery("body")
                        .find(".yv-coupan-sidebar-element")
                        .find("[data-flickity-slider]")
                        .flickity("resize");
                } else {
                    $(".offer-sidebar-section").hide();
                    jQuery("body").removeClass("offer-open");
                    jQuery(".yv-coupan-sidebar-element").removeClass("open");
                    jQuery("body")
                        .find(".yv-coupan-sidebar-element")
                        .find("[data-flickity-slider]")
                        .flickity("resize");
                }
                var sectionId = event.detail.sectionId;
                block = jQuery(event.target);

                slideIndex = block.index();
                if (
                    block.closest("[data-flickity-slider]").hasClass("flickity-enabled")
                ) {
                    block
                        .closest("[data-flickity-slider]")
                        .flickity("select", slideIndex);
                }
            } else {
                $(".offer-sidebar-section").hide();
                jQuery("body").removeClass("offer-open");
                jQuery(".yv-coupan-sidebar-element").removeClass("open");
                jQuery("body")
                    .find(".yv-coupan-sidebar-element")
                    .find("[data-flickity-slider]")
                    .flickity("resize");
            }
            if (event.type == "shopify:section:load") {
                productVariants(parent);
                collectionHoverNavInit(parent);
                timelineNavInit(parent);
                
                localizationElements(parent);
                cookiesBanner();
                viewcategoryInit();
                initBeforeAfter();
                productHoverSlider();
                deferredProductHoverImages(parent);
                initYouTubeIframe(parent);
                updateInventroyStatusBar();
                productRecommendations(parent);
                hamburgerInit(parent);
                navigationMenu(parent);
                closeDrawers(parent);
                recentlyViewedProducts(parent);
                productGiftOptions();
                lookbookScrollContent();
                initStoreLocator();
                productQueryForm();
                newsletterSidebar();
                pdpCountdown();
                coloredCollection(parent);
                sideDrawerContentStoryInit(parent)
                
                if (parent.querySelector('.yv-parallax')) {
                    new universalParallax().init({
                        speed: 10
                    });
                }
                if (parent.classList.contains('shopify-section-main-header')) {
                    $('html, body').animate({ scrollTop: 0 }, 'slow');
                    initSearchPrompts(parent);
                }
                if (
                    jQuery(parent)
                    .closest(".shopify-section")
                    .hasClass("offer-sidebar-section")
                ) {
                    $(".offer-sidebar-section").show();
                }
                if (block != "") {
                    slideIndex = undefined;
                }
                if (event.target.querySelector("[data-map-container]")) {
                    checkMapApi(event.target.querySelector("[data-map-container]"));
                }
                let _sliders = jQuery(event.target).find("[data-flickity-slider]");
                _sliders.each(function() {
                    let _slider = $(this);
                    if (_slider.is("[data-mobile-only]")) {
                        if ($(window).width() < 768) {
                            if (!_slider.hasClass("flickity-enabled")) {
                                flickitySlider(_slider, slideIndex);
                            }
                        } else {
                            if (_slider.hasClass("flickity-enabled")) {
                                _slider.flickity("destroy");
                            }
                        }
                    } else if (_slider.is("[data-desktop-only]")) {
                        if ($(window).width() >= 768) {
                            if (!_slider.hasClass("flickity-enabled")) {
                                flickitySlider(_slider);
                            }
                        } else {
                            if (_slider.hasClass("flickity-enabled")) {
                                _slider.flickity("destroy");
                            }
                        }
                    } else {
                        if (!_slider.hasClass("flickity-enabled")) {
                            flickitySlider($(this), slideIndex);
                        }
                    }
                });
                if (jQuery(event.target).find("[data-slider]").length > 0) {
                    jQuery("html, body").animate({
                        scrollTop: jQuery(event.target).offset().top,
                    });
                }
                tabAccordionContent();
                quantityChange();
                if (jQuery(event.target).find(".dealDate").length > 0) {
                    dealSection(jQuery(event.target).attr("id"));
                }
                // if (jQuery(event.target).find(".announcement-bar").length > 0) {
                //   initAnnouncement();
                // }
            }
            if (event.type == "shopify:section:unload") {
                unloadLegacyInteractionElements(event.target);
                unloadProductRecommendations(event.target);
                unloadRecentlyViewedProducts(event.target);
                clearDealCountdown(event.target);
                disposeProductVariantLifecycle(event.target);
                if (event.target.querySelector("[data-map-container]")) {
                    checkMapApi(event.target.querySelector("[data-map-container]"));
                }
            }
            if (event.type == "shopify:section:select") {
                if (jQuery(parent).hasClass("offer-sidebar-section")) {
                    jQuery(parent).show();
                } else if (
                    $(".offer-sidebar-section").find(".yv-offer-sidebar-outer")
                    .length == 0
                ) {
                    $(".offer-sidebar-section").hide();
                }
            }
            if (event.type == "shopify:section:select" || event.type == "shopify:section:load") {
                if (jQuery(parent).hasClass("side-drawer-content")) {
                    if (parent.querySelector('.side-drawer-story')) {
                        jQuery("[data-content-drawer-main]").addClass('show');
                        document.querySelector("body").classList.add("story-drawer-open")
                        setTimeout(function() {
                            document.querySelector("body").classList.add("story-drawer-overlay")
                        }, 400);
                    } else {
                        jQuery("[data-content-drawer-main]").removeClass('show');
                        document.querySelector("body").classList.remove("story-drawer-overlay");
                        setTimeout(function() {
                            document.querySelector("body").classList.remove("story-drawer-open")
                        }, 700);
                    }
                }
            }
            if (event.type == "shopify:section:deselect") {
                if (jQuery(parent).hasClass("side-drawer-content")) {
                    jQuery("[data-content-drawer-main]").removeClass('show');
                    document.querySelector("body").classList.remove("story-drawer-overlay");
                    setTimeout(function() {
                        document.querySelector("body").classList.remove("story-drawer-open")
                    }, 700);
                }
            }
            var offset = $(parent).offset();

            // $("html, body").animate({
            //   scrollTop: offset.top,
            // });

            if (animationStatus) {
                if (AOS) {
                    AOS.refreshHard();
                }
            }
        }
    );

    $("#currencyMobile").change(function() {
        $(this).closest("form").submit();
    });
    var deals = document.getElementsByClassName("deal-banner-section");
    if (deals) {
        Array.from(deals).forEach(function(deal) {
            dealSection(deal.getAttribute("id"));
        });
    }

    $(window).resize(function(event) {
        // if ($("body").hasClass("side_Drawer_open")) {
        //   $("body").removeClass("side_Drawer_open");
        // }
        if ($(window).width() < 992) {
            if ($('body').hasClass('catalog-open')) {
                $('body').removeClass('catalog-open');
                $('#view-catalog').hide();
            }
        }
        sliders();
        sliderFilter();
    });

    $(document).on("click", function(event) {
        var $trigger = $(".currency-dropdown");
        if ($trigger !== event.target && !$trigger.has(event.target).length) {
            $(".currency-menu").slideUp("fast");
        }
    });

    $("body").on("click", ".navbar-toggler,.yv-mobile-category", function(event) {
        event.preventDefault();
        $(".navbar-collapse-sidebar").addClass("show");
        $("body").addClass("nav-open");
    });

    $("body").on("click", ".close-btn", function(event) {
        $("body").removeClass("nav-open"),
            $(".toggle-level,.list-menu__item.toggle").removeClass("open-menu-drop"),
            $(".inner").removeClass("is-open"),
            $(".header-store-content-mobile .store-location-dropdown").slideUp("slow"),
            $(".inner").slideUp("slow");
        setTimeout(() => {
            if (window.location.href.indexOf('#mobileMenu') > -1 || window.location.href.indexOf('#header') > -1) {
                let url = window.location.href.replace('#mobileMenu', '');
                url = url.replace('#header', '')
                history.replaceState({}, null, url);
            }
        }, 100);
    });

    $(document).on("click", ".close-cart-drawer", function() {
        $("body").removeClass("minicart-open"), $(".wrapper-overlay").hide();
    });

    $("body").on("click", ".similar_options", function(e) {
        e.preventDefault();
        var similarDrawerTrigger = this;
        var getUrl = $(this).attr("data-url");
        const drawer = document.querySelector("[data-similar-product-drawer]");
        const drawerBody = drawer &&
            drawer.querySelector("[data-similar-drawer-body]");
        const wrapperOverlay = document.querySelector(".wrapper-overlay");
        if (!drawer || !drawerBody || !getUrl) return;
        var requestState = beginSimilarDrawerRequest(
            drawer,
            drawerBody,
            similarDrawerTrigger,
            wrapperOverlay
        );
        if (!requestState) return;

        $(wrapperOverlay || ".wrapper-overlay").css({ display: "block" });
        drawer.classList.add("searching");
        document.querySelector("body").classList.add("similar_Drawer_open");
        drawerBody.innerHTML = preLoadLoadGif;
        var fetchOptions = requestState.controller ?
            { signal: requestState.controller.signal } : undefined;
        var similarDrawerFetch;
        try {
            similarDrawerFetch = fetch(getUrl, fetchOptions);
        } catch (error) {
            closeSimilarDrawer(drawer, requestState);
            return;
        }
        Promise.resolve(similarDrawerFetch)
            .then((response) => {
                if (!isSimilarDrawerRequestCurrent(requestState)) return null;
                return response.text();
            })
            .then((text) => {
                if (
                    typeof text !== "string" ||
                    !isSimilarDrawerRequestCurrent(requestState)
                ) return;
                const html = document.createElement("div");
                html.innerHTML = text;
                const recommendations = html.querySelector("#similarItemContainer");
                if (recommendations && recommendations.innerHTML.trim().length) {
                    if (!isSimilarDrawerRequestCurrent(requestState)) return;
                    drawer.upvSimilarDrawerTrigger = similarDrawerTrigger;
                    drawerBody.innerHTML = recommendations.innerHTML;
                    drawer.classList.remove("searching");
                    focusElementsRotation($(drawer));
                    $(drawer).trigger("focus");
                    gridPickUpAvailability(drawer)
                    if (animationStatus) {
                        if (AOS) {
                            AOS.refreshHard();
                        }
                    }
                    requestState.controller = null;
                } else {
                    closeSimilarDrawer(drawer, requestState);
                }
            })
            .catch(() => {
                if (!isSimilarDrawerRequestCurrent(requestState)) return;
                closeSimilarDrawer(drawer, requestState);
            });
    });

    $("body").on("click", ".currency-dropdown .dropdown-toggle", function() {
        $(this)
            .closest(".currency-dropdown")
            .find(".currency-menu")
            .slideToggle("fast");
    });

    $("body").on("click", "#CountryList .dropdown-item", function(event) {
        event.preventDefault();
        var value = $(this).attr("data-value");
        var text = $(this).text();
        $(this).closest("form").find(".dropdown-toggle").text(text);
        $(this).closest("form").find('[name="country_code"]').val(value);
        $(this).closest("form").submit();
        $(this)
            .closest(".currency-dropdown")
            .find(".currency-menu")
            .slideUp("fast");
    });

    $("body").on("click", ".dropdown-selected", function() {
        $("body").find(".productOptionSelectList").slideUp("fast");
        $(this).siblings(".productOptionSelectList").css({ display: "block" });
    });

    $("body").on(
        "click",
        ".toggle.list-menu__item,button.toggle-level",
        function(event) {
            event.preventDefault();
            var $this = $(this);
            if ($this.hasClass("open-menu-drop")) {
                $(this).next().removeClass("is-open");
                $(this).removeClass("open-menu-drop");
                $this.next().slideUp("slow");
            } else {
                $(".header-store-content-mobile .store-location-dropdown").slideUp("slow");
                if ($(this).hasClass("toggle-level")) {
                    $(".toggle-level").removeClass("open-menu-drop");
                    $(".toggle-level").next().removeClass("is-open");
                    $(".toggle-level").next().slideUp("slow");
                } else {
                    $(".toggle.list-menu__item,.toggle-level").removeClass(
                        "open-menu-drop"
                    );
                    $(".toggle.list-menu__item,.toggle-level")
                        .next()
                        .removeClass("is-open");
                    $(".toggle.list-menu__item,.toggle-level").next().slideUp("slow");
                }
                $this.closest("li").find(".inner").removeClass("is-open");
                $this.closest("li").find(".inner").slideUp("slow");
                $(this).addClass("open-menu-drop");
                $this.next().slideDown("slow");
                $this.next().addClass("is-open");
            }
        }
    );

    $(document).on("click", function(event) {
        var $trigger = $(".productOptionSelect");
        if ($trigger !== event.target && !$trigger.has(event.target).length) {
            $(".productOptionSelectList").slideUp("fast");
        }
    });

    $("body").on("click", ".dropdown-menu li", function() {
        var getValue = $(this).text();
        $(this).find("input").prop("checked", true);
        $(this)
            .closest(".productOptionSelect")
            .find(".dropdown-selected")
            .text(getValue);
        $(this).closest(".productOptionSelectList").slideUp("fast");
    });

    $(document).on(
        "click",
        ".yv_side_drawer_close,.yv_similar_drawer_close",
        function() {
            var isSimilarDrawerClose = Boolean(
                this &&
                this.classList &&
                this.classList.contains("yv_similar_drawer_close")
            );
            if (isSimilarDrawerClose) {
                var similarDrawer = this.closest ?
                    this.closest("[data-similar-product-drawer]") : null;
                if (!similarDrawer) return;
                closeSimilarDrawer(similarDrawer);
                return;
            }
            var sharedDrawer = document.querySelector("[data-side-drawer]");
            var sharedDrawerWasQuickView =
                isNativeQuickViewSharedDrawer(sharedDrawer);
            if (sharedDrawer) {
                cancelSharedDrawerOwnership(sharedDrawer);
                cancelQuickViewRequest(sharedDrawer);
                hideQuickViewLoader();
                var sharedDrawerBody = sharedDrawer.querySelector(
                    "[data-drawer-body]"
                );
                if (sharedDrawerBody) {
                    sharedDrawerBody.classList.remove("searching");
                }
                disposeProductVariantLifecycle(sharedDrawer);
            }
            $("body")
                .removeClass("side_Drawer_open")
                .removeClass("similar_Drawer_open")
                .removeClass("yv_side_Drawer_open");
            closeVideoMedia("quickView");
            $("[data-similar-drawer-body]").html("");
            $(".yv-upsell-drawer").removeClass("active");
            stopFocusElementsRotation();
            if (focusElement) {
                if (focusElement.nodeType || focusElement == window) {
                    focusElement.focus();
                } else {
                    focusElement.trigger("focus");
                }
                focusElement = "";
            }
            if (sharedDrawerWasQuickView) {
                sharedDrawer.upvQuickViewTrigger = null;
            }
        }
    );

    $(document).on("click", ".quickView", function(evt) {
        evt.preventDefault();
        let _this = $(this);
        var _url = $(this).data("href");
        const drawer = document.querySelector("[data-side-drawer]");
        const drawerBody = drawer && drawer.querySelector("[data-drawer-body]");
        const drawerTitle = drawer && drawer.querySelector("[data-drawer-title]");
        if (
            !drawer ||
            !drawerBody ||
            !drawerTitle ||
            typeof _url !== "string" ||
            !_url.trim()
        ) return;
        focusElement = this;
        drawer.upvQuickViewTrigger = this;
        var drawerOwnership = claimSharedDrawerOwnership(drawer, "quick-view");
        disposeProductVariantLifecycle(drawerBody);
        drawer.setAttribute("class", "yv_side_drawer_wrapper");
        drawer.setAttribute("id", "yv_quickView_product");
        drawer.classList.add("yv_quickView_product");
        drawerBody.innerHTML = preLoadLoadGif;
        drawerTitle.innerHTML = quickViewHeading;
        drawerBody.classList.add("searching");
        document.querySelector("body").classList.add("side_Drawer_open");
        if (_url.indexOf("?") > -1) {
            _url = _url.split("?");
            _url = _url[0];
        }
        $(".Quick_loader").fadeIn("slow");
        scheduleQuickViewRequest(
            drawer,
            _url + "?view=quick-view",
            function(data) {
                disposeProductVariantLifecycle(drawerBody);
                var preGuardCapture =
                    beginProductVariantPreGuardCapture(drawerBody);
                try {
                    drawerBody.innerHTML = data;
                    drawerBody.classList.remove("searching");
                    $(".Quick_loader").fadeOut("slow");
                    initQuickViewMediaSliders(drawerBody);
                    if (Shopify.PaymentButton) {
                        Shopify.PaymentButton.init();
                    }
                    productVariants(drawer);
                } finally {
                    finishProductVariantPreGuardCapture(preGuardCapture);
                }
                quantityChange();

                focusElementsRotation($("[data-side-drawer]"));
                $(document).find(".yv_side_drawer_wrapper").trigger("focus");
            },
            function() {
                drawerBody.classList.remove("searching");
                drawerBody.innerHTML = "";
                var fallbackLink = document.createElement("a");
                fallbackLink.href = _url;
                fallbackLink.className = "button";
                fallbackLink.textContent = quickViewHeading;
                drawerBody.appendChild(fallbackLink);
                $(".Quick_loader").fadeOut("slow");
            },
            drawerOwnership
        );
    });

    $(document).on("click", ".quickViewClose", function(evt) {
        evt.preventDefault();
        var quickViewDrawer = this.closest ?
            this.closest("[data-side-drawer]") : null;
        var isSharedQuickViewDrawer =
            isNativeQuickViewSharedDrawer(quickViewDrawer);
        var shouldRestoreQuickViewFocus =
            isSharedQuickViewDrawer || $("body").hasClass("quickview-open");
        if (isSharedQuickViewDrawer) {
            cancelSharedDrawerOwnership(quickViewDrawer);
            cancelQuickViewRequest(quickViewDrawer);
            hideQuickViewLoader();
            var quickViewDrawerBody = quickViewDrawer.querySelector(
                "[data-drawer-body]"
            );
            if (quickViewDrawerBody) {
                quickViewDrawerBody.classList.remove("searching");
            }
            disposeProductVariantLifecycle(quickViewDrawer);
            $("body")
                .removeClass("side_Drawer_open")
                .removeClass("yv_side_Drawer_open");
        }
        $("body").removeClass("quickview-open");
        if (shouldRestoreQuickViewFocus) {
            stopFocusElementsRotation();
            if (focusElement) {
                if (focusElement.nodeType) {
                    focusElement.focus();
                } else {
                    focusElement.trigger("focus");
                }
                focusElement = "";
            }
        }
        if (isSharedQuickViewDrawer) {
            quickViewDrawer.upvQuickViewTrigger = null;
        }
    });

    $(".flickity-slider > div").on("focus,keydown", function() {
        let index = $(this).index();
        $(this).closest(".flickity-enabled").flickity("select", index);
    });

    $(".yv-product-slider").on("scroll", function() {
        document.querySelectorAll(".yv-youtube-video").forEach((video) => {
            let left = video.getBoundingClientRect().left;
            if (!(left > -50 && left < window.innerWidth - 100)) {
                video.contentWindow.postMessage(
                    '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
                    "*"
                );
            }
        });
        document.querySelectorAll(".yv-vimeo-video").forEach((video) => {
            let left = video.getBoundingClientRect().left;
            if (!(left > -50 && left < window.innerWidth - 100)) {
                video.contentWindow.postMessage('{"method":"pause"}', "*");
            }
        });
        document.querySelectorAll("video").forEach((video) => {
            let left = video.getBoundingClientRect().left;
            if (!video.hasAttribute("autoplay")) {
                if (!(left > -50 && left < window.innerWidth - 100)) {
                    video.pause();
                }
            }
        });
    });
    $(document).on("click", ".video-play-btn", function(e) {
        e.preventDefault();
        $(this).closest(".video-overlay-text").hide();
        $(this)
            .closest(".shopify-section")
            .find(".yv-feature-videobox")
            .addClass("video-loaded");
        $(this).closest(".shopify-section").find(".video-banner-file").show();
    });
});
var upvFlickityResizeTimer;
jQuery(window).off("resize.upvFlickity").on("resize.upvFlickity", function() {
    clearTimeout(upvFlickityResizeTimer);
    upvFlickityResizeTimer = setTimeout(function() {
        var sliders = jQuery("body").find("[data-flickity-slider]");
        if (sliders.length > 0) {
            sliders.each(function(index) {
                var _this = jQuery(this);
                if (_this.hasClass("flickity-enabled")) {
                    _this.flickity("resize");
                }
            });
        }
        upvFlickityResizeTimer = undefined;
    }, 1000);
});

function viewcategoryInit() {
    $(".yv-browse-category-link").click(function(e) {
        $('#view-catalog').show();
        if ($('body').hasClass('catalog-open')) {
            $('body').removeClass('catalog-open');
            $('#view-catalog').hide();
        } else {
            $('body').addClass('catalog-open');
            $('#view-catalog').show();
        }
        
    });
}

$(document).on("click", ".menu-tab", function() {
    if ($(this).hasClass("active")) return false;
    $(".menu-tab").removeClass('active')
    $('#mobileMenu').find('.tabcontent').addClass('hidden')
    $(this).addClass("active");
    $($(this).attr('data-tab')).removeClass('hidden');
});
// $(document).on("click",".yv-mobile-category",function(){
//    $("#side-catalog").removeClass('hidden');
// });

function getFirstAvailableVariant(options, type, selector, allVariants) {
    let availableVariant = null,
        slicedCount = 0;
    do {
        options.pop();
        slicedCount += 1;
        availableVariant = allVariants.find((variant) => {
            return variant["options"].slice(0, variant["options"].length - slicedCount).every((value, index) => value === options[index]);
        });
    } while (!availableVariant && options.length > 0);
    if (availableVariant) {
        let fieldsets = Array.from(selector.querySelectorAll(".product-loop-variants"));
        fieldsets.forEach((fieldset, index) => {
            if (variantStyle == "dropdown") {
                let option = fieldset.querySelector('select')
                if (option && option.value != availableVariant['options'][index]) {
                    option.value = availableVariant['options'][index];
                }
            } else {
                let option = fieldset.querySelector('input[value="' + availableVariant['options'][index] + '"]')
                if (option && option.checked == false) {
                    option.click();
                }
            }
        });
    }
    return availableVariant;
}
/* get variant based on selected options end */
const classAddToSelector = (selector, valueIndex, available, combinationExists) => {
    if (variantStyle == 'swatch') {
        const optionValue = Array.from(selector.querySelectorAll(".productOption"))[valueIndex];
        optionValue.parentElement.classList.toggle("hidden", !combinationExists);
        optionValue.classList.toggle("not-available", !available);
    } else {
        const optionValue = Array.from(selector.querySelectorAll(".productOption option"))[valueIndex];
        optionValue.classList.toggle("hidden", !combinationExists);
        optionValue.toggleAttribute("disabled", !available);
    }
};

function updateOptionsAvailability(product, productOptions, selectedVariant, optionSelectors, variantStyle) {
    if (!selectedVariant) {
        return;
    }
    if (optionSelectors && optionSelectors[0]) {
        productOptions[0]["values"].forEach((value, valueIndex) => {
            const combinationExists = product.some((variant) => variant["option1"] === value && variant),
                availableVariantExists = product.some((variant) => variant["option1"] === value && variant["available"]);
            classAddToSelector(optionSelectors[0], valueIndex, availableVariantExists, combinationExists);
            if (optionSelectors[1]) {
                productOptions[1]["values"].forEach((value2, valueIndex2) => {
                    const combinationExists2 = product.some((variant) => variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant),
                        availableVariantExists2 = product.some((variant) => variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant["available"]);
                    classAddToSelector(optionSelectors[1], valueIndex2, availableVariantExists2, combinationExists2);
                    if (optionSelectors[2]) {
                        productOptions[2]["values"].forEach((value3, valueIndex3) => {
                            const combinationExists3 = product.some((variant) => variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant),
                                availableVariantExists3 = product.some((variant) => variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant["available"]);
                            classAddToSelector(optionSelectors[2], valueIndex3, availableVariantExists3, combinationExists3);
                        });
                    }
                });
            }
        });
    }
}


function productGiftOptions() {
    let giftCardWrappers = document.querySelectorAll('[data-gift-card-box]');
    Array.from(giftCardWrappers).forEach(function(giftCard) {
        let jsCheck = giftCard.querySelector('[data-js-gift-card-selector]')
        if (jsCheck) {
            jsCheck.disabled = false;
            jsCheck.addEventListener('click', function() {
                let giftCardContent = giftCard.querySelector('[data-gift-card-content]');
                if (jsCheck.checked) {
                    DOMAnimations.slideDown(giftCardContent, 500);
                } else {
                    DOMAnimations.slideUp(giftCardContent, 500);
                }
            })
        }
        let noJsCheck = giftCard.querySelector('[data-no-js-gift-card-selector]')
        if (noJsCheck) {
            noJsCheck.disabled = true;
        }

    })

}

const UPVANITY_RECENTLY_VIEWED_STORAGE_KEY = "yv-recently-viewed";
const UPVANITY_RECENTLY_VIEWED_STORAGE_LIMIT = 14;
const UPVANITY_RECENTLY_VIEWED_RENDER_LIMIT = 6;

function createUpvanityRecentlyViewedController() {
    const wrapperSelector = "[data-recent-viewed-products]";
    const currentProductSelector = "[data-recently-viewed-current-product]";
    const requestDeadlineMs = 15000;
    const states = new WeakMap();
    const pendingStates = new Set();
    let destroyed = false;
    let pageShowFrame = 0;
    let pageShowTimer = 0;
    let pageShowFocusPending = false;

    function elementsInScope(scope, selector) {
        if (!scope || typeof scope.querySelectorAll !== "function") return [];
        const elements = [];
        if (scope.nodeType === 1 && typeof scope.matches === "function" && scope.matches(selector)) {
            elements.push(scope);
        }
        return elements.concat(Array.from(scope.querySelectorAll(selector)));
    }

    function normalizeProductId(value) {
        const productId = String(value == null ? "" : value).trim();
        return /^[1-9][0-9]*$/.test(productId) ? productId : "";
    }

    function normalizeHistory(value) {
        if (!Array.isArray(value)) return [];
        const history = [];
        const seen = new Set();
        for (let index = 0; index < value.length && history.length < UPVANITY_RECENTLY_VIEWED_STORAGE_LIMIT; index += 1) {
            const productId = normalizeProductId(value[index]);
            if (!productId || seen.has(productId)) continue;
            seen.add(productId);
            history.push(productId);
        }
        return history;
    }

    function readHistory() {
        try {
            const storedHistory = window.localStorage.getItem(UPVANITY_RECENTLY_VIEWED_STORAGE_KEY);
            if (storedHistory && storedHistory.length > 4096) return [];
            return normalizeHistory(storedHistory ? JSON.parse(storedHistory) : []);
        } catch (error) {
            return [];
        }
    }

    function writeHistory(history) {
        try {
            window.localStorage.setItem(
                UPVANITY_RECENTLY_VIEWED_STORAGE_KEY,
                JSON.stringify(history)
            );
            return true;
        } catch (error) {
            return false;
        }
    }

    function recordProduct(productId) {
        const currentProduct = normalizeProductId(productId);
        const history = readHistory();
        if (!currentProduct) return history;
        const updatedHistory = [currentProduct].concat(
            history.filter(function(historyProduct) {
                return historyProduct !== currentProduct;
            })
        ).slice(0, UPVANITY_RECENTLY_VIEWED_STORAGE_LIMIT);
        writeHistory(updatedHistory);
        return updatedHistory;
    }

    function setSectionVisible(wrapper, visible) {
        const section = wrapper && typeof wrapper.closest === "function" ?
            wrapper.closest(".shopify-section") : null;
        if (section) section.classList.toggle("hidden", !visible);
    }

    function clearWrapper(wrapper) {
        wrapper.innerHTML = "";
        wrapper.removeAttribute("aria-busy");
        setSectionVisible(wrapper, false);
    }

    function finishState(state) {
        if (state.deadlineTimer !== null) {
            window.clearTimeout(state.deadlineTimer);
            state.deadlineTimer = null;
        }
        state.finished = true;
        if (state.status === "loading") state.status = "idle";
        pendingStates.delete(state);
        if (states.get(state.wrapper) === state) state.wrapper.removeAttribute("aria-busy");
    }

    function abortState(wrapper, removeState) {
        const state = states.get(wrapper);
        if (!state) return;
        state.generation += 1;
        finishState(state);
        if (state.controller) state.controller.abort();
        if (removeState) states.delete(wrapper);
    }

    function responseOrder(recommendations, productIds) {
        const order = new Map(productIds.map(function(productId, index) {
            return [productId, index];
        }));
        const seen = new Set();
        const children = Array.from(recommendations.children).filter(function(child) {
            const product = child.matches("[data-product-id]") ?
                child : child.querySelector("[data-product-id]");
            const productId = product ? normalizeProductId(product.dataset.productId) : "";
            if (!productId || !order.has(productId) || seen.has(productId)) {
                child.remove();
                return false;
            }
            seen.add(productId);
            child.dataset.recentlyViewedProductId = productId;
            return true;
        });
        children.sort(function(left, right) {
            return order.get(left.dataset.recentlyViewedProductId) -
                order.get(right.dataset.recentlyViewedProductId);
        });
        children.slice(0, UPVANITY_RECENTLY_VIEWED_RENDER_LIMIT).forEach(function(child) {
            delete child.dataset.recentlyViewedProductId;
            recommendations.appendChild(child);
        });
        return Math.min(children.length, UPVANITY_RECENTLY_VIEWED_RENDER_LIMIT);
    }

    function isCurrent(wrapper, state) {
        return !destroyed && !state.finished && wrapper.isConnected && states.get(wrapper) === state &&
            wrapper.dataset.section === state.sectionUrl &&
            normalizeProductId(wrapper.dataset.product) === state.currentProduct;
    }

    function hydrateWrapper(wrapper, history) {
        const currentProduct = normalizeProductId(wrapper.dataset.product);
        const productIds = history.filter(function(productId) {
            return productId !== currentProduct;
        }).slice(0, UPVANITY_RECENTLY_VIEWED_RENDER_LIMIT);

        if (!productIds.length) {
            abortState(wrapper, true);
            clearWrapper(wrapper);
            return;
        }

        const sectionUrl = wrapper.dataset.section || "";
        if (!sectionUrl) {
            abortState(wrapper, true);
            clearWrapper(wrapper);
            return;
        }

        const requestUrl = sectionUrl + encodeURIComponent(
            productIds.map(function(productId) {
                return "id:" + productId;
            }).join(" OR ")
        );
        const existingState = states.get(wrapper);
        if (existingState && existingState.requestUrl === requestUrl &&
            (existingState.status === "loading" || existingState.status === "loaded")) {
            return;
        }

        abortState(wrapper, true);
        const controller = typeof AbortController === "function" ? new AbortController() : null;
        const state = {
            controller: controller,
            currentProduct: currentProduct,
            deadlineTimer: null,
            finished: false,
            generation: existingState ? existingState.generation + 1 : 1,
            productIds: productIds,
            requestUrl: requestUrl,
            sectionUrl: sectionUrl,
            status: "loading",
            wrapper: wrapper
        };
        states.set(wrapper, state);
        pendingStates.add(state);
        wrapper.setAttribute("aria-busy", "true");
        state.deadlineTimer = window.setTimeout(function() {
            if (state.finished) return;
            state.status = "timeout";
            finishState(state);
            if (state.controller) state.controller.abort();
        }, requestDeadlineMs);

        const fetchOptions = controller ? { signal: controller.signal } : undefined;
        let request;
        try {
            request = fetch(requestUrl, fetchOptions);
        } catch (error) {
            request = Promise.reject(error);
        }
        request
            .then(function(response) {
                if (!isCurrent(wrapper, state)) return;
                if (!response.ok) {
                    throw new Error("Recently viewed request failed with status " + response.status);
                }
                return response.text();
            })
            .then(function(text) {
                if (!isCurrent(wrapper, state)) return;
                const html = document.createElement("div");
                html.innerHTML = text;
                const recommendations = html.querySelector(wrapperSelector);
                if (!recommendations) {
                    throw new Error("Recently viewed response did not contain its section root");
                }
                if (!recommendations.innerHTML.trim().length ||
                    responseOrder(recommendations, state.productIds) === 0) {
                    clearWrapper(wrapper);
                    state.status = "empty";
                    return;
                }
                wrapper.innerHTML = recommendations.innerHTML;
                setSectionVisible(wrapper, true);
                try {
                    gridPickUpAvailability(wrapper);
                } catch (error) {
                    console.error("Recently viewed pickup initialization failed", error);
                }
                state.status = "loaded";
            })
            .catch(function(error) {
                if (!isCurrent(wrapper, state)) return;
                state.status = "error";
                if (error && error.name === "AbortError") return;
                console.error("Recently viewed products failed to load", error);
            })
            .then(function() {
                finishState(state);
            });
    }

    function currentProductInScope(scope, wrappers) {
        const currentMarkers = elementsInScope(scope, currentProductSelector);
        let currentProduct = "";
        for (let index = 0; index < currentMarkers.length && !currentProduct; index += 1) {
            currentProduct = normalizeProductId(
                currentMarkers[index].dataset.recentlyViewedCurrentProduct
            );
        }
        for (let index = 0; index < wrappers.length && !currentProduct; index += 1) {
            currentProduct = normalizeProductId(wrappers[index].dataset.product);
        }
        return currentProduct;
    }

    function refresh(scope = document) {
        if (destroyed) return;
        const wrappers = elementsInScope(scope, wrapperSelector);
        const currentProduct = currentProductInScope(scope, wrappers);
        if (!currentProduct && !wrappers.length) return;
        const history = currentProduct ? recordProduct(currentProduct) : readHistory();
        wrappers.forEach(function(wrapper) {
            hydrateWrapper(wrapper, history);
        });
    }

    function unload(scope) {
        elementsInScope(scope, wrapperSelector).forEach(function(wrapper) {
            abortState(wrapper, true);
        });
    }

    function cancelPageShowRefresh() {
        if (pageShowFrame && typeof window.cancelAnimationFrame === "function") {
            window.cancelAnimationFrame(pageShowFrame);
        }
        if (pageShowTimer) window.clearTimeout(pageShowTimer);
        if (pageShowFocusPending) {
            document.removeEventListener("focusin", handlePageShowFocusIn, true);
            document.removeEventListener("focusout", handlePageShowFocusOut, true);
        }
        pageShowFrame = 0;
        pageShowTimer = 0;
        pageShowFocusPending = false;
    }

    function focusInsideRecentlyViewed(candidate, wrappers) {
        return candidate && wrappers.some(function(wrapper) {
            return wrapper.contains(candidate);
        });
    }

    function handlePageShowFocusIn(event) {
        const wrappers = elementsInScope(document, wrapperSelector);
        if (focusInsideRecentlyViewed(event.target, wrappers)) return;
        cancelPageShowRefresh();
        refresh(document);
    }

    function runPageShowFocusOutCheck() {
        pageShowFrame = 0;
        pageShowTimer = 0;
        if (destroyed || !pageShowFocusPending) return;
        const wrappers = elementsInScope(document, wrapperSelector);
        if (focusInsideRecentlyViewed(document.activeElement, wrappers)) return;
        cancelPageShowRefresh();
        refresh(document);
    }

    function handlePageShowFocusOut(event) {
        if (!pageShowFocusPending) return;
        const wrappers = elementsInScope(document, wrapperSelector);
        if (!focusInsideRecentlyViewed(event.target, wrappers)) return;
        if (pageShowFrame || pageShowTimer) return;
        if (typeof window.requestAnimationFrame === "function") {
            pageShowFrame = window.requestAnimationFrame(runPageShowFocusOutCheck);
        } else {
            pageShowTimer = window.setTimeout(runPageShowFocusOutCheck, 0);
        }
    }

    function runPageShowRefresh() {
        pageShowFrame = 0;
        pageShowTimer = 0;
        if (destroyed) return;
        const wrappers = elementsInScope(document, wrapperSelector);
        const activeElement = document.activeElement;
        if (focusInsideRecentlyViewed(activeElement, wrappers)) {
            const currentProduct = currentProductInScope(document, wrappers);
            if (currentProduct) recordProduct(currentProduct);
            pageShowFocusPending = true;
            document.addEventListener("focusin", handlePageShowFocusIn, true);
            document.addEventListener("focusout", handlePageShowFocusOut, true);
            return;
        }
        refresh(document);
    }

    function handlePageShow(event) {
        if (!event || event.persisted !== true) return;
        cancelPageShowRefresh();
        if (typeof window.requestAnimationFrame === "function") {
            pageShowFrame = window.requestAnimationFrame(runPageShowRefresh);
        } else {
            pageShowTimer = window.setTimeout(runPageShowRefresh, 0);
        }
    }

    function destroy() {
        if (destroyed) return;
        destroyed = true;
        cancelPageShowRefresh();
        window.removeEventListener("pageshow", handlePageShow);
        pendingStates.forEach(function(state) {
            state.generation += 1;
            finishState(state);
            if (state.controller) state.controller.abort();
        });
        pendingStates.clear();
    }

    window.addEventListener("pageshow", handlePageShow);

    return {
        version: 1,
        refresh: refresh,
        unload: unload,
        destroy: destroy,
        normalizeHistory: normalizeHistory,
        recordProduct: recordProduct,
        debugState: function(wrapper) {
            const state = states.get(wrapper);
            return state ? {
                currentProduct: state.currentProduct,
                productIds: state.productIds.slice(),
                requestUrl: state.requestUrl,
                status: state.status
            } : null;
        }
    };
}

function getUpvanityRecentlyViewedController() {
    let controller = window.UpvanityRecentlyViewedController;
    if (!controller || controller.version !== 1) {
        if (controller && typeof controller.destroy === "function") controller.destroy();
        controller = createUpvanityRecentlyViewedController();
        window.UpvanityRecentlyViewedController = controller;
    }
    return controller;
}

function recentlyViewedProducts(section = document) {
    return getUpvanityRecentlyViewedController().refresh(section);
}

function unloadRecentlyViewedProducts(section) {
    const controller = window.UpvanityRecentlyViewedController;
    if (controller && controller.version === 1) controller.unload(section);
}

function isOnScreenVisible(elm) {
    const rect = elm.getBoundingClientRect();
    const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
}

function getOffsetTop(elm) {
    if (!elm.getClientRects().length) {
        return 0;
    }
    const rect = elm.getBoundingClientRect();
    const win = elm.ownerDocument.defaultView;
    return rect.top + win.pageYOffset;
}

function lookbookscrollItem(currentSlideMedia, scrollValue) {
    currentSlideMedia.style.height = `${scrollValue}px`;
}

function lookbookScrollContent() {

    if (window.innerWidth > 767) {
        var sliderItems = document.querySelectorAll("[data-lookbook-container]");
        var currentScroll = window.scrollY;
        var scrollEnabled = true;
        var screenHeight = Math.min(window.innerHeight, window.screen.availHeight);
        Array.from(sliderItems).forEach(function(slideritem) {
            var slides = slideritem.querySelectorAll('.lookbook-items');
            var slidesMediaItem = slideritem.querySelectorAll('.left-box > div');
            slides.forEach((elm, key) => {
                if (key == 0 || window.scrollY >= getOffsetTop(elm)) {
                    slidesMediaItem[key].style.height = `100%`;
                } else {
                    slidesMediaItem[key].style.height = `0`;
                }
            });
            let previous = -1,
                currentOld = -1;
            let scrollHelper = () => {
                const scrollTop = window.scrollY >= 0 ? window.scrollY : 0;
                const sliderTop = getOffsetTop(slideritem);
                if (scrollEnabled) {
                    let current = 0;
                    if (scrollTop < getOffsetTop(slideritem) && !slideritem.classList.contains('lookbook-to-normal')) {
                        slideritem.classList.add('lookbook-to-normal');
                    }
                    slides.forEach((elm, key) => {
                        if (isOnScreenVisible(elm)) {
                            current = key;
                        }
                    });
                    if (current != currentOld) {
                        if (currentScroll < scrollTop && currentOld > 0) {
                            lookbookscrollItem(slidesMediaItem[currentOld], screenHeight);
                        } else if (currentScroll > window.scrollY && currentOld > 0) {
                            lookbookscrollItem(slidesMediaItem[currentOld], 0);
                        }
                        currentOld = current;
                        previous = current - 1;
                    }
                    if (current == 0 && scrollTop + screenHeight >= sliderTop + slideritem.offsetHeight && !slideritem.classList.contains('lookbook-to-normal')) {
                        slideritem.classList.add('lookbook-to-normal');
                    } else if (current > 0) {
                        const scrollValue = (scrollTop - sliderTop) - screenHeight * (current - 1);
                        if (scrollTop + screenHeight >= sliderTop + slideritem.offsetHeight && !slideritem.classList.contains('lookbook-to-normal')) {
                            slideritem.classList.add('lookbook-to-normal');
                        } else if (scrollTop + screenHeight < sliderTop + slideritem.offsetHeight && slideritem.classList.contains('lookbook-to-normal')) {
                            slideritem.classList.remove('lookbook-to-normal');
                        }
                        if (!slideritem.classList.contains('lookbook-to-normal')) {
                            lookbookscrollItem(slidesMediaItem[current], scrollValue);
                        }
                    }

                }
                currentScroll = scrollTop;
            }

            window.addEventListener('scroll', scrollHelper, { passive: true });
            scrollHelper();


        })
    }

}
window.addEventListener("resize", function() {
    if (window.innerWidth > 767) {
        lookbookScrollContent();
    }
});

$(document).click(function(event) {
    var container = $(".yv-header-searchbar-box");
    if (!container.is(event.target) && !container.has(event.target).length) {
        $('.yv-header-searchbar-content').hide();
    }
});


function gridPickUpAvailability(section = document) {
    let gridElements = section.querySelectorAll('.grid-pickup-availability-preview-container');
    Array.from(gridElements).forEach(function(grid) {
        var preferredStore = localStorage.getItem('preferredStore');
        var pickupElements = grid.querySelectorAll('.grid__avail-pickup');
        Array.from(pickupElements).forEach(function(element) {
            element.classList.add('hidden')
        })
        if (preferredStore == null && grid.querySelector("[data-select-store]")) {
            grid.querySelector("[data-select-store]").classList.remove('hidden')
        } else {
            let currentPickupStore = grid.querySelector('.grid__avail-pickup[data-store="' + preferredStore + '"]');
            if (currentPickupStore) {
                currentPickupStore.classList.remove('hidden')
            } else if (grid.querySelector("[data-store-unavailable]")) {
                grid.querySelector("[data-store-unavailable]").querySelector('[data-location-name]').textContent = preferredStore;
                grid.querySelector("[data-store-unavailable]").classList.remove('hidden')
            }
        }
    })
}

function initStoreLocator() {
    const preferredStoreKey = "preferredStore";
    const storeLocatorItems = document.querySelectorAll(".yv-store-locator-details-item");
    const modalWrapper = document.querySelector('.yv-store-locator-wrapper');

    const updatePreferredStore = (storeName) => {
        localStorage.setItem(preferredStoreKey, storeName);
        gridPickUpAvailability();
    };

    const getPreferredStore = () => localStorage.getItem(preferredStoreKey);

    const closeModal = () => {
        modalWrapper.style.display = 'none';
        modalWrapper.classList.remove("store-locator-visible");
        document.querySelector('body').classList.remove('store-locator-open');
    };

    const button = document.querySelector('.yv-store-locator-btn');
    const closebutton = document.querySelector('.yv-store-locator-close');
    if (button) {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            modalWrapper.style.display = 'flex';
            modalWrapper.classList.add("store-locator-visible");
            document.querySelector('body').classList.add('store-locator-open');
            initStoreMap();
        });
    }
    if (closebutton) {
        closebutton.addEventListener('click', (event) => {
            event.preventDefault();
            closeModal();
        });
    }
    const preferredStore = getPreferredStore();
    if (preferredStore) {
        const preferredStoreItem = document.querySelector(`.yv-store-locator-details-item[data-label="${preferredStore}"]`);
        if (preferredStoreItem) {
            preferredStoreItem.classList.add('active');
        }
    }

    const changePreferredStoreButton = document.querySelector('.store-location-save');
    if (changePreferredStoreButton) {
        changePreferredStoreButton.addEventListener('click', () => {
            const activeItem = document.querySelector('.yv-store-locator-details-item.active');
            if (activeItem) {
                const storeName = activeItem.getAttribute('data-label');
                updatePreferredStore(storeName);
                closeModal();
            }
        });
    }
    if (storeLocatorItems.length > 0) {
        const script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + googleMapApiKey + '&callback=initStoreMap';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
    }
}

async function getGeoDetails(geocoder, address) {
    let getAddress = new Promise(function(resolve, reject) {
        geocoder.geocode({ 'address': address }, function(results, status) {
            if (status === 'OK') {
                resolve([results[0].geometry.location.lat(), results[0].geometry.location.lng()]);
            } else {
                reject(new Error('Couldnt\'t find the location ' + address));
            }
        })
    })
    return await getAddress;
}

function initStoreMap() {
    setTimeout(() => {
        let geocoder = new google.maps.Geocoder();
        const storeLocatorItems = document.querySelectorAll(".yv-store-locator-details-item");
        if (storeLocatorItems.length == 0) { return false; }
        const preferredStoreKey = "preferredStore";
        const map = new google.maps.Map(document.querySelector(".yv-store-locator-map"), {
            center: { lat: 0, lng: 0 },
            zoom: 8,
            mapTypeControl: false,
            streetViewControl: false,
            scrollwheel: false
        });
        const markers = [];

        const createMarker = (position) => {
            return new google.maps.Marker({
                position: position,
                map: map,
                icon: document.querySelector('.yv-store-locator-map').getAttribute('data-marker')
            });
        };

        const updateMap = (latitude, longitude) => {
            map.setCenter({ lat: latitude, lng: longitude });
            map.setZoom(15);
            markers.forEach(marker => marker.setMap(null));
            const position = { lat: latitude, lng: longitude };
            const marker = createMarker(position);
            markers.push(marker);
        };

        let activeItem = document.querySelector(".yv-store-locator-details-item.active");

        if (!activeItem) {
            activeItem = document.querySelector(".yv-store-locator-details-item");
        }

        // const latitude = parseFloat(activeItem.getAttribute("data-latitude"));
        // const longitude = parseFloat(activeItem.getAttribute("data-longitude"));
        let address = activeItem.getAttribute("data-address")
            // updateMap(latitude, longitude);
        let geoDetail = getGeoDetails(geocoder, address);
        geoDetail.then(function(address) {
            if (geoDetail != null) {
                updateMap(address[0], address[1]);
            }
        })
        storeLocatorItems.forEach(item => {
            item.addEventListener("click", () => {
                // const latitude = parseFloat(item.getAttribute("data-latitude"));
                // const longitude = parseFloat(item.getAttribute("data-longitude"));
                const storeName = item.getAttribute("data-label");
                let address = item.getAttribute("data-address")
                storeLocatorItems.forEach(sibling => {
                    if (sibling !== item) {
                        sibling.classList.remove('active');
                    }
                });

                item.classList.add('active');
                // updateMap(latitude, longitude);
                let geoDetail = getGeoDetails(geocoder, address);
                geoDetail.then(function(address) {
                    if (geoDetail != null) {
                        updateMap(address[0], address[1]);
                    }
                })
            });
        });
    }, 100);
}

function productQueryForm() {
    const button = document.querySelector('.yv-ask-question-btn');
    const addonmodalWrapper = document.querySelector('.yv-addon-button-wrapper');
    const addonclosebutton = document.querySelector('.yv-addon-button-close');
    if (button) {
        button.addEventListener('click', (event) => {
            addonmodalWrapper.style.display = "flex";
            document.querySelector("body").classList.add("query-form-open");
        })
    }
    if (addonmodalWrapper) {
        function addoncloseModal() {
            addonmodalWrapper.style.display = 'none';
            document.querySelector("body").classList.remove("query-form-open");
        };
    }
    if (addonclosebutton) {
        addonclosebutton.addEventListener('click', (event) => {
            event.preventDefault();
            addoncloseModal();
        });
    }

}

function timelineNavInit(section = document) {
    let navsElements = section.querySelectorAll('[data-timeline-nav]');
    Array.from(navsElements).forEach(function(nav) {
        nav.addEventListener('click', () => {
            if (nav.classList.contains('active')) { return false; }
            let _section = nav.closest('.shopify-section');
            let activeNav = _section.querySelector('.yv-timeline-nav.active')
            if (activeNav) {
                activeNav.classList.remove('active')
                nav.closest('.yv-timeline-nav').classList.add('active')
            }
            let focusContentSlider = Flickity.data('#' + nav.getAttribute('data-focus-content'));
            let focusIndex = nav.getAttribute('data-index')
            if (focusContentSlider && focusIndex) {
                focusContentSlider.select(focusIndex)
            }
        });
    })
}


function collectionHoverNavInit(section = document) {
    let navsElements = section.querySelectorAll('[data-hover-collection-item]');
    Array.from(navsElements).forEach(function(nav) {
        nav.addEventListener('mouseover', () => {
            collectionHoverAction(nav);
        });
    })
}

function collectionHoverAction(nav) {
    if (nav.classList.contains('active')) { return false; }
    let _section = nav.closest('.shopify-section');
    let activeImage = _section.querySelector('.featured-collections-banner-img.active')
    let activeNav = _section.querySelector('[data-hover-collection-item].active')
    if (activeNav) {
        activeNav.classList.remove('active')
        nav.classList.add('active')
    }
    let currentItemID = nav.getAttribute('data-media')
    let currentMedia = _section.querySelector('#' + currentItemID);
    let _name = nav.textContent;
    let _href = nav.getAttribute('data-href')
    let nameSelector = _section.querySelector('[data-collection-banner-title]')
    if (currentMedia) {
        activeImage.classList.remove('active')
        currentMedia.classList.add('active')
    }
    if (nameSelector) {
        nameSelector.textContent = _name;
        if (_href != null) {
            nameSelector.removeAttribute('role')
            nameSelector.removeAttribute('aria-disabled')
            nameSelector.setAttribute('href', _href)
        } else {
            nameSelector.removeAttribute('href')
            nameSelector.setAttribute('aria-disabled', true)
            nameSelector.setAttribute('role', 'link')
        }
    }
    if (_section.querySelector('[data-collection-banner-description]')) {
        if (nav.nextElementSibling) {
            _section.querySelector('[data-collection-banner-description]').textContent = nav.nextElementSibling.textContent;
            _section.querySelector('[data-collection-banner-description]').classList.remove('hidden')
        } else {
            _section.querySelector('[data-collection-banner-description]').classList.add('hidden')
        }
    }
}

function newsletterSidebar() {
    const button = document.querySelector('.yv-discount-panel');
    const newslettermodalWrapper = document.querySelector('.yv-discount-sidebar-element');
    const newsletterclosebutton = document.querySelector('.yv-newsletter-popup-button-close');
    if (button) {
        button.addEventListener('click', (event) => {
            newslettermodalWrapper.style.display = "flex";
            document.querySelector("body").classList.add("newsletter-popup-open");
        })
    }
    if (newslettermodalWrapper) {
        function newslettercloseModal() {
            newslettermodalWrapper.style.display = 'none';
            document.querySelector("body").classList.remove("newsletter-popup-open");
        };
    }
    if (newsletterclosebutton) {
        newsletterclosebutton.addEventListener('click', (event) => {
            event.preventDefault();
            newslettercloseModal();
        });
    }

}

// Set the sale end date as a JavaScript variable
function pdpCountdown() {
    Array.from(document.querySelectorAll('[data-product-countdown]')).forEach(function(countdownElement) {
        var EndDate = countdownElement.getAttribute('data-product-countdown');
        if (EndDate != null) {
            var saleEndDate = new Date(EndDate);
            // Function to update the countdown timer
            let pdpCountdownInterval = setInterval(function() {
                var now = new Date();
                var timeRemaining = saleEndDate - now;

                var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
                var hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

                countdownElement.querySelector('#dDays1').innerHTML = days;
                countdownElement.querySelector('#dHours1').innerHTML = hours;
                countdownElement.querySelector('#dMinutes1').innerHTML = minutes;
                countdownElement.querySelector('#dSeconds1').innerHTML = seconds;

                if (timeRemaining <= 0) {
                    countdownElement.style.display = "none";
                    clearInterval(pdpCountdownInterval);
                }
            }, 1000);
        }
    })
}

function updateBackInStock(variant, container) {
    if (container) {
        let backInStockWrapper = container.querySelector('[data-back-in-stock]')
        if (backInStockWrapper) {
            let backInStockVariant = container.querySelector('[data-variant-title]')
            let backInStockVariantUrl = container.querySelector('[data-variant-url]')
            if (variant != undefined) {
                let baseUrl = getProductVariantBasePath(container);
                if (baseUrl.indexOf("/products/") > -1) {
                    let _updateUrl = baseUrl + "?variant=" + variant.id + "&contact_posted=true";
                    backInStockVariantUrl.value = _updateUrl;
                }
                backInStockVariant.value = variant.name;
                if (variant.available) {
                    if (!Shopify.designMode) {
                        backInStockWrapper.classList.add('hidden')
                    }
                } else {
                    backInStockWrapper.classList.remove('hidden')
                }
            } else {
                if (!Shopify.designMode) {
                    backInStockWrapper.classList.add('hidden')
                }
            }
        }
    }
}

function toggleForm(event) {
    event.preventDefault();
    let element = event.target;
    let elementParent = element.closest('.account-wrapper')
    let closeElement = elementParent.querySelector('#' + element.dataset.close)
    let openElement = elementParent.querySelector('#' + element.dataset.open)
    if (openElement && closeElement) {
        closeElement.style.display = 'none'
        openElement.style.display = 'block'
    }
}

function toggleAccountPopup(event, accountType) {
    event.preventDefault();
    let element = event.target;
    if (accountType == 'dropdown') {
        let toggleElement = document.querySelector('[data-account-dropdown]');
        if (toggleElement) {
            DOMAnimations.slideToggle(toggleElement, 250);
        }
    } else {
        let toggleElement = document.querySelector('[data-account-popup]');
        if (toggleElement) {
            document.querySelector('body').classList.add('account-popup-open')
        }
    }
}

function toggleStoreDetails(event) {
    event.preventDefault();
    let element = event.target;
    let parent = element.closest('[data-store-wrapper]')
    let toggleElement = parent.querySelector('[data-store-location-dropdown]');
    if (parent.classList.contains('customer-support-mobile')) {
        $(".toggle-level,.list-menu__item.toggle").removeClass("open-menu-drop"),
            $(".inner").removeClass("is-open"),
            $(".inner").slideUp("slow");
    }
    if (toggleElement) {
        DOMAnimations.slideToggle(toggleElement, 250);
    }
}

function initSearchPrompts(section = document) {
    let inputElements = section.querySelectorAll('[data-search-drawer-query-input]');
    let typingSpeed = 100;
    let deletingSpeed = 60;
    let delayAfterDeleting = 500;
    let delayBeforeFirstDelete = 2000;
    let delayAfterWordTyped = 2400;
    Array.from(inputElements).forEach(function(input) {
        if (input.classList.contains("enable-searchpromt")) {
            let placeholders = [];
            if (input.placeholder) {
                placeholders.push(input.placeholder);
            }

            if (input.dataset.placeholderTwo) {
                placeholders.push(input.dataset.placeholderTwo);
            }

            if (input.dataset.placeholderThree) {
                placeholders.push(input.dataset.placeholderThree);
            }

            async function typeInNextPlaceholder(placeholder) {
                await new Promise((resolve) => {
                    let currentPlaceholder = input.getAttribute('placeholder');
                    let nextPlaceholder = (currentPlaceholder.length >= 3 &&
                            placeholder.startsWith(currentPlaceholder)) ?
                        placeholder.replace(currentPlaceholder, '') :
                        placeholder;

                    const typingIntervalId = setInterval(() => {
                        currentPlaceholder = input.getAttribute('placeholder');
                        input.setAttribute('placeholder', currentPlaceholder + nextPlaceholder.charAt(0));
                        if (nextPlaceholder.length === 1) {
                            resolve();
                            clearInterval(typingIntervalId);
                        } else {
                            nextPlaceholder = nextPlaceholder.substring(1);
                        }
                    }, typingSpeed);
                });
            }

            async function deleteCurrentPlaceholder(nextPlaceholder) {
                await new Promise((resolve) => {
                    let prevPlaceholder = input.getAttribute('placeholder');
                    const deletionIntervalId = setInterval(() => {
                        const newPlaceholder = prevPlaceholder.substring(0, prevPlaceholder.length - 1);
                        input.setAttribute('placeholder', newPlaceholder);
                        prevPlaceholder = newPlaceholder;
                        if (prevPlaceholder.length === 0 ||
                            (prevPlaceholder.length >= 3 && nextPlaceholder.startsWith(prevPlaceholder))) {
                            resolve();
                            clearInterval(deletionIntervalId);
                        }
                    }, deletingSpeed);
                });
            }

            let startIndex = 0;

            function showNextPlaceholder() {
                startIndex = (startIndex + 1) % placeholders.length;
                const nextPlaceholder = placeholders[startIndex];
                deleteCurrentPlaceholder(nextPlaceholder).then(() => {
                    setTimeout(() => {
                        typeInNextPlaceholder(nextPlaceholder).then(() => {
                            setTimeout(showNextPlaceholder, delayAfterWordTyped);
                        });
                    }, delayAfterDeleting);
                });
            }

            setTimeout(showNextPlaceholder, delayBeforeFirstDelete);
        }
    });

}

function switchSwatchMedia(event) {
    let element = event.target;
    if (element.classList.contains('active')) return false;
    let mediaParent = element.closest('[data-color-wrapper]');
    let gridParent = element.closest('[data-product-main-grid]');
    let productMediaWrapper = gridParent.querySelector('[data-product-grid-main-image]');
    if (element.closest('.color-variants-wrapper').querySelector('.productOption.active')) {
        element.closest('.color-variants-wrapper').querySelector('.productOption.active').classList.remove('active');
    }
    element.classList.add('active');
    if (mediaParent.querySelector('script') && productMediaWrapper) {
        let colorMedia = new DOMParser().parseFromString(JSON.parse(mediaParent.querySelector('script').textContent), "text/html").querySelector('.media-content');
        productMediaWrapper.innerHTML = colorMedia.innerHTML;
    }
}

function localizationElements(section = document) {
    var controllerKey = 'UpvanityLocalizationDisclosure';
    var controller = window[controllerKey];

    if (!controller || controller.version !== 1 || typeof controller.refresh !== 'function') {
        if (controller && typeof controller.destroy === 'function') controller.destroy();

        controller = (function createLocalizationDisclosureController() {
            var dropdownSelector =
                '.localization-dropdown .detail-box, .footer-dropdown .detail-box';
            var activeDropdownSelector =
                '.localization-dropdown .detail-box.active, .footer-dropdown .detail-box.active';
            var activeDropdown = null;
            var active = true;
            var generatedId = 0;

            function connected(node) {
                return Boolean(node && (typeof node.isConnected !== 'boolean' || node.isConnected));
            }

            function eventElement(target) {
                if (!target) return null;
                if (target.nodeType === 1) return target;
                return target.parentElement || null;
            }

            function ownedDropdown(node) {
                return Boolean(
                    node &&
                    typeof node.matches === 'function' &&
                    node.matches(dropdownSelector)
                );
            }

            function parts(dropdown) {
                if (!ownedDropdown(dropdown)) return null;
                var trigger = dropdown.querySelector('.detail-summary');
                var panel = dropdown.querySelector('.detail-expand');
                if (!trigger || !panel) return null;
                return { trigger: trigger, panel: panel };
            }

            function setInert(panel, shouldBeInert) {
                try {
                    panel.inert = shouldBeInert;
                } catch (error) {
                    /* The hidden state remains the fail-safe for older engines. */
                }
                if (shouldBeInert) panel.setAttribute('inert', '');
                else panel.removeAttribute('inert');
            }

            function syncFooter(footer) {
                if (!footer || !connected(footer)) return;
                if (footer.querySelector('.footer-dropdown .detail-box.active')) {
                    footer.style.zIndex = 2;
                } else {
                    footer.style.removeProperty('z-index');
                }
            }

            function focusTrigger(trigger) {
                if (!connected(trigger) || typeof trigger.focus !== 'function') return;
                try {
                    trigger.focus({ preventScroll: true });
                } catch (error) {
                    trigger.focus();
                }
            }

            function setExpanded(dropdown, shouldExpand, returnFocus) {
                var disclosureParts = parts(dropdown);
                if (!disclosureParts) {
                    var fallbackTrigger = dropdown && dropdown.querySelector
                        ? dropdown.querySelector('.detail-summary')
                        : null;
                    var fallbackPanel = dropdown && dropdown.querySelector
                        ? dropdown.querySelector('.detail-expand')
                        : null;
                    var fallbackFooter = dropdown && dropdown.closest
                        ? dropdown.closest('footer')
                        : null;
                    if (fallbackTrigger) fallbackTrigger.setAttribute('aria-expanded', 'false');
                    if (fallbackPanel) {
                        fallbackPanel.setAttribute('aria-hidden', 'true');
                        setInert(fallbackPanel, true);
                        fallbackPanel.hidden = true;
                        fallbackPanel.style.removeProperty('display');
                    }
                    if (dropdown && dropdown.classList) dropdown.classList.remove('active');
                    if (activeDropdown === dropdown) activeDropdown = null;
                    syncFooter(fallbackFooter);
                    return false;
                }

                var trigger = disclosureParts.trigger;
                var panel = disclosureParts.panel;
                var footer = dropdown.closest('footer');
                var expand = Boolean(shouldExpand && connected(dropdown));

                if (expand) {
                    Array.from(document.querySelectorAll(activeDropdownSelector)).forEach(
                        function(otherDropdown) {
                            if (otherDropdown !== dropdown) setExpanded(otherDropdown, false, false);
                        }
                    );
                    setInert(panel, false);
                    panel.hidden = false;
                    panel.style.display = 'block';
                    panel.setAttribute('aria-hidden', 'false');
                    dropdown.classList.add('active');
                    trigger.setAttribute('aria-expanded', 'true');
                    activeDropdown = dropdown;
                } else {
                    trigger.setAttribute('aria-expanded', 'false');
                    if (returnFocus) focusTrigger(trigger);
                    panel.setAttribute('aria-hidden', 'true');
                    setInert(panel, true);
                    panel.hidden = true;
                    panel.style.removeProperty('display');
                    dropdown.classList.remove('active');
                    if (activeDropdown === dropdown) activeDropdown = null;
                }

                syncFooter(footer);
                return expand;
            }

            function ensureIds(dropdown, trigger, panel) {
                var form = dropdown.closest('form');
                var baseId = form && form.id ? form.id : '';
                if (!baseId) {
                    generatedId += 1;
                    baseId = 'upv-localization-' + generatedId;
                }
                if (!trigger.id) trigger.id = baseId + '-trigger';
                if (!panel.id) panel.id = baseId + '-panel';
                trigger.setAttribute('aria-controls', panel.id);
            }

            function enhance(dropdown) {
                var disclosureParts = parts(dropdown);
                if (!disclosureParts) {
                    setExpanded(dropdown, false, false);
                    return false;
                }

                var trigger = disclosureParts.trigger;
                var panel = disclosureParts.panel;
                var isNew = dropdown.dataset.upvLocalizationDisclosure !== 'true';

                dropdown.removeAttribute('tabindex');
                dropdown.removeAttribute('role');
                ensureIds(dropdown, trigger, panel);

                if (trigger.tagName === 'BUTTON') {
                    trigger.type = 'button';
                    trigger.removeAttribute('role');
                } else {
                    trigger.setAttribute('role', 'button');
                    trigger.setAttribute('tabindex', '0');
                }

                dropdown.dataset.upvLocalizationDisclosure = 'true';
                if (isNew) {
                    setExpanded(dropdown, false, false);
                } else {
                    setExpanded(
                        dropdown,
                        dropdown.classList.contains('active') &&
                            trigger.getAttribute('aria-expanded') === 'true' &&
                            panel.hidden === false,
                        false
                    );
                }
                return true;
            }

            function dropdownsWithin(root) {
                var dropdowns = [];
                if (!root) return dropdowns;
                if (ownedDropdown(root)) dropdowns.push(root);
                if (typeof root.querySelectorAll === 'function') {
                    Array.from(root.querySelectorAll(dropdownSelector)).forEach(function(dropdown) {
                        if (!dropdowns.includes(dropdown)) dropdowns.push(dropdown);
                    });
                }
                return dropdowns;
            }

            function refresh(root) {
                if (!active) return 0;
                if (activeDropdown && !connected(activeDropdown)) activeDropdown = null;
                var count = 0;
                dropdownsWithin(root || document).forEach(function(dropdown) {
                    if (enhance(dropdown)) count += 1;
                });
                return count;
            }

            function handleClick(event) {
                var target = eventElement(event.target);
                if (!target) return;
                var trigger = target.closest('.detail-summary');
                var dropdown = trigger ? trigger.closest('.detail-box') : null;

                if (trigger && ownedDropdown(dropdown)) {
                    if (trigger.disabled) return;
                    setExpanded(dropdown, !dropdown.classList.contains('active'), false);
                    return;
                }

                if (activeDropdown && !activeDropdown.contains(target)) {
                    setExpanded(activeDropdown, false, false);
                }
            }

            function handleKeydown(event) {
                var target = eventElement(event.target);
                if (!target) return;
                var dropdown = target.closest('.detail-box');

                if (
                    event.key === 'Escape' &&
                    ownedDropdown(dropdown) &&
                    dropdown.classList.contains('active')
                ) {
                    event.preventDefault();
                    event.stopPropagation();
                    setExpanded(dropdown, false, true);
                    return;
                }

                var trigger = target.closest('.detail-summary[role="button"]');
                if (
                    trigger &&
                    trigger.tagName !== 'BUTTON' &&
                    ownedDropdown(trigger.closest('.detail-box')) &&
                    (event.key === 'Enter' || event.key === ' ')
                ) {
                    event.preventDefault();
                    trigger.click();
                }
            }

            function handleFocusOut(event) {
                var target = eventElement(event.target);
                var dropdown = target ? target.closest('.detail-box.active') : null;
                if (!ownedDropdown(dropdown)) return;

                window.setTimeout(function() {
                    if (
                        active &&
                        connected(dropdown) &&
                        dropdown.classList.contains('active') &&
                        !dropdown.contains(document.activeElement)
                    ) {
                        setExpanded(dropdown, false, false);
                    }
                }, 0);
            }

            function handlePageShow() {
                refresh(document);
            }

            function handleSectionUnload(event) {
                if (
                    activeDropdown &&
                    event.target &&
                    typeof event.target.contains === 'function' &&
                    event.target.contains(activeDropdown)
                ) {
                    setExpanded(activeDropdown, false, false);
                    activeDropdown = null;
                }
            }

            function destroy() {
                if (!active) return;
                active = false;
                document.removeEventListener('click', handleClick);
                document.removeEventListener('focusout', handleFocusOut);
                window.removeEventListener('keydown', handleKeydown, true);
                window.removeEventListener('pageshow', handlePageShow);
                document.removeEventListener('shopify:section:unload', handleSectionUnload);
                Array.from(document.querySelectorAll(dropdownSelector)).forEach(function(dropdown) {
                    setExpanded(dropdown, false, false);
                });
                activeDropdown = null;
                if (window[controllerKey] === api) window[controllerKey] = null;
            }

            var api = {
                version: 1,
                destroy: destroy,
                refresh: refresh,
                getDebugState: function() {
                    return {
                        active: active,
                        hasActiveDropdown: Boolean(activeDropdown && connected(activeDropdown)),
                        enhancedCount: document.querySelectorAll(
                            '[data-upv-localization-disclosure="true"]'
                        ).length
                    };
                }
            };

            document.addEventListener('click', handleClick);
            document.addEventListener('focusout', handleFocusOut);
            window.addEventListener('keydown', handleKeydown, true);
            window.addEventListener('pageshow', handlePageShow);
            document.addEventListener('shopify:section:unload', handleSectionUnload);
            return api;
        })();

        window[controllerKey] = controller;
    }

    return controller.refresh(section);
}

function footerMenuAccordionElements(section = document) {
    var controllerKey = 'UpvanityFooterAccordionController';
    var controller = window[controllerKey];

    if (!controller || controller.version !== 1 || typeof controller.refresh !== 'function') {
        if (controller && typeof controller.destroy === 'function') controller.destroy();

        controller = (function createFooterAccordionController() {
            var headSelector = '[data-upv-footer-accordion-head]';
            var triggerSelector = '[data-upv-footer-accordion-trigger]';
            var panelSelector = '[data-upv-footer-accordion-panel]';
            var mobileQuery = '(max-width: 767px)';
            var mediaQuery = typeof window.matchMedia === 'function'
                ? window.matchMedia(mobileQuery)
                : null;
            var currentMobile = null;
            var activeItem = null;
            var generatedId = 0;
            var active = true;

            function connected(node) {
                return Boolean(node && (typeof node.isConnected !== 'boolean' || node.isConnected));
            }

            function eventElement(target) {
                if (!target) return null;
                if (target.nodeType === 1) return target;
                return target.parentElement || null;
            }

            function ownedHead(node) {
                return Boolean(
                    node &&
                    typeof node.matches === 'function' &&
                    node.matches(headSelector)
                );
            }

            function isMobileMode() {
                if (mediaQuery) return mediaQuery.matches;
                return window.innerWidth <= 767;
            }

            function setInert(panel, shouldBeInert) {
                try {
                    panel.inert = shouldBeInert;
                } catch (error) {
                    /* The hidden state remains the fail-safe for older engines. */
                }
                if (shouldBeInert) panel.setAttribute('inert', '');
                else panel.removeAttribute('inert');
            }

            function focusTrigger(trigger) {
                if (!connected(trigger) || typeof trigger.focus !== 'function') return;
                try {
                    trigger.focus({ preventScroll: true });
                } catch (error) {
                    trigger.focus();
                }
            }

            function parts(head) {
                if (!ownedHead(head)) return null;
                var item = head.closest('.footer-menu-accordion');
                var trigger = head.querySelector(triggerSelector);
                var panel = item ? item.querySelector(panelSelector) : null;
                if (!item || !trigger || !panel) return null;
                return { head: head, item: item, trigger: trigger, panel: panel };
            }

            function ensureIds(accordionParts) {
                var trigger = accordionParts.trigger;
                var panel = accordionParts.panel;
                var storedPanelId = trigger.getAttribute('data-upv-footer-accordion-controls');

                if (!panel.id) {
                    generatedId += 1;
                    panel.id = storedPanelId || 'upv-footer-accordion-panel-' + generatedId;
                }
                if (!trigger.id) trigger.id = panel.id + '-trigger';
                trigger.setAttribute('data-upv-footer-accordion-controls', panel.id);
                trigger.setAttribute('aria-controls', panel.id);
            }

            function failClosed(head) {
                if (!head) return false;
                var item = typeof head.closest === 'function'
                    ? head.closest('.footer-menu-accordion')
                    : null;
                var trigger = typeof head.querySelector === 'function'
                    ? head.querySelector(triggerSelector)
                    : null;
                var panel = item && typeof item.querySelector === 'function'
                    ? item.querySelector(panelSelector)
                    : null;

                if (trigger) {
                    trigger.removeAttribute('role');
                    trigger.removeAttribute('tabindex');
                    trigger.removeAttribute('aria-controls');
                    trigger.setAttribute('aria-expanded', 'false');
                }
                if (panel) {
                    panel.setAttribute('aria-hidden', 'true');
                    setInert(panel, true);
                    panel.hidden = true;
                    panel.style.removeProperty('display');
                }
                if (item && item.classList) item.classList.remove('active');
                head.removeAttribute('data-upv-footer-accordion-enhanced');
                if (activeItem === item) activeItem = null;
                return false;
            }

            function setExpanded(item, shouldExpand, returnFocus) {
                var head = item && typeof item.querySelector === 'function'
                    ? item.querySelector(headSelector)
                    : null;
                var accordionParts = parts(head);
                if (!accordionParts) return failClosed(head);

                var expand = Boolean(shouldExpand && currentMobile && connected(item));
                var trigger = accordionParts.trigger;
                var panel = accordionParts.panel;

                if (expand) {
                    Array.from(document.querySelectorAll('.footer-menu-accordion.active')).forEach(
                        function(otherItem) {
                            if (otherItem !== item && otherItem.querySelector(headSelector)) {
                                setExpanded(otherItem, false, false);
                            }
                        }
                    );
                    setInert(panel, false);
                    panel.hidden = false;
                    panel.style.display = 'block';
                    panel.setAttribute('aria-hidden', 'false');
                    item.classList.add('active');
                    trigger.setAttribute('aria-expanded', 'true');
                    activeItem = item;
                } else {
                    trigger.setAttribute('aria-expanded', 'false');
                    if (returnFocus) focusTrigger(trigger);
                    panel.setAttribute('aria-hidden', 'true');
                    setInert(panel, true);
                    panel.hidden = true;
                    panel.style.removeProperty('display');
                    item.classList.remove('active');
                    if (activeItem === item) activeItem = null;
                }
                return expand;
            }

            function enhanceMobile(head, forceClosed) {
                var accordionParts = parts(head);
                if (!accordionParts) return failClosed(head);

                var trigger = accordionParts.trigger;
                var panel = accordionParts.panel;
                var isNew = head.getAttribute('data-upv-footer-accordion-enhanced') !== 'true';

                ensureIds(accordionParts);
                trigger.setAttribute('role', 'button');
                trigger.setAttribute('tabindex', '0');
                head.setAttribute('data-upv-footer-accordion-enhanced', 'true');

                if (forceClosed || isNew) {
                    setExpanded(
                        accordionParts.item,
                        false,
                        Boolean(
                            forceClosed &&
                            document.activeElement &&
                            panel.contains(document.activeElement)
                        )
                    );
                } else {
                    setExpanded(
                        accordionParts.item,
                        accordionParts.item.classList.contains('active') &&
                            trigger.getAttribute('aria-expanded') === 'true' &&
                            panel.hidden === false,
                        false
                    );
                }
                return true;
            }

            function cleanDesktop(head) {
                if (!head) return false;
                var item = typeof head.closest === 'function'
                    ? head.closest('.footer-menu-accordion')
                    : null;
                var trigger = typeof head.querySelector === 'function'
                    ? head.querySelector(triggerSelector)
                    : null;
                var panel = item && typeof item.querySelector === 'function'
                    ? item.querySelector(panelSelector)
                    : null;

                if (trigger) {
                    trigger.removeAttribute('role');
                    trigger.removeAttribute('tabindex');
                    trigger.removeAttribute('aria-controls');
                    trigger.removeAttribute('aria-expanded');
                }
                if (panel) {
                    panel.removeAttribute('aria-hidden');
                    setInert(panel, false);
                    panel.hidden = false;
                    panel.style.removeProperty('display');
                }
                if (item && item.classList) item.classList.remove('active');
                head.removeAttribute('data-upv-footer-accordion-enhanced');
                if (activeItem === item) activeItem = null;
                return Boolean(item && trigger && panel);
            }

            function headsWithin(root) {
                var heads = [];
                if (!root) return heads;
                if (ownedHead(root)) heads.push(root);
                if (typeof root.querySelectorAll === 'function') {
                    Array.from(root.querySelectorAll(headSelector)).forEach(function(head) {
                        if (!heads.includes(head)) heads.push(head);
                    });
                }
                return heads;
            }

            function refresh(root) {
                if (!active) return 0;
                if (activeItem && !connected(activeItem)) activeItem = null;

                var mobile = isMobileMode();
                var modeChanged = currentMobile !== mobile;
                currentMobile = mobile;
                var refreshRoot = modeChanged ? document : (root || document);
                var count = 0;

                headsWithin(refreshRoot).forEach(function(head) {
                    if (mobile) {
                        if (enhanceMobile(head, modeChanged)) count += 1;
                    } else if (cleanDesktop(head)) {
                        count += 1;
                    }
                });
                return count;
            }

            function handleClick(event) {
                if (!currentMobile) return;
                var target = eventElement(event.target);
                var head = target && typeof target.closest === 'function'
                    ? target.closest(headSelector)
                    : null;
                if (!ownedHead(head)) return;

                var accordionParts = parts(head);
                if (!accordionParts) {
                    failClosed(head);
                    return;
                }
                if (head.getAttribute('data-upv-footer-accordion-enhanced') !== 'true') {
                    enhanceMobile(head, true);
                }
                event.preventDefault();
                setExpanded(
                    accordionParts.item,
                    !accordionParts.item.classList.contains('active'),
                    false
                );
            }

            function handleKeydown(event) {
                if (!currentMobile) return;
                var target = eventElement(event.target);
                if (!target) return;
                var item = typeof target.closest === 'function'
                    ? target.closest('.footer-menu-accordion')
                    : null;
                var head = item && typeof item.querySelector === 'function'
                    ? item.querySelector(headSelector)
                    : null;
                if (!ownedHead(head)) return;

                if (event.key === 'Escape' && item.classList.contains('active')) {
                    event.preventDefault();
                    event.stopPropagation();
                    setExpanded(item, false, true);
                    return;
                }

                var trigger = typeof target.closest === 'function'
                    ? target.closest(triggerSelector)
                    : null;
                if (
                    trigger &&
                    head.contains(trigger) &&
                    (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar')
                ) {
                    event.preventDefault();
                    if (event.repeat) return;
                    setExpanded(item, !item.classList.contains('active'), false);
                }
            }

            function handlePageShow() {
                refresh(document);
            }

            function handleSectionLoad(event) {
                refresh(event.target || document);
            }

            function handleSectionUnload(event) {
                if (
                    activeItem &&
                    event.target &&
                    typeof event.target.contains === 'function' &&
                    event.target.contains(activeItem)
                ) {
                    setExpanded(activeItem, false, false);
                    activeItem = null;
                }
            }

            function handleMediaChange() {
                refresh(document);
            }

            function destroy() {
                if (!active) return;
                active = false;
                document.removeEventListener('click', handleClick);
                document.removeEventListener('keydown', handleKeydown);
                window.removeEventListener('pageshow', handlePageShow);
                document.removeEventListener('shopify:section:load', handleSectionLoad);
                document.removeEventListener('shopify:section:unload', handleSectionUnload);
                if (mediaQuery && typeof mediaQuery.removeEventListener === 'function') {
                    mediaQuery.removeEventListener('change', handleMediaChange);
                } else if (mediaQuery && typeof mediaQuery.removeListener === 'function') {
                    mediaQuery.removeListener(handleMediaChange);
                } else {
                    window.removeEventListener('resize', handleMediaChange);
                }
                headsWithin(document).forEach(cleanDesktop);
                activeItem = null;
                currentMobile = null;
                if (window[controllerKey] === api) window[controllerKey] = null;
            }

            var api = {
                version: 1,
                destroy: destroy,
                refresh: refresh,
                getDebugState: function() {
                    return {
                        active: active,
                        isMobile: Boolean(currentMobile),
                        hasActiveItem: Boolean(activeItem && connected(activeItem)),
                        enhancedCount: document.querySelectorAll(
                            '[data-upv-footer-accordion-enhanced="true"]'
                        ).length
                    };
                }
            };

            document.addEventListener('click', handleClick);
            document.addEventListener('keydown', handleKeydown);
            window.addEventListener('pageshow', handlePageShow);
            document.addEventListener('shopify:section:load', handleSectionLoad);
            document.addEventListener('shopify:section:unload', handleSectionUnload);
            if (mediaQuery && typeof mediaQuery.addEventListener === 'function') {
                mediaQuery.addEventListener('change', handleMediaChange);
            } else if (mediaQuery && typeof mediaQuery.addListener === 'function') {
                mediaQuery.addListener(handleMediaChange);
            } else {
                window.addEventListener('resize', handleMediaChange);
            }
            return api;
        })();

        window[controllerKey] = controller;
    }

    return controller.refresh(section);
}

function sideDrawerContentStoryInit(section = document) {
    let contentDrawerHeads = section.querySelectorAll('[data-content-drawer-head]');
    Array.from(contentDrawerHeads).forEach(function(contentDrawerHead) {
        contentDrawerHead.addEventListener("click", function(event) {
            event.preventDefault();
            let mainParent = contentDrawerHead.closest("[data-content-drawer-main]");
            if (mainParent.classList.contains("show")) {
                document.querySelector("body").classList.remove("story-drawer-overlay");
                mainParent.classList.remove("show");
                setTimeout(function() {
                    document.querySelector("body").classList.remove("story-drawer-open");
                }, 700);
            } else {
                setTimeout(function() {
                    mainParent.classList.add("show");
                }, 200);
                document.querySelector("body").classList.add("story-drawer-open");
                setTimeout(function() {
                    document.querySelector("body").classList.add("story-drawer-overlay");
                }, 400);
            }
        })
    })
    let contentDrawerCloseBtn = section.querySelectorAll('[side-drawer-story-close]');
    Array.from(contentDrawerCloseBtn).forEach(function(closeBtn) {
        closeBtn.addEventListener("click", function(event) {
            event.preventDefault();
            let mainParent = closeBtn.closest("[data-content-drawer-main]");
            mainParent.classList.remove("show");
            document.querySelector("body").classList.remove("story-drawer-overlay");
            setTimeout(function() {
                document.querySelector("body").classList.remove("story-drawer-open")
            }, 700);
        })
    })


}
document.addEventListener("DOMContentLoaded", function() {
    initYouTubeIframe();
    cookiesBanner();
    viewcategoryInit();
    initBeforeAfter();
    productHoverSlider();
    deferredProductHoverImages();
    updateInventroyStatusBar();
    productRecommendations();
    hamburgerInit();
    navigationMenu();
    sliderFilter();
    closeDrawers();
    recentlyViewedProducts();
    productGiftOptions();
    lookbookScrollContent();
    if (gridPickupAvailabilityStatus) {
        gridPickUpAvailability()
    }
    initStoreLocator();
    productQueryForm();
    timelineNavInit();
    collectionHoverNavInit();
    newsletterSidebar();
    pdpCountdown();
    initSearchPrompts();
    localizationElements();
    footerMenuAccordionElements();
    coloredCollection();
    let stickersOverlay = document.querySelector('[data-upv-stickers-overlay]');
    if (stickersOverlay) startTimer(stickersOverlay);

    sideDrawerContentStoryInit();

});
// document.addEventListener('click', resetTimer);

// document.addEventListener('mouseover', resetTimer);

function sideBarVisibility(contentDrawer = document.querySelector('[data-content-drawer-main]')) {
    let windowCenter = window.innerHeight;
    if (contentDrawer) {
        if (window.scrollY > windowCenter) {
            if (!contentDrawer.classList.contains('expand')) contentDrawer.classList.add('expand')
        }
        else{
            if (contentDrawer.classList.contains('expand')) contentDrawer.classList.remove('expand')
        }
    }
}
function footerDropdownCheck(footerDropdown = document.querySelector('.footer-dropdown')) {
    if (
        !footerDropdown ||
        footerDropdown.length === 0 ||
        footerDropdown.isConnected === false ||
        typeof footerDropdown.getBoundingClientRect !== 'function' ||
        !footerDropdown.classList
    ) return;

    let footerRect = footerDropdown.getBoundingClientRect();
    if (footerRect.width === 0 && footerRect.height === 0) return;

    let viewportRoot = document.documentElement;
    let viewportHeight = viewportRoot && typeof viewportRoot.clientHeight === 'number'
        ? viewportRoot.clientHeight
        : window.innerHeight;
    let viewportWidth = viewportRoot && typeof viewportRoot.clientWidth === 'number'
        ? viewportRoot.clientWidth
        : window.innerWidth;
    let adjustedTop = footerRect.top + (viewportWidth > 768 ? 400 : 0);
    let footerHeight = typeof footerRect.height === 'number'
        ? footerRect.height
        : Math.max(0, footerRect.bottom - footerRect.top);
    let adjustedBottom = adjustedTop + footerHeight;
    let footerIsVisible =
        (adjustedTop >= 0 && adjustedTop < viewportHeight) ||
        (adjustedBottom > 0 && adjustedBottom <= viewportHeight) ||
        (footerHeight > viewportHeight &&
            adjustedTop <= 0 &&
            adjustedBottom >= viewportHeight);

    if (!footerIsVisible) return;

    let shouldOpenDownward = footerRect.top < window.innerHeight / 2;
    if (shouldOpenDownward) {
        if (!footerDropdown.classList.contains('bottom')) footerDropdown.classList.add('bottom')
    } else {
        if (footerDropdown.classList.contains('bottom')) footerDropdown.classList.remove('bottom')
    }
}

/* UPVANITY_GLOBAL_SCROLL_CONTROLLER_START */
(function () {
    var controllerKey = 'UpvanityGlobalScrollController';
    var previousController = window[controllerKey];
    if (previousController && typeof previousController.destroy === 'function') {
        previousController.destroy();
    }

    var mediaSelector = '.yv-youtube-video, .yv-vimeo-video, video:not(.videoBackgroundFile)';
    var controller = null;
    var state = {
        active: false,
        drawer: null,
        footer: null,
        frameId: null,
        frameUsesTimeout: false,
        flushCount: 0,
        mediaCloseCount: 0,
        mediaScanCount: 0,
        needsLayoutWork: false,
        needsScrollWork: false,
        overlay: null
    };

    function nodeIsConnected(node) {
        return Boolean(node && (typeof node.isConnected !== 'boolean' || node.isConnected));
    }

    function targetOwnsNode(target, node) {
        return Boolean(
            target &&
            node &&
            (target === node || (typeof target.contains === 'function' && target.contains(node)))
        );
    }

    function handleOverlayActivity() {
        if (state.overlay) resetTimer(state.overlay);
    }

    function bindOverlay(nextOverlay) {
        if (state.overlay === nextOverlay) return;
        if (state.overlay) {
            state.overlay.removeEventListener('click', handleOverlayActivity);
            state.overlay.removeEventListener('keydown', handleOverlayActivity);
        }
        state.overlay = nextOverlay;
        if (state.overlay) {
            state.overlay.addEventListener('click', handleOverlayActivity);
            state.overlay.addEventListener('keydown', handleOverlayActivity);
        }
    }

    function refreshTargets() {
        state.footer = document.querySelector('.footer-dropdown');
        state.drawer = document.querySelector('[data-content-drawer-main]');
        bindOverlay(document.querySelector('[data-upv-stickers-overlay]'));
    }

    function cancelFrame() {
        if (state.frameId === null) return;
        if (state.frameUsesTimeout) {
            window.clearTimeout(state.frameId);
        } else if (typeof window.cancelAnimationFrame === 'function') {
            window.cancelAnimationFrame(state.frameId);
        }
        state.frameId = null;
        state.frameUsesTimeout = false;
    }

    function runFrame() {
        state.frameId = null;
        state.frameUsesTimeout = false;
        if (!state.active) return;

        var runScrollWork = state.needsScrollWork;
        var runLayoutWork = state.needsLayoutWork || runScrollWork;
        state.needsScrollWork = false;
        state.needsLayoutWork = false;
        if (!runScrollWork && !runLayoutWork) return;

        if (
            (state.footer && !nodeIsConnected(state.footer)) ||
            (state.drawer && !nodeIsConnected(state.drawer)) ||
            (state.overlay && !nodeIsConnected(state.overlay))
        ) {
            refreshTargets();
        }

        state.flushCount += 1;
        if (runScrollWork) {
            if (state.overlay) resetTimer(state.overlay);
            state.mediaScanCount += 1;
            if (document.querySelector(mediaSelector)) {
                state.mediaCloseCount += 1;
                closeVideoMedia();
            }
        }
        if (runLayoutWork) {
            footerDropdownCheck(state.footer);
            sideBarVisibility(state.drawer);
        }
    }

    function scheduleFrame(scrollWork, layoutWork) {
        if (!state.active) return;
        if (scrollWork) state.needsScrollWork = true;
        if (layoutWork) state.needsLayoutWork = true;
        if (state.frameId !== null) return;
        if (typeof window.requestAnimationFrame === 'function') {
            state.frameUsesTimeout = false;
            state.frameId = window.requestAnimationFrame(runFrame);
        } else {
            state.frameUsesTimeout = true;
            state.frameId = window.setTimeout(runFrame, 16);
        }
    }

    function handleScroll() {
        scheduleFrame(true, true);
    }

    function handleLayoutChange() {
        scheduleFrame(false, true);
    }

    function handlePageShow() {
        cancelFrame();
        refreshTargets();
        handleLayoutChange();
    }

    function handleSectionLoad() {
        refreshTargets();
        handleLayoutChange();
    }

    function handleSectionUnload(event) {
        var target = event.target;
        if (targetOwnsNode(target, state.footer)) state.footer = null;
        if (targetOwnsNode(target, state.drawer)) state.drawer = null;
        if (targetOwnsNode(target, state.overlay)) bindOverlay(null);
        handleLayoutChange();
    }

    function refresh() {
        if (!state.active) return;
        refreshTargets();
        handleLayoutChange();
    }

    function destroy() {
        if (!state.active) return;
        state.active = false;
        document.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleLayoutChange);
        window.removeEventListener('pageshow', handlePageShow);
        document.removeEventListener('shopify:section:load', handleSectionLoad);
        document.removeEventListener('shopify:section:unload', handleSectionUnload);
        document.removeEventListener('shopify:section:reorder', handleLayoutChange);
        cancelFrame();
        bindOverlay(null);
        state.footer = null;
        state.drawer = null;
        state.needsScrollWork = false;
        state.needsLayoutWork = false;
        if (window[controllerKey] === controller) window[controllerKey] = null;
    }

    controller = {
        destroy: destroy,
        refresh: refresh,
        getDebugState: function () {
            return {
                active: state.active,
                flushCount: state.flushCount,
                framePending: state.frameId !== null,
                hasDrawer: Boolean(state.drawer),
                hasFooter: Boolean(state.footer),
                hasOverlay: Boolean(state.overlay),
                mediaCloseCount: state.mediaCloseCount,
                mediaScanCount: state.mediaScanCount,
                needsLayoutWork: state.needsLayoutWork,
                needsScrollWork: state.needsScrollWork
            };
        }
    };
    window[controllerKey] = controller;

    state.active = true;
    refreshTargets();
    document.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleLayoutChange);
    window.addEventListener('pageshow', handlePageShow);
    document.addEventListener('shopify:section:load', handleSectionLoad);
    document.addEventListener('shopify:section:unload', handleSectionUnload);
    document.addEventListener('shopify:section:reorder', handleLayoutChange);
})();
/* UPVANITY_GLOBAL_SCROLL_CONTROLLER_END */

var timer = null;
var svgTimer = null;
var svgCount = 200;
var svgs = [];
var stickerOverlaySelector = '[data-upv-stickers-overlay]';

function isOwnedStickerOverlay(stickersOverlay) {
    return Boolean(
        stickersOverlay &&
        stickersOverlay.isConnected !== false &&
        typeof stickersOverlay.matches === 'function' &&
        stickersOverlay.matches(stickerOverlaySelector)
    );
}

function stickerSettingsAreAvailable() {
    return Boolean(
        typeof stickers !== 'undefined' &&
        Array.isArray(stickers) &&
        stickers.length > 0 &&
        typeof stickersTimer !== 'undefined' &&
        Number.isFinite(Number(stickersTimer)) &&
        typeof randomTextColors !== 'undefined' &&
        Array.isArray(randomTextColors) &&
        randomTextColors.length > 0 &&
        typeof randomBgColors !== 'undefined' &&
        Array.isArray(randomBgColors) &&
        randomBgColors.length > 0
    );
}

function generateRandomInteger(min, max) {
    return Math.floor(min + Math.random() * (max - min + 1));
}

function startTimer(stickersOverlay = document.querySelector(stickerOverlaySelector)) {
    clearTimeout(timer);
    timer = null;
    if (!isOwnedStickerOverlay(stickersOverlay) || !stickerSettingsAreAvailable()) return;

    timer = setTimeout(() => {
        timer = null;
        appendSVG();
    }, Number(stickersTimer));
}

function randomColorCode(numArr) {
    return numArr[(Math.floor(Math.random() * numArr.length))];
}

function randomScale() {
    let scaleArr = ['1.0', '1.1', '1.2', '1.3', '1.4'];
    return scaleArr[(Math.floor(Math.random() * scaleArr.length))];
}

function appendSVG(stickersOverlay = document.querySelector(stickerOverlaySelector)) {
    if (!isOwnedStickerOverlay(stickersOverlay) || !stickerSettingsAreAvailable()) return;

    if (svgs.length < svgCount) {
        let randomSticker = stickers[(Math.floor(Math.random() * stickers.length))];
        let parsedNode = new DOMParser().parseFromString(randomSticker, 'text/html');
        let parsedSticker = parsedNode.querySelector('svg');
        if (!parsedSticker) return;
        let stickerParent = document.createElement('div');
        let x = generateRandomInteger(0, 90);
        let y = generateRandomInteger(0, 90);
        let deg = generateRandomInteger(0, 360);
        let scale = randomScale();

        let randomColor;
        let randomBackground;
        do {
            randomColor = randomColorCode(randomTextColors);
            randomBackground = randomColorCode(randomBgColors);
        } while (randomColor === randomBackground);

        stickerParent.classList.add(`sticker`, `color-${randomColor}`, `background-${randomBackground}`);
        stickerParent.style.cssText = `top:${x}vh; left:${y}vw; rotate:${deg}deg; scale:${scale}`;
        stickerParent.appendChild(parsedSticker);

        stickersOverlay.appendChild(stickerParent);
        svgTimer = setTimeout(appendSVG, 1000); // 1 second delay
        svgs.push(stickerParent);
    }
}

function resetTimer(stickersOverlay = document.querySelector(stickerOverlaySelector)) {
    if (!isOwnedStickerOverlay(stickersOverlay)) return;

    stickersOverlay.innerHTML = '';
    clearTimeout(timer);
    clearTimeout(svgTimer);
    startTimer(stickersOverlay);
}

function reelPlay(event) {
    event.preventDefault();
    let _target = event.target;
    if (_target.closest('.product-video-link')) {
        _target = _target.closest('.product-video-link');
    }
    let videoUrl = _target.getAttribute('data-src');
    let reelAspectRatio = _target.dataset.aspectRatio;
    let video = document.createElement('video');
    video.src = videoUrl;
    video.autoplay = true;
    video.playsInline = true;
    video.controls = true;
    video.loop = true;
    if (_target.closest('[products-reels-list]').querySelector('.product-video-item.active')) {
        _target.closest('[products-reels-list]').querySelector('.product-video-item.active').classList.remove('active');
        _target.parentElement.classList.add('active');
    } else {
        _target.parentElement.classList.add('active');
    }
    let reelPopup = document.querySelector('[data-reels-popup]')
    if (reelPopup) {
        if (reelPopup.querySelector('.image-wrapper')) {
            reelPopup.querySelector('.image-wrapper').style.paddingBottom = reelAspectRatio + '%';
            reelPopup.querySelector('.image-wrapper').innerHTML = '';
            reelPopup.querySelector('.image-wrapper').appendChild(video);
        }
        reelPopup.classList.add('video-popup-open');
        reelPopup.style.display = 'flex';
    }
}

function reelClose(event) {
    event.preventDefault();
    let _target = event.target;
    let reelPopup = _target.closest('[data-reels-popup]')
    reelPopup.classList.remove('video-popup-open');
    reelPopup.style.display = 'none';
    if (reelPopup.querySelector('.image-wrapper')) {
        reelPopup.querySelector('.image-wrapper').innerHTML = '';
    }
    if (document.querySelector('.product-video-item.active')) {
        document.querySelector('.product-video-item.active').classList.remove('active');
    }
}

function coloredCollection(section = document) {
    let colorItems = section.querySelectorAll('.color-collections-color-item[data-list-item]');
    Array.from(colorItems).forEach(function(colorItem) {
        if (!colorItem.closest('[data-coll-wrapper]')) return;
        if (colorItem.dataset.upvColoredCollectionBound === 'true') return;
        colorItem.dataset.upvColoredCollectionBound = 'true';
        colorItem.addEventListener('click', function(e) {
            let targetIndex = colorItem.getAttribute('data-list-item');

            let closestWrapper = colorItem.closest('[data-coll-wrapper]');
            if (!closestWrapper) return false;

            let targetImage = closestWrapper.querySelector(`.img-item-${targetIndex}`);
            let targetProducts = closestWrapper.querySelector(`[data-grid-id="${targetIndex}"]`);
            if (!targetImage || !targetProducts) return false;

            e.preventDefault();
            if (colorItem.classList.contains('active')) return false;

            let currentColorItem = closestWrapper.querySelector(
                '.color-collections-color-item[data-list-item].active'
            );
            let currentImage = null;
            if (currentColorItem) {
                let currentIndex = currentColorItem.getAttribute('data-list-item');
                currentImage = closestWrapper.querySelector(`.img-item-${currentIndex}`);
            }

            let collectionImages = closestWrapper.querySelectorAll('.color-collections-img-item');
            Array.from(collectionImages).forEach(function(collectionImage) {
                if (collectionImage === targetImage) return;
                if (collectionImage._upvColorHideTimer) {
                    clearTimeout(collectionImage._upvColorHideTimer);
                    collectionImage._upvColorHideTimer = null;
                }
                if (collectionImage._upvColorResetTimer) {
                    clearTimeout(collectionImage._upvColorResetTimer);
                    collectionImage._upvColorResetTimer = null;
                }
                collectionImage.setAttribute('aria-hidden', 'true');
                collectionImage.setAttribute('inert', '');
                if (collectionImage === currentImage && collectionImage.classList.contains('active')) {
                    collectionImage.classList.add('previous');
                    collectionImage._upvColorHideTimer = setTimeout(() => {
                        collectionImage.hidden = true;
                        collectionImage.classList.remove('active');
                        collectionImage._upvColorResetTimer = setTimeout(() => {
                            collectionImage.classList.remove('previous');
                            collectionImage._upvColorResetTimer = null;
                        }, 500);
                        collectionImage._upvColorHideTimer = null;
                    }, 800);
                } else {
                    collectionImage.hidden = true;
                    collectionImage.classList.remove('active');
                    collectionImage.classList.remove('previous');
                }
            });

            let activeElements = closestWrapper.querySelectorAll(
                '.color-collections-color-item.active, .color-collections-products.active'
            );
            Array.from(activeElements).forEach(function(activeElement) {
                if (activeElement.classList.contains('color-collections-color-item')) {
                    let activeButton = activeElement.querySelector('button');
                    if (activeButton) activeButton.setAttribute('aria-pressed', 'false');
                } else {
                    activeElement.classList.add('hidden');
                    activeElement.setAttribute('aria-hidden', 'true');
                }
                activeElement.classList.remove('active');
            })

            colorItem.classList.add('active');
            let targetButton = colorItem.querySelector('button');
            if (targetButton) targetButton.setAttribute('aria-pressed', 'true');

            if (targetImage._upvColorHideTimer) {
                clearTimeout(targetImage._upvColorHideTimer);
                targetImage._upvColorHideTimer = null;
            }
            if (targetImage._upvColorResetTimer) {
                clearTimeout(targetImage._upvColorResetTimer);
                targetImage._upvColorResetTimer = null;
            }
            targetImage.classList.remove('previous');
            targetImage.hidden = false;
            targetImage.setAttribute('aria-hidden', 'false');
            targetImage.removeAttribute('inert');

            closestWrapper._upvColorActivationId =
                (closestWrapper._upvColorActivationId || 0) + 1;
            let activationId = closestWrapper._upvColorActivationId;
            let activateTargetImage = function() {
                if (closestWrapper._upvColorActivationId !== activationId) return;
                targetImage.classList.add('active');
            };
            if (typeof requestAnimationFrame === 'function') {
                requestAnimationFrame(activateTargetImage);
            } else {
                activateTargetImage();
            }

            targetProducts.classList.add('active');
            targetProducts.classList.remove('hidden');
            targetProducts.setAttribute('aria-hidden', 'false');

        });
    });


}

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        if (this.classList.contains("autoplay-status-false")) {
            const loadBtn = this.closest(".shopify-section").querySelector('.video-play-btn');
            loadBtn.addEventListener('click', this.loadContent.bind(this));
        } else {
        this.addObserver();
        }
    }

    addObserver() {
        if ('IntersectionObserver' in window === false) return;
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.loadContent();
                    observer.unobserve(this);
                }
            });
        }, { rootMargin: '0px 0px 1000px 0px' });

        observer.observe(this);
    }

    loadContent() {
        if (this.parentElement.classList.contains('yv-parallax')) {
            this.style.position = 'absolute';
            this.parentElement.style.position = 'fixed';
        }
        if (this.parentElement.classList.contains('yv-feature-videobox')) {
            this.parentElement.style.position = 'absolute';
        }
        const content = this.querySelector('template').content.cloneNode(true);
        this.appendChild(content);
    
        if (this.dataset.type == 'youtube') {
            initYouTubeIframe(this.closest('.shopify-section'))
        }
        if (this.querySelector('video') && this.querySelector('video').hasAttribute("autoplay")) {
            this.querySelector('video').play();
        }
        if (this.closest('.shopify-section').querySelector('[data-flickity-slider]')) {
            Array.from(this.closest('.shopify-section').querySelectorAll('[data-flickity-slider]')).forEach(function(sliderSelector) {
                let slider = Flickity.data(sliderSelector);
                if (slider) slider.resize();
            })
        }
    }
}

customElements.define('deferred-media', DeferredMedia);



class QuickAddClose extends HTMLElement {
    constructor() {
        super();
        this.parent = this.closest('.quick-add-popup');
        this.body = this.parent.querySelector('[quick-add-body]');
        this.addEventListener('click', this.hideContent.bind(this))
    }

    hideContent() {
        if (this.body) {
            const returnTrigger = this.parent.upvQuickAddTrigger;
            const shouldRestoreFocus = Boolean(
                returnTrigger &&
                returnTrigger.isConnected &&
                this.parent.contains(document.activeElement)
            );
            document.body.classList.remove('quick-add-popup-open');
            this.parent.classList.remove('show');
            disposeProductVariantLifecycle(this.body);
            this.body.innerHTML = '';
            if (shouldRestoreFocus) {
                try {
                    returnTrigger.focus({ preventScroll: true });
                } catch (error) {
                    returnTrigger.focus();
                }
            }
        }
    }
}

customElements.define('quick-add-close', QuickAddClose);

class QuickAddToggle extends HTMLElement {
    constructor() {
        super();
        this.popup = document.querySelector('.quick-add-popup');
        this.popBody = document.querySelector('[quick-add-body]');
        this.addEventListener('click', this.showContent.bind(this))
    }

    showContent() {
        if (this.popup && this.popBody) {
            this.popup.upvQuickAddTrigger = this;
            disposeProductVariantLifecycle(this.popBody);
            this.popBody.innerHTML = '';
            const content = this.querySelector('template').content.cloneNode(true);
            const preGuardCapture =
                beginProductVariantPreGuardCapture(this.popBody);
            try {
                this.popBody.appendChild(content);
                document.body.classList.add('quick-add-popup-open');
                this.popup.classList.add('show');
                if (Shopify.PaymentButton) {
                    Shopify.PaymentButton.init();
                }
                productVariants(this.popup);
            } finally {
                finishProductVariantPreGuardCapture(preGuardCapture);
            }
            quantityChange();
        }
    }
}

customElements.define('quick-add-toggle', QuickAddToggle);

class TestimonialVideoTrigger extends HTMLElement {
    constructor() {
        super();
        this.parent = this.closest('[data-testimonial-wrapper]');
        this.popVideoWrapper;
        this.video;
        console.log('Fancybox')
        console.log(Fancybox)
        this.addEventListener('click', this.showContent.bind(this))
    }

    showContent() {
        this.url = this.dataset.url;
        new Fancybox(
            // Array containing gallery items
            [
                // Gallery item
                {
                    src: this.url
                },
            ],
            // Gallery options
            {
                hideScrollbar: true,
                mainClass: 'testimonial-video-popup-box',
                closebutton: false,
                Toolbar: {
                    display: {
                        right: ["close"]
                    },
                }
            }
        );
    }
}

customElements.define('testimonial-video-trigger', TestimonialVideoTrigger);


class CounterText extends HTMLElement {
    constructor() {
        super();
        this.addObserver();
    }

    addObserver() {
        if ('IntersectionObserver' in window === false) return;
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.loadContent();
                    observer.unobserve(this);
                }
            });
        }, { rootMargin: '0px 0px -300px 0px' });

        observer.observe(this);
    }

    loadContent() {
        let $el = $(this);
        $({ Counter: 0 }).animate({ Counter: $el.data('counter') }, {
            duration: 2000,
            easing: 'swing',
            step: function() {
                $el.text(Math.ceil(this.Counter));
            },
            complete: function() {
                $el.text($el.data('counter'));
            }

        });
    }
}

customElements.define('counter-text', CounterText);

function createUpvanitySpotlightController(root = document) {
    const targetSelector = '.spotlight-section .yv-spotlight-main';
    const activeAttribute = 'data-upv-spotlight-active';
    const targets = new Set();
    const intersectionStates = new WeakMap();
    const pruneTimers = new Set();
    const supportsIntersectionObserver = typeof window.IntersectionObserver === 'function';
    let observer = null;
    let destroyed = false;

    function getTargets(scope) {
        let matches = [];
        if (!scope) return matches;
        if (scope.matches && scope.matches(targetSelector)) matches.push(scope);
        if (scope.querySelectorAll) {
            Array.from(scope.querySelectorAll(targetSelector)).forEach((target) => {
                if (matches.indexOf(target) === -1) matches.push(target);
            });
        }
        return matches;
    }

    function setActive(target, active) {
        if (!target || !target.setAttribute || !target.removeAttribute) return;
        let shouldBeActive = active && target.isConnected !== false;
        let isActive = target.getAttribute && target.getAttribute(activeAttribute) === 'true';
        if (shouldBeActive === isActive) return;
        if (shouldBeActive) {
            target.setAttribute(activeAttribute, 'true');
        } else {
            target.removeAttribute(activeAttribute);
        }
    }

    function releaseTarget(target) {
        if (!targets.has(target)) return;
        setActive(target, false);
        intersectionStates.delete(target);
        if (observer) observer.unobserve(target);
        targets.delete(target);
    }

    function pruneDisconnectedTargets() {
        targets.forEach((target) => {
            if (target.isConnected === false) releaseTarget(target);
        });
    }

    function scheduleDisconnectedPrunes() {
        pruneTimers.forEach((timer) => clearTimeout(timer));
        pruneTimers.clear();
        [3000, 12000].forEach((delay) => {
            let timer = setTimeout(() => {
                pruneTimers.delete(timer);
                pruneDisconnectedTargets();
            }, delay);
            pruneTimers.add(timer);
        });
    }

    function handleIntersections(entries) {
        if (destroyed) return;
        pruneDisconnectedTargets();
        entries.forEach((entry) => {
            let target = entry.target;
            if (!targets.has(target) || target.isConnected === false) return;
            let isIntersecting = Boolean(entry.isIntersecting);
            if (intersectionStates.get(target) === isIntersecting) return;
            intersectionStates.set(target, isIntersecting);
            setActive(target, isIntersecting);
        });
    }

    if (supportsIntersectionObserver) {
        observer = new window.IntersectionObserver(handleIntersections, {
            root: null,
            rootMargin: '200px 0px 200px 0px',
            threshold: 0
        });
    }

    function refresh(scope = document) {
        if (destroyed) return;
        pruneDisconnectedTargets();
        let addedTarget = false;
        getTargets(scope).forEach((target) => {
            if (targets.has(target)) return;
            targets.add(target);
            intersectionStates.set(target, false);
            setActive(target, false);
            if (observer) {
                observer.observe(target);
            } else {
                intersectionStates.set(target, true);
                setActive(target, true);
            }
            addedTarget = true;
        });
        if (addedTarget) scheduleDisconnectedPrunes();
    }

    function unload(scope) {
        if (!scope) return;
        let scopedTargets = new Set(getTargets(scope));
        targets.forEach((target) => {
            let belongsToScope = scopedTargets.has(target) || target === scope;
            if (!belongsToScope && scope.contains) belongsToScope = scope.contains(target);
            if (belongsToScope) releaseTarget(target);
        });
    }

    function handleSectionLoad(event) {
        refresh(event.target);
    }

    function handleSectionUnload(event) {
        unload(event.target);
    }

    function destroy() {
        if (destroyed) return;
        destroyed = true;
        document.removeEventListener('shopify:section:load', handleSectionLoad);
        document.removeEventListener('shopify:section:unload', handleSectionUnload);
        pruneTimers.forEach((timer) => clearTimeout(timer));
        pruneTimers.clear();
        targets.forEach((target) => setActive(target, false));
        targets.clear();
        if (observer) {
            observer.disconnect();
            observer = null;
        }
    }

    document.addEventListener('shopify:section:load', handleSectionLoad);
    document.addEventListener('shopify:section:unload', handleSectionUnload);
    refresh(root);

    return {
        version: 1,
        refresh,
        unload,
        destroy,
        getDebugState: function() {
            let activeTargetCount = 0;
            targets.forEach((target) => {
                if (target.getAttribute && target.getAttribute(activeAttribute) === 'true') {
                    activeTargetCount += 1;
                }
            });
            return {
                version: 1,
                targetCount: targets.size,
                activeTargetCount,
                hasObserver: Boolean(observer),
                rootMargin: observer ? '200px 0px 200px 0px' : null
            };
        },
        getTargetCount: function() {
            return targets.size;
        }
    };
}

if (
    window.UpvanitySpotlightController &&
    typeof window.UpvanitySpotlightController.destroy === 'function'
) {
    window.UpvanitySpotlightController.destroy();
}
window.UpvanitySpotlightController = createUpvanitySpotlightController();

const upvIconAnimationTimers = new WeakMap();

function createUpvanitySpotlightInteractionController(root = document) {
    const itemSelector = '.spotlight-section .spotlight-media-item[data-upv-spotlight-item]';
    const mainSelector = '.yv-spotlight-main';
    const triggerSelector = '[data-upv-spotlight-disclosure]';
    const panelSelector = '[data-upv-spotlight-panel]';
    const readyAttribute = 'data-upv-spotlight-interaction-ready';
    const openAttribute = 'data-upv-spotlight-open';
    const desktopQuery = typeof window.matchMedia === 'function'
        ? window.matchMedia('(min-width: 768px)')
        : null;
    const mobileQuery = typeof window.matchMedia === 'function'
        ? window.matchMedia('(max-width: 767px)')
        : null;
    const focusableSelector = [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]'
    ].join(',');
    const items = new Set();
    const states = new WeakMap();
    const readyMains = new Set();
    const pruneTimers = new Set();
    const viewportListenerModes = new Map();
    let destroyed = false;

    function getItems(scope) {
        let matches = [];
        if (!scope) return matches;
        if (scope.matches && scope.matches(itemSelector)) matches.push(scope);
        if (scope.querySelectorAll) {
            Array.from(scope.querySelectorAll(itemSelector)).forEach((item) => {
                if (matches.indexOf(item) === -1) matches.push(item);
            });
        }
        return matches;
    }

    function setAttributeValue(element, name, value) {
        if (!element || !element.getAttribute || !element.setAttribute) return;
        let nextValue = String(value);
        if (element.getAttribute(name) !== nextValue) element.setAttribute(name, nextValue);
    }

    function restoreFallbackTabStops(state) {
        state.tabStops.forEach((original, element) => {
            if (!element || !element.setAttribute || !element.removeAttribute) return;
            if (original.hadAttribute) {
                element.setAttribute('tabindex', original.value);
            } else {
                element.removeAttribute('tabindex');
            }
        });
        state.tabStops.clear();
    }

    function setPanelFocusable(state, focusable) {
        let panel = state.panel;
        if (state.supportsInert) {
            panel.inert = !focusable;
            if (focusable && panel.removeAttribute) panel.removeAttribute('inert');
            return;
        }
        if (focusable) {
            restoreFallbackTabStops(state);
            return;
        }
        if (!panel.querySelectorAll) return;
        Array.from(panel.querySelectorAll(focusableSelector)).forEach((element) => {
            if (!state.tabStops.has(element)) {
                state.tabStops.set(element, {
                    hadAttribute: element.hasAttribute && element.hasAttribute('tabindex'),
                    value: element.getAttribute ? element.getAttribute('tabindex') : null
                });
            }
            if (element.setAttribute) element.setAttribute('tabindex', '-1');
        });
    }

    function getTriggers(state) {
        if (!state.item.querySelectorAll) return [];
        return Array.from(state.item.querySelectorAll(triggerSelector));
    }

    function setOpen(state, open, restoreFocus) {
        open = Boolean(open);
        if (state.open === open) return;
        state.open = open;

        if (open) {
            state.item.setAttribute(openAttribute, 'true');
            setAttributeValue(state.panel, 'aria-hidden', 'false');
            setPanelFocusable(state, true);
            getTriggers(state).forEach((trigger) => {
                setAttributeValue(trigger, 'aria-expanded', 'true');
            });
        } else {
            getTriggers(state).forEach((trigger) => {
                setAttributeValue(trigger, 'aria-expanded', 'false');
            });
            if (
                restoreFocus &&
                document.activeElement &&
                state.panel.contains &&
                state.panel.contains(document.activeElement)
            ) {
                let trigger = getTriggers(state)[0];
                if (trigger && typeof trigger.focus === 'function') {
                    try {
                        trigger.focus({ preventScroll: true });
                    } catch (_error) {
                        trigger.focus();
                    }
                }
            }
            state.item.removeAttribute(openAttribute);
            setAttributeValue(state.panel, 'aria-hidden', 'true');
            setPanelFocusable(state, false);
        }
    }

    function closeOtherItems(activeState) {
        items.forEach((item) => {
            let state = states.get(item);
            if (!state || state === activeState || !state.open) return;
            if (state.editorSelected && !activeState.editorSelected) return;
            state.pinned = false;
            state.dismissed = true;
            setOpen(state, false, true);
        });
    }

    function isVisibleAtCurrentBreakpoint(state) {
        if (!state) return true;
        let visibility = state.main && state.main.getAttribute
            ? state.main.getAttribute('data-upv-spotlight-visibility')
            : 'always';
        if (visibility === 'large') return !mobileQuery || !mobileQuery.matches;
        if (visibility === 'small') return !desktopQuery || !desktopQuery.matches;
        return true;
    }

    function deactivateHiddenState(state) {
        state.hovered = false;
        state.focusWithin = false;
        state.pinned = false;
        state.dismissed = true;
        setOpen(state, false, false);
    }

    function syncState(state) {
        if (!state || destroyed || state.item.isConnected === false) return;
        if (!isVisibleAtCurrentBreakpoint(state)) {
            deactivateHiddenState(state);
            return;
        }
        let shouldOpen = state.editorSelected || (!state.dismissed && Boolean(
            state.hovered || state.focusWithin || state.pinned
        ));
        let selectedElsewhere = false;
        if (shouldOpen && !state.editorSelected) {
            items.forEach((item) => {
                let otherState = states.get(item);
                if (
                    otherState &&
                    otherState !== state &&
                    otherState.editorSelected &&
                    isVisibleAtCurrentBreakpoint(otherState)
                ) {
                    selectedElsewhere = true;
                }
            });
        }
        if (selectedElsewhere) {
            setOpen(state, false, true);
            return;
        }
        if (shouldOpen) closeOtherItems(state);
        setOpen(state, shouldOpen, false);
    }

    function clearOtherEditorSelections(selectedState) {
        items.forEach((item) => {
            let state = states.get(item);
            if (!state || state === selectedState || !state.editorSelected) return;
            state.editorSelected = false;
            state.pinned = false;
            state.dismissed = true;
            setOpen(state, false, true);
        });
    }

    function mainHasRegisteredItems(main) {
        let found = false;
        items.forEach((item) => {
            let state = states.get(item);
            if (state && state.main === main) found = true;
        });
        return found;
    }

    function restoreItem(state) {
        setOpen(state, false, state.item.isConnected !== false);
        restoreFallbackTabStops(state);
        if (state.supportsInert) {
            state.panel.inert = false;
            if (state.panel.removeAttribute) state.panel.removeAttribute('inert');
        }
        state.item.removeAttribute(openAttribute);
        state.panel.removeAttribute('aria-hidden');
        getTriggers(state).forEach((trigger) => trigger.removeAttribute('aria-expanded'));
    }

    function releaseItem(item) {
        if (!items.has(item)) return;
        let state = states.get(item);
        if (!state) {
            items.delete(item);
            return;
        }
        restoreItem(state);
        items.delete(item);
        states.delete(item);
        if (!mainHasRegisteredItems(state.main)) {
            state.main.removeAttribute(readyAttribute);
            readyMains.delete(state.main);
        }
    }

    function registerItem(item) {
        if (!item || items.has(item)) return false;
        let main = item.closest ? item.closest(mainSelector) : null;
        let panel = item.querySelector ? item.querySelector(panelSelector) : null;
        let triggers = item.querySelectorAll ? item.querySelectorAll(triggerSelector) : [];
        if (!main || !panel || !triggers.length) return false;

        let state = {
            item,
            main,
            panel,
            open: null,
            hovered: false,
            focusWithin: false,
            pinned: false,
            dismissed: false,
            editorSelected: false,
            supportsInert: 'inert' in panel,
            tabStops: new Map()
        };
        items.add(item);
        states.set(item, state);
        setOpen(state, false, false);
        setAttributeValue(main, readyAttribute, 'true');
        readyMains.add(main);
        return true;
    }

    function pruneDisconnectedItems() {
        items.forEach((item) => {
            if (item.isConnected === false) releaseItem(item);
        });
    }

    function scheduleDisconnectedPrunes() {
        pruneTimers.forEach((timer) => clearTimeout(timer));
        pruneTimers.clear();
        [3000, 12000].forEach((delay) => {
            let timer = setTimeout(() => {
                pruneTimers.delete(timer);
                pruneDisconnectedItems();
            }, delay);
            pruneTimers.add(timer);
        });
    }

    function refresh(scope = document) {
        if (destroyed) return;
        pruneDisconnectedItems();
        let addedItem = false;
        getItems(scope).forEach((item) => {
            if (registerItem(item)) addedItem = true;
        });
        if (addedItem) scheduleDisconnectedPrunes();
    }

    function unload(scope) {
        if (!scope) return;
        let scopedItems = new Set(getItems(scope));
        items.forEach((item) => {
            let belongsToScope = scopedItems.has(item) || item === scope;
            if (!belongsToScope && scope.contains) belongsToScope = scope.contains(item);
            if (belongsToScope) releaseItem(item);
        });
    }

    function getStateFromTarget(target) {
        if (!target || !target.closest) return null;
        let item = target.closest(itemSelector);
        return item && items.has(item) ? states.get(item) : null;
    }

    function isHoverPointer(event) {
        return !event.pointerType || event.pointerType === 'mouse' || event.pointerType === 'pen';
    }

    function handlePointerOver(event) {
        if (!isHoverPointer(event)) return;
        let state = getStateFromTarget(event.target);
        if (!state || (event.relatedTarget && state.item.contains(event.relatedTarget))) return;
        state.hovered = true;
        state.dismissed = false;
        syncState(state);
    }

    function handlePointerOut(event) {
        if (!isHoverPointer(event)) return;
        let state = getStateFromTarget(event.target);
        if (!state || (event.relatedTarget && state.item.contains(event.relatedTarget))) return;
        state.hovered = false;
        syncState(state);
        if (!state.hovered && !state.focusWithin && !state.pinned && !state.editorSelected) {
            state.dismissed = false;
        }
    }

    function handleFocusIn(event) {
        let state = getStateFromTarget(event.target);
        if (!state) return;
        let enteredFromOutside = !event.relatedTarget || !state.item.contains(event.relatedTarget);
        state.focusWithin = true;
        if (enteredFromOutside) state.dismissed = false;
        syncState(state);
    }

    function handleFocusOut(event) {
        let state = getStateFromTarget(event.target);
        if (!state || (event.relatedTarget && state.item.contains(event.relatedTarget))) return;
        state.focusWithin = false;
        syncState(state);
        if (!state.hovered && !state.focusWithin && !state.pinned && !state.editorSelected) {
            state.dismissed = false;
        }
    }

    function handleClick(event) {
        let trigger = event.target && event.target.closest ? event.target.closest(triggerSelector) : null;
        let state = trigger ? getStateFromTarget(trigger) : null;
        if (state) {
            if (state.editorSelected) return;
            if (state.pinned) {
                state.pinned = false;
                state.dismissed = true;
            } else {
                state.pinned = true;
                state.dismissed = false;
            }
            syncState(state);
            return;
        }

        items.forEach((item) => {
            let itemState = states.get(item);
            if (
                !itemState ||
                !itemState.open ||
                itemState.editorSelected ||
                item.contains(event.target)
            ) return;
            itemState.pinned = false;
            itemState.dismissed = true;
            setOpen(itemState, false, true);
        });
    }

    function handleKeydown(event) {
        if (event.key !== 'Escape') return;
        let state = getStateFromTarget(event.target);
        if (!state || !state.open) {
            state = null;
            items.forEach((item) => {
                let candidate = states.get(item);
                if (!state && candidate && candidate.open && !candidate.editorSelected) {
                    state = candidate;
                }
            });
        }
        if (!state || !state.open || state.editorSelected) return;
        event.preventDefault();
        state.pinned = false;
        state.dismissed = true;
        let focusIsInside = Boolean(
            document.activeElement &&
            state.panel.contains &&
            state.panel.contains(document.activeElement)
        );
        setOpen(state, false, focusIsInside);
    }

    function getBlockEventState(event) {
        let state = getStateFromTarget(event.target);
        if (state) return state;
        let blockId = event.detail && event.detail.blockId;
        if (!blockId || !document.getElementById) return null;
        let item = document.getElementById('yv-spotlight-item-' + blockId);
        if (!item) return null;
        if (!items.has(item)) registerItem(item);
        return states.get(item) || null;
    }

    function handleBlockSelect(event) {
        let state = getBlockEventState(event);
        if (!state) return;
        clearOtherEditorSelections(state);
        state.editorSelected = true;
        state.dismissed = false;
        syncState(state);
    }

    function handleBlockDeselect(event) {
        let state = getBlockEventState(event);
        if (!state) return;
        state.editorSelected = false;
        syncState(state);
        if (!state.hovered && !state.focusWithin && !state.pinned) state.dismissed = false;
    }

    function handleSectionLoad(event) {
        refresh(event.target);
    }

    function handleSectionUnload(event) {
        unload(event.target);
    }

    function handleViewportChange() {
        if (destroyed) return;
        pruneDisconnectedItems();
        items.forEach((item) => {
            let state = states.get(item);
            if (!state) return;
            if (!isVisibleAtCurrentBreakpoint(state)) {
                deactivateHiddenState(state);
                return;
            }
            if (state.editorSelected) {
                state.dismissed = false;
                syncState(state);
            }
        });
    }

    function addViewportListener() {
        [desktopQuery, mobileQuery].forEach((query) => {
            if (!query || viewportListenerModes.has(query)) return;
            if (typeof query.addEventListener === 'function') {
                query.addEventListener('change', handleViewportChange);
                viewportListenerModes.set(query, 'event');
            } else if (typeof query.addListener === 'function') {
                query.addListener(handleViewportChange);
                viewportListenerModes.set(query, 'legacy');
            }
        });
    }

    function removeViewportListener() {
        viewportListenerModes.forEach((mode, query) => {
            if (mode === 'event' && typeof query.removeEventListener === 'function') {
                query.removeEventListener('change', handleViewportChange);
            } else if (mode === 'legacy' && typeof query.removeListener === 'function') {
                query.removeListener(handleViewportChange);
            }
        });
        viewportListenerModes.clear();
    }

    function destroy() {
        if (destroyed) return;
        destroyed = true;
        document.removeEventListener('pointerover', handlePointerOver);
        document.removeEventListener('pointerout', handlePointerOut);
        document.removeEventListener('focusin', handleFocusIn);
        document.removeEventListener('focusout', handleFocusOut);
        document.removeEventListener('click', handleClick);
        document.removeEventListener('keydown', handleKeydown);
        document.removeEventListener('shopify:block:select', handleBlockSelect);
        document.removeEventListener('shopify:block:deselect', handleBlockDeselect);
        document.removeEventListener('shopify:section:load', handleSectionLoad);
        document.removeEventListener('shopify:section:unload', handleSectionUnload);
        removeViewportListener();
        pruneTimers.forEach((timer) => clearTimeout(timer));
        pruneTimers.clear();
        Array.from(items).forEach((item) => releaseItem(item));
        readyMains.forEach((main) => main.removeAttribute(readyAttribute));
        readyMains.clear();
    }

    document.addEventListener('pointerover', handlePointerOver);
    document.addEventListener('pointerout', handlePointerOut);
    document.addEventListener('focusin', handleFocusIn);
    document.addEventListener('focusout', handleFocusOut);
    document.addEventListener('click', handleClick);
    document.addEventListener('keydown', handleKeydown);
    document.addEventListener('shopify:block:select', handleBlockSelect);
    document.addEventListener('shopify:block:deselect', handleBlockDeselect);
    document.addEventListener('shopify:section:load', handleSectionLoad);
    document.addEventListener('shopify:section:unload', handleSectionUnload);
    addViewportListener();
    refresh(root);

    return {
        version: 2,
        refresh,
        unload,
        destroy,
        getDebugState: function() {
            let openItemCount = 0;
            items.forEach((item) => {
                let state = states.get(item);
                if (state && state.open) openItemCount += 1;
            });
            return {
                version: 2,
                itemCount: items.size,
                openItemCount,
                readyMainCount: readyMains.size
            };
        },
        getItemCount: function() {
            return items.size;
        }
    };
}

if (
    window.UpvanitySpotlightInteractionController &&
    typeof window.UpvanitySpotlightInteractionController.destroy === 'function'
) {
    window.UpvanitySpotlightInteractionController.destroy();
}
window.UpvanitySpotlightInteractionController = createUpvanitySpotlightInteractionController();

class ScrollObserver {
    constructor(root = document) {
        this.sections = new Set();
        this.observer = null;
        this.observerGeneration = 0;
        this.fallbackFrame = null;
        this.pruneTimers = new Set();
        this.supportsIntersectionObserver = typeof window.IntersectionObserver === 'function';
        this.desktopQuery = window.matchMedia ? window.matchMedia('(min-width: 769px)') : null;
        this.handleIntersections = this.handleIntersections.bind(this);
        this.handleFallbackScroll = this.handleFallbackScroll.bind(this);
        this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
        this.handleSectionLoad = this.handleSectionLoad.bind(this);
        this.handleSectionUnload = this.handleSectionUnload.bind(this);

        if (this.supportsIntersectionObserver) {
            this.createObserver();
            if (this.desktopQuery) {
                if (typeof this.desktopQuery.addEventListener === 'function') {
                    this.desktopQuery.addEventListener('change', this.handleBreakpointChange);
                } else if (typeof this.desktopQuery.addListener === 'function') {
                    this.desktopQuery.addListener(this.handleBreakpointChange);
                }
            }
        } else {
            window.addEventListener('scroll', this.handleFallbackScroll, { passive: true });
            window.addEventListener('resize', this.handleFallbackScroll, { passive: true });
        }

        document.addEventListener('shopify:section:load', this.handleSectionLoad);
        document.addEventListener('shopify:section:unload', this.handleSectionUnload);
        this.observe(root);
    }

    getSections(root) {
        let sections = [];
        if (!root) return sections;
        if (root.matches && root.matches('section')) sections.push(root);
        if (root.querySelectorAll) {
            Array.from(root.querySelectorAll('section')).forEach((section) => {
                if (sections.indexOf(section) === -1) sections.push(section);
            });
        }
        return sections;
    }

    getRootMargin() {
        let isDesktop = this.desktopQuery ? this.desktopQuery.matches : window.innerWidth > 768;
        return isDesktop ? '400px 0px -400px 0px' : '0px';
    }

    createObserver() {
        this.pruneDisconnectedSections();
        if (this.observer) this.observer.disconnect();
        let observerGeneration = ++this.observerGeneration;
        this.observer = new window.IntersectionObserver((entries) => {
            if (observerGeneration !== this.observerGeneration) return;
            this.handleIntersections(entries);
        }, {
            root: null,
            rootMargin: this.getRootMargin(),
            threshold: 0
        });
        this.sections.forEach((section) => this.observer.observe(section));
    }

    observe(root) {
        this.pruneDisconnectedSections();
        let addedSection = false;
        this.getSections(root).forEach((section) => {
            if (this.sections.has(section)) return;
            this.sections.add(section);
            addedSection = true;
            if (this.observer) this.observer.observe(section);
        });
        if (addedSection) this.scheduleDisconnectedPrunes();
        if (!this.supportsIntersectionObserver) {
            this.handleFallbackScroll();
        }
    }

    unobserve(root) {
        this.getSections(root).forEach((section) => {
            if (!this.sections.has(section)) return;
            clearIconAnimationTimers(section);
            if (this.observer) this.observer.unobserve(section);
            this.sections.delete(section);
        });
    }

    pruneDisconnectedSections() {
        this.sections.forEach((section) => {
            if (section.isConnected !== false) return;
            clearIconAnimationTimers(section);
            if (this.observer) this.observer.unobserve(section);
            this.sections.delete(section);
        });
    }

    scheduleDisconnectedPrunes() {
        this.pruneTimers.forEach((timer) => clearTimeout(timer));
        this.pruneTimers.clear();
        [3000, 12000].forEach((delay) => {
            let timer = setTimeout(() => {
                this.pruneTimers.delete(timer);
                this.pruneDisconnectedSections();
            }, delay);
            this.pruneTimers.add(timer);
        });
    }

    updateSection(section, isIntersecting) {
        if (!section || !section.classList) return;
        if (isIntersecting) {
            if (section.classList.contains('section-in-view')) return;
            section.classList.add('section-in-view');
            if (section.querySelector('[data-icon]')) _iconsAnimations(section);
        } else {
            section.classList.remove('section-in-view');
        }
    }

    handleIntersections(entries) {
        this.pruneDisconnectedSections();
        entries.forEach((entry) => {
            if (!this.sections.has(entry.target) || entry.target.isConnected === false) return;
            this.updateSection(entry.target, entry.isIntersecting);
        });
    }

    handleFallbackScroll() {
        if (this.fallbackFrame !== null) return;
        let requestFrame = window.requestAnimationFrame || function(callback) {
            return setTimeout(callback, 16);
        };
        this.fallbackFrame = requestFrame(() => {
            this.fallbackFrame = null;
            this.pruneDisconnectedSections();
            this.sections.forEach((section) => {
                this.updateSection(section, Boolean(isOnScreen(section)));
            });
        });
    }

    handleBreakpointChange() {
        if (this.supportsIntersectionObserver) this.createObserver();
    }

    handleSectionLoad(event) {
        this.observe(event.target);
    }

    handleSectionUnload(event) {
        this.unobserve(event.target);
    }

    destroy() {
        this.observerGeneration += 1;
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
        if (!this.supportsIntersectionObserver) {
            window.removeEventListener('scroll', this.handleFallbackScroll);
            window.removeEventListener('resize', this.handleFallbackScroll);
            if (this.fallbackFrame !== null) {
                let cancelFrame = window.cancelAnimationFrame || clearTimeout;
                cancelFrame(this.fallbackFrame);
                this.fallbackFrame = null;
            }
        }
        if (this.desktopQuery) {
            if (typeof this.desktopQuery.removeEventListener === 'function') {
                this.desktopQuery.removeEventListener('change', this.handleBreakpointChange);
            } else if (typeof this.desktopQuery.removeListener === 'function') {
                this.desktopQuery.removeListener(this.handleBreakpointChange);
            }
        }
        document.removeEventListener('shopify:section:load', this.handleSectionLoad);
        document.removeEventListener('shopify:section:unload', this.handleSectionUnload);
        this.pruneTimers.forEach((timer) => clearTimeout(timer));
        this.pruneTimers.clear();
        this.sections.forEach((section) => clearIconAnimationTimers(section));
        this.sections.clear();
    }
}

if (
    window.UpvanityScrollObserver &&
    typeof window.UpvanityScrollObserver.destroy === 'function'
) {
    window.UpvanityScrollObserver.destroy();
}
window.UpvanityScrollObserver = new ScrollObserver();

function clearIconAnimationTimers(section) {
    let timers = upvIconAnimationTimers.get(section);
    if (!timers) return;
    timers.forEach((timer) => clearTimeout(timer));
    upvIconAnimationTimers.delete(section);
}

function _iconsAnimations(section) {
    if (!section || !section.querySelector || !section.dataset) return;
    if (section.dataset.upvIconAnimationStarted === 'true') return;
    let icon = section.querySelector('[data-icon]');
    if (!icon) return;
    let iconName = icon.getAttribute('data-icon');
    if (['arrow', 'line-arrow', 'heart', 'star', 'snail', 'sparkle'].indexOf(iconName) === -1) return;

    section.dataset.upvIconAnimationStarted = 'true';
    let timers = [];
    upvIconAnimationTimers.set(section, timers);

    let animatePath = function(selector, index, classes) {
        if (section.isConnected === false) return;
        let path = section.querySelectorAll(selector)[index];
        if (path) path.classList.add.apply(path.classList, classes);
    };
    let scheduleAnimation = function(callback, delay) {
        let timer = setTimeout(callback, delay);
        timers.push(timer);
    };

    if (iconName == 'arrow') {
        animatePath('.arrow-path', 0, ['animated-path', 'delay-2']);
        scheduleAnimation(() => {
            animatePath('.arrow-path', 1, ['animated-path', 'delay-12']);
        }, 1500);
    }
    
    if (iconName == 'line-arrow') {
        animatePath('.line-arrow-path', 0, ['animated-path', 'delay-2']);
        scheduleAnimation(() => {
            animatePath('.line-arrow-path', 1, ['animated-path', 'delay-6']);
        }, 1000);
    }

    if (iconName == 'heart') {
        animatePath('.heart-path', 0, ['animated-path', 'delay-2']);
        scheduleAnimation(() => {
            animatePath('.heart-path', 1, ['animated-path', 'delay-6']);
            animatePath('.heart-path', 2, ['animated-path', 'delay-6']);
        }, 1500);
    }

    if (iconName == 'star') {
        animatePath('.star-path', 0, ['animated-path', 'delay-2']);
    }

    if (iconName == 'snail') {
        animatePath('.snail-path', 0, ['animated-path', 'delay-2']);
        scheduleAnimation(() => {
            animatePath('.snail-path', 1, ['animated-path', 'delay-2']);
        }, 1400);
    }

    if (iconName == 'sparkle') {
        animatePath('.sparkle-path', 0, ['animated-path', 'delay-2']);
        scheduleAnimation(() => {
            if (section.isConnected === false) return;
            section.querySelectorAll('.sparkle-path').forEach((sparkleitem, index) => {
                if (index != 0) {
                    sparkleitem.classList.add('animated-path', 'delay-6');
                }
            });
        }, 1100);
    }
}
